import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fixed } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Radio,
  Checkbox,
  ListItemText,
  FormLabel,
  FormGroup,
  Card,
  Typography,
  TextField,
  OutlinedInput,
  Chip,
  Modal,
  InputAdornment,
  CircularProgress,
  Icon,
  Divider,
  DialogContentText,
  RadioGroup,
  Grid,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Drawer,
  Tabs,
  Tab,
  TableFooter,
  Popper,
} from '@mui/material';
import moment from 'moment';
import {
  Add,
  ArrowBack,
  Article,
  ChevronRight,
  Close,
  ContentCopy,
  CopyAll,
  Delete,
  Edit,
  ExpandMore,
  Group,
  Link,
  Lock,
  Mic,
  Notes,
  Redo,
  Replay,
  Search,
  Send,
  Settings,
  StopCircle,
  Summarize,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import {
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import getAllUsers from 'redux/actions/Common/getAllUsers';
import RichTextEditor from 'components/RichTextEditor';
import * as yup from 'yup';
import { useFormik } from 'formik';
import updatePlaybookForUser from 'redux/actions/Common/updatePlaybookForUser';
import getAllOrganizations from 'redux/actions/Common/getAllOrganizations';
import updateTeamMemberRole from 'redux/actions/Common/updateTeamMemberRole';
import updateOrganization from 'redux/actions/Common/updateOrganization';
import getPlatformConfigs from 'redux/actions/Common/getPlatformConfigs';
import RiskBandsEditor from 'components/RiskBands/RiskBandsEditor';
import OrgScheduleEditor from 'components/OrgSchedule/OrgScheduleEditor';
import {
  toRiskBandPayload,
  toRiskBandRows,
  validateRiskBands,
} from 'utils/riskBands';
import {
  DEFAULT_TIME_ZONE,
  formatWeeklyReportSchedule,
  getTimeZoneLabel,
  normalizeWeeklyReportSchedule,
  toWeeklyReportSchedulePayload,
  validateWeeklyReportSchedule,
} from 'utils/orgSchedule';
import {
  artifactFailedStatuses,
  artifactStatusMap,
  artifactTypesWithoutMedia,
  capitalizeText,
  validateEmail,
} from 'utils';
import sendTeamInvite from 'redux/actions/Common/sendTeamInvite';
import getPlans from 'redux/actions/Common/getPlans';
import updatePlanForOrganization from 'redux/actions/Common/updatePlanForOrganization';
import refreshUsage from 'redux/actions/Common/refreshUsage';
import refreshUsageForOrg from 'redux/actions/Common/refreshUsageForOrg';
import updatePlanForOrgUser from 'redux/actions/Common/updatePlanForOrgUser';
import AutoCompleteMUI from 'components/@2024/AutoCompleteMUI';
import updatePlanTrialEndsOn from 'redux/actions/Common/updatePlanTrialEndsOn';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import getDefaultPrompt from 'redux/actions/Common/getDefaultPrompt';
import getContentScoringConfigTemplate from 'redux/actions/Common/getContentScoringConfigTemplate';
import deepEqual from 'deep-equal';
import getBotsByUserId from 'redux/actions/Common/getBotsByUserId';
import addCreditsForOrg from 'redux/actions/Common/addCreditsForOrg';
import exportDiscoveryTree from 'redux/actions/Common/exportDiscoveryTree';
import getDiscoveryTreeById from 'redux/actions/Common/getDiscoveryTreeById';
import QuestionFrameworkTree from 'components/@2024/QuestionFrameworkTree';
import getDealsForV2CustomerNew from 'redux/actions/Common/getDealsForV2CustomerNew';
import getArtifactsForDeal from 'redux/actions/Common/getArtifactsForDeal';
import getArtifactsForDealNew from 'redux/actions/Common/getArtifactsForDealNew';
import parse from 'html-react-parser';
import NextBestActions from 'components/NextBestActions';
import getArtifactRisks from 'redux/actions/Common/getArtifactRisks';
import ArtifactRisksSelectionList from 'components/ArtifactRisksSelectionList';
import regenerateDiscoveryTree from 'redux/actions/Common/regenerateDiscoveryTree';
import processDealArtifact from 'redux/actions/Common/processDealArtifact';
import scheduleAccountForDeletion from 'redux/actions/Common/scheduleAccountForDeletion';
import deleteAccountPermanently from 'redux/actions/Common/deleteAccountPermanently';
import resetUnlinkedItems from 'redux/actions/Common/resetUnlinkedItems';
import updateOrgAutoSync from 'redux/actions/Common/updateOrgAutoSync';
import resetDealHighlights from 'redux/actions/Common/resetDealHighlights';
import reTriggerDealHighlights from 'redux/actions/Common/reTriggerDealHighlights';
import RagQueries from '../RagQueries';
import processRagQueryBulk from 'redux/actions/Common/processRagQueryBulk';
import RagTestingView from './components/RagTestingView';
import McpToolsConfig from './components/McpToolsConfig';
import { aiModels, modelMapping } from 'data';
import testLllPrompt from 'redux/actions/Common/testLllPrompt';
import axios from 'utils/axios';
import actionCodeBaseUrl from 'config/actionCodeBaseUrl';
import { v4 as uuidv4 } from 'uuid';
import impersonateUser from 'redux/actions/Common/impersonateUser';
import terminateImpersonateSession from 'redux/actions/Common/terminateImpersonateSession';
import getWeeklyDealSummaries from 'redux/actions/Common/getWeeklyDealSummaries';
import triggerWeeklyDealSummary from 'redux/actions/Common/triggerWeeklyDealSummary';
import triggerRecentWeeklyDealSummaries from 'redux/actions/Common/triggerRecentWeeklyDealSummaries';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const validationSchemaPlaybook = yup.object().nullable();
const validationSchemaSearch = yup.object().nullable();

const OrganizationsV2 = () => {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const { version } = useParams();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isXs = useMediaQuery(theme.breakpoints.only('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: true,
  });
  const {
    organizations,
    fetchingPagination,
    emptyList,
    fetching,
    lastTime,
  } = useSelector((state) => state.allOrganizations);

  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [currentTab, setCurrentTab] = useState('onboardingData');
  const [currentOrgMenu, setCurrentOrgMenu] = useState('setup');
  const [fetchingDeals, setFetchingDeals] = useState(false);
  const [deals, setDeals] = useState([]);
  const [exportingTree, setExportingTree] = useState(false);
  const [promptOrder, setPromptOrder] = useState(null);
  const [selectedTree, setSelectedTree] = useState(null);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [promptType, setPromptType] = useState(
    'add_question_category_for_risk',
  );
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [fetchingArtifacts, setFetchingArtifacts] = useState(false);
  const [artifacts, setArtifacts] = useState([]);

  const [showArtifactContent, setShowArtifactContent] = useState(null);
  const [currentDealTab, setCurrentDealTab] = useState('details');
  const [selectedArtifact, setSelectedArtifact] = useState(null);
  const [currentArtifactTab, setCurrentArtifactTab] = useState(
    'artifactContent',
  );
  const [artifactPrompts, setArtifactPrompts] = useState([]);
  const [selectedArtifactPrompt, setSelectedArtifactPrompt] = useState('');

  const [viewType, setViewType] = useState('deals');

  const [selectedPlan, setSelectedPlan] = useState('');

  const [showExportTreeDialog, setShowExportTreeDialog] = useState(false);
  const [
    showConfirmTreeRegeneration,
    setShowConfirmTreeRegeneration,
  ] = useState(false);
  const [triggeringTreeRegeneration, setTriggeringTreeRegeneration] = useState(
    false,
  );

  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState('-');

  const [anchorElRisks, setAnchorElRisks] = useState(null);
  const [recentArtifactWithNBA, setRecentArtifactWithNBA] = useState(null);

  const [currentOnboadingDataTab, setCurrentOnboardingDataTab] = useState(
    'valueprop',
  );
  const [stackHolderSearchLimit, setStackHolderSearchLimit] = useState(0);

  const [
    excludedCrmStageNamesForSync,
    setExcludedCrmStageNamesForSync,
  ] = useState([]);

  const [adminCanSeeAllDeals, setAdminCanSeeAllDeals] = useState(false);
  const [gmailAutoSync, setGmailAutoSync] = useState(false);
  const [syncCrmEmailEnabled, setSyncCrmEmailEnabled] = useState(false);
  const [autoTrackNewCrmDeals, setAutoTrackNewCrmDeals] = useState(false);
  const [expandedPromptSections, setExpandedPromptSections] = useState([]);
  const [
    experimentalFeaturesSettingPreferenceEnabled,
    setExperimentalFeaturesSettingPreferenceEnabled,
  ] = useState(false);
  const [syncLinkedInPosts, setSyncLinkedInPosts] = useState(false);
  const [
    scheduledAutoSyncLinkedInPosts,
    setScheduledAutoSyncLinkedInPosts,
  ] = useState(false);
  const [generateWeeklyDealSummary, setGenerateWeeklyDealSummary] = useState(
    false,
  );

  // The org's risk score bands override, as editor rows. An org with none of
  // its own is classified by the admin platform default, so that is what the
  // editor opens on -- editing then saving is what turns the inherited default
  // into an override of the org's own.
  const [riskBandRows, setRiskBandRows] = useState(() => toRiskBandRows(null));
  const [platformRiskBands, setPlatformRiskBands] = useState(null);
  const [updatingRiskBands, setUpdatingRiskBands] = useState(false);
  // Whether what's on screen is inherited rather than the org's own, so the
  // tab can say which of the two the admin is looking at.
  const orgHasOwnRiskBands = !!organizations?.find(
    (org) => org?.id === selectedOrganization,
  )?.riskBands?.length;

  // The org's timezone and weekly report day/time, as one editable draft. The
  // API resolves and persists a value for every org on first read, so the org
  // record normally carries both -- the platform defaults are only what a
  // never-read org falls back to here.
  const [scheduleDraft, setScheduleDraft] = useState(() => ({
    timeZone: DEFAULT_TIME_ZONE,
    ...normalizeWeeklyReportSchedule(null),
  }));
  const [updatingSchedule, setUpdatingSchedule] = useState(false);

  const [emailIntegrationType, setEmailIntegrationType] = useState('default');

  const [larry, setLarry] = useState(false);
  const [larryAiModel, setLarryAiModel] = useState('');

  const [weeklySummaryDeal, setWeeklySummaryDeal] = useState(null);
  const [weeklySummaries, setWeeklySummaries] = useState([]);
  const [loadingWeeklySummaries, setLoadingWeeklySummaries] = useState(false);
  const [weeklySummaryWindow, setWeeklySummaryWindow] = useState('LAST_WEEK');
  const [triggeringWeeklySummary, setTriggeringWeeklySummary] = useState(false);

  const [triggerRecentOpen, setTriggerRecentOpen] = useState(false);
  const [triggeringRecent, setTriggeringRecent] = useState(false);
  const [triggerRecentResult, setTriggerRecentResult] = useState(null);
  const [triggerRecentError, setTriggerRecentError] = useState(null);

  const [processingArtifact, setProcessingArtifact] = useState(false);

  const [selectedMember, setSelectedMember] = useState(null);

  const initialValuesSearch = {
    searchKeyword: '',
  };

  const [showConfirmDisableDialog, setShowConfirmDisableDialog] = useState('');
  const [disablingOrDeletingAccount, setDisablingOrDeletingAccount] = useState(
    false,
  );
  const [reason, setReason] = useState('');

  const [resettingUnlinkedItems, setResettingUnlinkedItems] = useState(false);

  const [resettingDealHighlights, setResettingDealDealHighlights] = useState(
    false,
  );
  const [reTriggeringDealHighlights, setReTriggeringDealHighlights] = useState(
    false,
  );

  const [gmailOAuthFlowEnabled, setGmailOAuthFlowEnabled] = useState(false);

  const [enableOauthMcpIntegration, setEnableOauthMcpIntegration] = useState(
    false,
  );

  const [indexProvider, setIndexProvider] = useState('pinecone');
  const [selectedNamespaces, setSelectedNamespaces] = useState([]);
  const [query, setQuery] = useState('');
  const [size, setSize] = useState(3);
  const [generatingPrompt, setGeneratingPrompt] = useState(false);
  const [prompts, setPrompts] = useState([]);
  const [models, setModels] = useState(aiModels);
  const [model, setModel] = useState(aiModels?.[1]);
  const [prompt, setPrompt] = useState('');
  const [generatingPromptResponse, setGeneratingPromptResponse] = useState(
    false,
  );
  const [promptResponse, setPromptResponse] = useState('');

  const handleListScroll = (e, paginate) => {
    // console.log(
    //   e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight,
    // );
    if (
      (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight &&
        // viewType === 'list' &&
        !fetching &&
        !fetchingPagination &&
        organizations &&
        organizations.length % 9 === 0 &&
        emptyList === false) ||
      paginate
    ) {
      dispatch(
        getAllOrganizations(
          formikSearch?.values?.searchKeyword
            ? [formikSearch?.values?.searchKeyword]
            : [],
          true,
          'n_org',
          9,
          lastTime,
          version === 'v1' ? 'all' : 'v2',
          () => {},
        ),
      );
    }
  };

  const onSearch = (values) => {
    console.log(values);
    if (values?.searchKeyword?.trim()) {
      dispatch(
        getAllOrganizations(
          [values?.searchKeyword],
          true,
          'n_org',
          9,
          null,
          version === 'v1' ? 'all' : 'v2',
          () => {},
        ),
      );
    } else {
      dispatch(
        getAllOrganizations(
          [],
          true,
          'n_org',
          9,
          null,
          version === 'v1' ? 'all' : 'v2',
          () => {},
        ),
      );
    }
  };

  const formikSearch = useFormik({
    initialValues: initialValuesSearch,
    validationSchema: validationSchemaSearch,
    onSubmit: onSearch,
  });

  useEffect(() => {
    if (organizations?.length > 0) {
      setSelectedOrganization(organizations?.[0]?.id);
    }
  }, [organizations]);

  useEffect(() => {
    if (selectedOrganization) {
      setCurrentOrgMenu('deals');
      setSelectedMember(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.customFields?.users?.[0]?.id,
      );
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (selectedOrganization) {
      setSelectedPlan(
        organizations?.find((org) => org?.id === selectedOrganization)?.plan
          ?.id,
      );
      setStackHolderSearchLimit(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.stackHolderSearchLimit || 20,
      );
    }
  }, [selectedOrganization]);

  // The platform default is what an org without its own bands is classified
  // by, so the editor needs it to open on the values actually in force. The
  // GET always answers with a non-empty array -- the hardcoded fallback is
  // decorated in at read time -- so there is no empty case to handle.
  useEffect(() => {
    dispatch(
      getPlatformConfigs((data) => {
        setPlatformRiskBands(data?.riskBands || null);
      }),
    );
  }, []);

  // Seeded from the org's own bands, falling back to the inherited platform
  // default. Kept apart from the other per-org state so it can re-run when the
  // platform config lands after an org was already selected; it settles on the
  // one fetch above, so this doesn't sit clobbering an edit in progress.
  useEffect(() => {
    if (!selectedOrganization) return;
    const orgBands = organizations?.find(
      (org) => org?.id === selectedOrganization,
    )?.riskBands;
    setRiskBandRows(
      toRiskBandRows(orgBands?.length ? orgBands : platformRiskBands),
    );
  }, [selectedOrganization, platformRiskBands]);

  // Seeded from the selected org whenever it changes, so switching orgs never
  // leaves the previous org's schedule on screen.
  useEffect(() => {
    if (!selectedOrganization) return;
    const org = organizations?.find((o) => o?.id === selectedOrganization);
    setScheduleDraft({
      timeZone: org?.timeZone || DEFAULT_TIME_ZONE,
      ...normalizeWeeklyReportSchedule(org?.weeklyReportGenerationTime),
    });
  }, [selectedOrganization]);

  useEffect(() => {
    if (version === 'v1') {
      setCurrentTab('onboardingData');
    } else {
      setCurrentTab('onboardingData');
    }
  }, [version]);

  useEffect(() => {
    if (selectedOrganization) {
      console.log(
        organizations?.find((org) => org?.id === selectedOrganization),
      );
      setSelectedTree(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.customFields?.discoveryTree?.risks || [],
      );
      setPromptOrder(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.customFields?.discoveryTree?.rootTopics?.length ===
          Object.keys(
            organizations?.find((org) => org?.id === selectedOrganization)
              ?.customFields?.discoveryTree?.metadata || {},
          ).length
          ? organizations?.find((org) => org?.id === selectedOrganization)
              ?.customFields?.discoveryTree?.rootTopics || []
          : Object.keys(
              organizations?.find((org) => org?.id === selectedOrganization)
                ?.customFields?.discoveryTree?.metadata || {},
            ) || [],
      );
      setSelectedMetadata(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.customFields?.discoveryTree?.metadata || {},
      );
      setStages(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.qaiDealStages || [],
      );
      setExperimentalFeaturesSettingPreferenceEnabled(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.experimentalFeaturesSettingPreferenceEnabled || false,
      );
      setAutoTrackNewCrmDeals(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.autoTrackNewCrmDeals || false,
      );
      setGmailOAuthFlowEnabled(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.gmailOAuthFlowEnabled || false,
      );
      setEnableOauthMcpIntegration(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.enableOauthMcpIntegration || false,
      );
      setAdminCanSeeAllDeals(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.adminCanSeeAllDeals || false,
      );
      setSyncCrmEmailEnabled(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.syncCrmEmailEnabled || false,
      );
      setGmailAutoSync(
        organizations
          ?.find((org) => org?.id === selectedOrganization)
          ?.customFields?.users?.find(
            (user) => !user?.integrations?.gmailAutoSync,
          )
          ? false
          : true,
      );
      setSyncLinkedInPosts(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.syncLinkedInPosts || false,
      );
      setScheduledAutoSyncLinkedInPosts(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.scheduledAutoSyncLinkedInPosts || false,
      );
      setGenerateWeeklyDealSummary(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.generateWeeklyDealSummary || false,
      );
      setEmailIntegrationType(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.emailOrCalendarServiceProvider || 'default',
      );
      setLarry(
        organizations?.find((org) => org?.id === selectedOrganization)?.larry ||
          false,
      );
      setLarryAiModel(
        organizations?.find((org) => org?.id === selectedOrganization)
          ?.larryAiModel || '',
      );
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (currentOrgMenu === 'deals' && selectedMember) {
      dispatch(
        getDealsForV2CustomerNew(
          selectedOrganization,
          { ownerId: selectedMember },
          (data) => {
            console.log(data);
            setDeals(data || []);
          },
        ),
      );
    }
  }, [selectedOrganization, currentOrgMenu, selectedMember]);

  useEffect(() => {
    if (currentOrgMenu === 'activities') {
      setViewType('artifacts');
    } else {
      setViewType('deals');
    }
  }, [currentOrgMenu]);

  useEffect(() => {
    if (
      selectedOrganization &&
      ((viewType === 'dealdetails' &&
        currentDealTab === 'artifacts' &&
        selectedDeal) ||
        currentOrgMenu === 'activities')
    ) {
      setFetchingArtifacts(true);
      dispatch(
        getArtifactsForDealNew(
          selectedOrganization,
          currentOrgMenu === 'activities' ? null : selectedDeal?.id,
          (data) => {
            setFetchingArtifacts(false);
            setArtifacts(data);
          },
        ),
      );
    }
  }, [
    selectedOrganization,
    viewType,
    selectedDeal,
    currentDealTab,
    currentOrgMenu,
  ]);

  useEffect(() => {
    if (selectedArtifact) {
      setArtifactPrompts(
        selectedArtifact?.customField?.metadataListOrder || [],
      );
    }
  }, [selectedArtifact]);

  useEffect(() => {
    if (artifacts && artifacts?.length > 0 && currentDealTab === 'details') {
      setRecentArtifactWithNBA(
        artifacts
          ?.filter(
            (artifact) =>
              artifact?.postProcessingStatus === 'interaction_nba_completed',
          )
          ?.sort((a, b) => b?.interactionTime - a?.interactionTime)?.[0] ||
          null,
      );
    } else {
      setRecentArtifactWithNBA(null);
    }
  }, [artifacts, currentDealTab]);

  useEffect(() => {
    if (
      selectedArtifact?.selectedRisks &&
      ((selectedArtifact?.nextBestActionsMap &&
        Object.keys(selectedArtifact?.nextBestActionsMap || {})?.length ===
          0) ||
        !selectedArtifact?.nextBestActionsMap)
    ) {
      dispatch(
        getArtifactRisks(selectedOrganization, selectedArtifact?.id, (data) => {
          if (data) {
            setSelectedArtifact((prev) => {
              return {
                ...prev,
                nextBestActionsMap: data?.nextBestActions,
              };
            });
          }
        }),
      );
    }
  }, [selectedArtifact]);

  useEffect(() => {
    if (
      recentArtifactWithNBA?.selectedRisks &&
      ((recentArtifactWithNBA?.nextBestActionsMap &&
        Object.keys(recentArtifactWithNBA?.nextBestActionsMap || {})?.length ===
          0) ||
        !recentArtifactWithNBA?.nextBestActionsMap)
    ) {
      dispatch(
        getArtifactRisks(
          selectedOrganization,
          recentArtifactWithNBA?.id,
          (data) => {
            if (data) {
              setRecentArtifactWithNBA((prev) => {
                return {
                  ...prev,
                  nextBestActionsMap: data?.nextBestActions,
                };
              });
            }
          },
        ),
      );
    }
  }, [recentArtifactWithNBA]);

  useEffect(() => {
    if (currentOrgMenu === 'promptTesting') {
      setSelectedNamespaces([
        ...Object.keys(
          organizations?.find((org) => org?.id === selectedOrganization)
            ?.ragNamespaceMapForFE || {},
        ),
      ]);
    }
  }, [currentOrgMenu]);

  useEffect(() => {
    dispatch(
      getAllOrganizations(
        [],
        true,
        'n_org',
        9,
        null,
        version === 'v1' ? 'all' : 'v2',
        () => {},
      ),
    );
  }, []);

  // console.log(contentScoringConfig);
  // console.log(
  //   deepEqual(contentScoringConfig.inbound, contentScoringConfig.outbound),
  // );
  // console.log(contentScoringConfig);
  // console.log(contentScoreConfigText);
  // console.log(selectedOrganization);
  // console.log(excludedCrmStageNamesForSync);
  // console.log(selectedArtifact);

  const handleViewAs = (userId) => {
    dispatch(
      impersonateUser(
        userId,
        (token) => {
          if (token && typeof token === 'string') {
            window.open(
              `${actionCodeBaseUrl}?impersonate_token=${token}&view_as=true`,
              '_blank',
            );
          } else if (token?.token) {
            window.open(
              `${actionCodeBaseUrl}?impersonate_token=${token?.token}&view_as=true`,
              '_blank',
            );
          } else {
            alert('Failed to get impersonation token');
          }
        },
        () => {
          alert('Error generating impersonation token');
        },
      ),
    );
  };

  const terminateViewAsSessions = (userId) => {
    dispatch(
      terminateImpersonateSession(
        userId,
        () => {
          alert('View-as session terminated successfully');
        },
        () => {
          alert('Error terminating view-as session');
        },
      ),
    );
  };

  // console.log(prompts);

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{
          xs: 'calc(100vh - 60px)',
          sm: 'calc(100vh - 70px)',
          md: 'calc(100vh - 80px)',
        }}
        sx={{
          overflow: 'hidden',
        }}
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={'relative'}
        gap={1}
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          sx={{ position: 'relative' }}
        >
          <Box
            sx={{
              position: 'absolute',
              background: '#fff',
              p: 2,
              zIndex: 12,
            }}
          >
            <form onSubmit={formikSearch.handleSubmit}>
              <TextField
                label="Search"
                variant="outlined"
                name={'searchKeyword'}
                size="small"
                // fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                value={formikSearch.values.searchKeyword}
                onChange={(e) => {
                  formikSearch.setFieldValue('searchKeyword', e.target.value);
                }}
              />
            </form>
          </Box>
          <Box
            flex={{ xs: 'auto', sm: 'auto', md: 1 }}
            display={'flex'}
            flexDirection={{ xs: 'row', sm: 'row', md: 'column' }}
            alignItems={{ xs: 'start', sm: 'start', md: 'start' }}
            gap={2}
            sx={
              isXs || isSm
                ? {
                    borderBottom: '1px solid #d3d3d3',
                    padding: 1,
                    overflowX: 'scroll',
                    '&::-webkit-scrollbar': {
                      width: '5px',
                      height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: 2,
                      // outline: '1px solid slategrey',
                    },
                  }
                : {
                    borderRight: '1px solid #d3d3d3',
                    minHeight: 'calc(100vh - 80px)',
                    maxHeight: 'calc(100vh - 80px)',
                    overflowY: 'scroll',
                    '&::-webkit-scrollbar': {
                      width: '5px',
                      height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: 2,
                      // outline: '1px solid slategrey',
                    },
                    padding: 2,
                    paddingTop: 10,
                  }
            }
          >
            {fetching ? (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: 10,
                  textAlign: 'center',
                }}
              >
                <CircularProgress size={16} />
                <Typography>Loading organizations ...</Typography>
              </Box>
            ) : (
              <>
                {organizations?.map((org) => (
                  <Box
                    // flex={1}
                    key={org?.id}
                    sx={{
                      // flex: 1,
                      // width: 1,
                      padding: '4px 8px',
                      // border: '1px solid #d3d3d3',
                      borderRadius: 2,
                      cursor: 'pointer',
                      // background:
                      //   selectedOrganization === org?.id
                      //     ? theme.palette.primary.main
                      //     : 'default',
                      whiteSpace: 'nowrap',
                    }}
                    onClick={() => setSelectedOrganization(org?.id)}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="body1"
                        color={'text.primary'}
                        fontWeight={'bold'}
                        sx={{
                          color:
                            selectedOrganization === org?.id
                              ? theme.palette.primary.main
                              : 'text.primary',
                        }}
                      >
                        {org?.organizationName}
                      </Typography>
                      {org?.scheduledDeleteRequest && (
                        <Chip size="small" label="Disabled" color="default" />
                      )}
                    </Box>
                    <Typography variant="subtitle2">
                      {
                        org?.customFields?.users?.find(
                          (user) => user?.id === org?.adminId,
                        )?.email
                      }
                    </Typography>
                    {selectedOrganization === org?.id ? (
                      <Box
                        marginLeft={1}
                        display={'flex'}
                        flexDirection={'column'}
                      >
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              currentOrgMenu === 'setup'
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('setup')}
                        >
                          - Setup
                        </Typography>
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              currentOrgMenu === 'promptTesting'
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('promptTesting')}
                        >
                          - Prompt Testing
                        </Typography>
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              currentOrgMenu === 'rag'
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('rag')}
                        >
                          - RAG Queries
                        </Typography>
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              currentOrgMenu === 'mcpTools'
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('mcpTools')}
                        >
                          - MCP Tools Configurations
                        </Typography>
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              currentOrgMenu === 'activities'
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('activities')}
                        >
                          - Activities
                        </Typography>
                        <Typography
                          // variant="subtitle2"
                          color={'text.secondary'}
                          // fontWeight={'bold'}
                          sx={{
                            color:
                              selectedOrganization === org?.id &&
                              (currentOrgMenu === 'users' ||
                                currentOrgMenu === 'deals')
                                ? theme.palette.primary.main
                                : 'text.secondary',
                          }}
                          onClick={() => setCurrentOrgMenu('users')}
                        >
                          - Users
                        </Typography>
                      </Box>
                    ) : null}
                    {(currentOrgMenu === 'users' ||
                      currentOrgMenu === 'deals') &&
                      selectedOrganization === org?.id &&
                      organizations
                        ?.find((org) => org?.id === selectedOrganization)
                        ?.customFields?.users?.map((user) => (
                          <>
                            <Typography
                              variant="subtitle2"
                              color={'text.secondary'}
                              // fontWeight={'bold'}
                              sx={{
                                color:
                                  selectedOrganization === org?.id &&
                                  selectedMember === user?.id
                                    ? theme.palette.primary.main
                                    : 'text.secondary',
                                marginLeft: '20px',
                              }}
                              onClick={() => setSelectedMember(user?.id)}
                            >
                              - {user?.email}
                            </Typography>
                            {selectedMember === user?.id && (
                              <Typography
                                // variant="subtitle2"
                                color={'text.secondary'}
                                // fontWeight={'bold'}
                                sx={{
                                  color:
                                    selectedOrganization === org?.id &&
                                    currentOrgMenu === 'deals'
                                      ? theme.palette.primary.main
                                      : 'text.secondary',
                                  marginLeft: '35px',
                                }}
                                onClick={() => setCurrentOrgMenu('deals')}
                              >
                                - Deals
                              </Typography>
                            )}
                          </>
                        ))}
                  </Box>
                ))}
              </>
            )}
            {fetchingPagination ? (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: 10,
                  textAlign: 'center',
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  // type="submit"
                  color="primary"
                  disabled
                >
                  Loading more organizations ...
                  <CircularProgress size={20} />
                </Button>
              </Box>
            ) : emptyList === false && organizations?.length >= 9 ? (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: 10,
                  textAlign: 'center',
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={(e) => handleListScroll(e, true)}
                  sx={{
                    whiteSpace: 'nowrap',
                    minWidth: 100,
                  }}
                >
                  Load More
                </Button>
              </Box>
            ) : null}
          </Box>
          <Box
            flex={{ xs: 'auto', sm: 'auto', md: 4 }}
            sx={{
              position: 'relative',
            }}
          >
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={2}
              // justifyContent={'space-between'}
              p={2}
              sx={{
                minHeight:
                  isXs || isSm ? 'calc(100vh - 130px)' : 'calc(100vh - 80px)',
                maxHeight:
                  isXs || isSm ? 'calc(100vh - 130px)' : 'calc(100vh - 80px)',
                overflowY: 'scroll',
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 2,
                  // outline: '1px solid slategrey',
                },
                paddingBottom: isXs || isSm ? 0 : 0,
              }}
            >
              {currentOrgMenu === 'setup' ? (
                <>
                  {/* {organizations &&
                  organizations.length > 0 &&
                  selectedOrganization &&
                  !(
                    organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.customFields?.discoveryTree?.status === 'completed'
                  ) ? (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 300,
                        gap: 2,
                      }}
                    >
                      <CircularProgress size={20} />
                      <Typography>Tree generation is in progress</Typography>
                    </Box>
                  ) : ( */}
                  <>
                    {selectedOrganization ? (
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        gap={1}
                        justifyContent={'space-between'}
                        border={'1px solid #d3d3d3'}
                      >
                        <Tabs
                          value={currentTab}
                          onChange={(e, newValue) => {
                            setCurrentTab(newValue);
                          }}
                          aria-label="Tabs"
                          orientation={'horizontal'}
                          // indicatorColor={theme.palette.background.default}
                          variant="scrollable"
                          // scrollButtons={!isMd}
                          allowScrollButtonsMobile
                        >
                          <Tab
                            value={'onboardingData'}
                            label={
                              <Typography variant="caption" fontWeight={'bold'}>
                                Onboarding Data
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'framework'}
                            label={
                              <Typography variant="caption" fontWeight={'bold'}>
                                Question Framework
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'prompts'}
                            label={
                              <Typography variant="caption" fontWeight={'bold'}>
                                Prompts
                              </Typography>
                            }
                            id={`simple-tab-${5}`}
                            aria-controls={`simple-tabpanel-${5}`}
                            sx={{}}
                          />
                        </Tabs>
                        {currentTab === 'framework' && selectedOrganization ? (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                            }}
                          >
                            <Button
                              color="primary"
                              variant="contained"
                              // startIcon={
                              //   exportingTree ? (
                              //     <CircularProgress size={20} />
                              //   ) : null
                              // }
                              // disabled={exportingTree}
                              onClick={() => {
                                setShowConfirmTreeRegeneration(true);
                              }}
                              sx={{
                                padding: '4px 8px',
                              }}
                            >
                              Trigger tree regeneration
                            </Button>
                            <Button
                              color="primary"
                              variant="contained"
                              // startIcon={
                              //   exportingTree ? (
                              //     <CircularProgress size={20} />
                              //   ) : null
                              // }
                              // disabled={exportingTree}
                              onClick={() => {
                                setShowExportTreeDialog(true);
                              }}
                              sx={{
                                padding: '4px 8px',
                                marginRight: 2,
                              }}
                            >
                              Export Tree
                            </Button>
                          </Box>
                        ) : null}
                      </Box>
                    ) : null}
                    {selectedOrganization ? (
                      currentTab === 'prompts' ? (
                        <Box display={'flex'} flexDirection={'column'} gap={2}>
                          {promptOrder && promptOrder?.length > 0 ? (
                            <Box
                              display={'flex'}
                              flexDirection={'column'}
                              gap={2}
                            >
                              <FormControl size="small" sx={{ minWidth: 150 }}>
                                <InputLabel id="promptType">
                                  Prompt Type
                                </InputLabel>
                                <Select
                                  variant="outlined"
                                  size="small"
                                  labelId={'promptType'}
                                  label={'Words Limit'}
                                  id={'promptType'}
                                  name={'promptType'}
                                  MenuProps={{ disableScrollLock: true }}
                                  onChange={(e) => {
                                    setPromptType(e.target.value);
                                  }}
                                  value={promptType}
                                >
                                  {promptOrder.map((key) => (
                                    <MenuItem key={key} value={key}>
                                      <Typography variant="subtitle2">
                                        {capitalizeText(
                                          key?.split('_').join(' '),
                                        )}
                                      </Typography>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  padding: 2,
                                  gap: 2,
                                  border: '1px solid #d3d3d3',

                                  minHeight: 'calc(100vh - 240px)',
                                  maxHeight: 'calc(100vh - 240px)',
                                  overflowY: 'scroll',
                                  '&::-webkit-scrollbar': {
                                    width: '5px',
                                    height: '5px',
                                  },
                                  '&::-webkit-scrollbar-track': {
                                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                    webkitBoxShadow:
                                      'inset 0 0 6px rgba(0,0,0,0.00)',
                                  },
                                  '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: theme.palette.primary.main,
                                    borderRadius: 2,
                                    // outline: '1px solid slategrey',
                                  },
                                }}
                              >
                                {selectedMetadata?.[promptType]?.messages?.map(
                                  (msg, index) => (
                                    <>
                                      {msg ? (
                                        <Box
                                          key={msg?.content}
                                          sx={{
                                            borderTopLeftRadius:
                                              msg?.role === 'user' ? 16 : 0,
                                            borderTopRightRadius:
                                              msg?.role === 'user' ? 0 : 16,
                                            borderBottomLeftRadius:
                                              msg?.role === 'user' ? 8 : 16,
                                            borderBottomRightRadius:
                                              msg?.role === 'user' ? 16 : 8,
                                            minWidth: '80%',
                                            maxWidth: '80%',
                                            alignSelf:
                                              msg?.role === 'user'
                                                ? 'end'
                                                : 'start',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // gap: 1,
                                            boxShadow: theme.shadows[8],
                                            background:
                                              msg?.role === 'user'
                                                ? theme.palette.primary.main
                                                : '#fff',
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            alignItems={'center'}
                                            justifyContent={'space-between'}
                                            sx={{
                                              padding: '8px 16px',
                                              gap: 4,
                                              cursor: 'pointer',
                                              width: 1,
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                expandedPromptSections?.includes(
                                                  index,
                                                )
                                              ) {
                                                setExpandedPromptSections(
                                                  (prev) =>
                                                    prev?.filter(
                                                      (id) => id !== index,
                                                    ),
                                                );
                                              } else {
                                                setExpandedPromptSections(
                                                  (prev) => [...prev, index],
                                                );
                                              }
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                              }}
                                            >
                                              {expandedPromptSections?.includes(
                                                index,
                                              ) ? (
                                                <ExpandMore
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              ) : (
                                                <ChevronRight
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              )}
                                              {msg?.role === 'user' ? (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#f1f1f1'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                >
                                                  {'Prompt'}
                                                </Typography>
                                              ) : (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#f1f1f1'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                >
                                                  {'GPT'}
                                                </Typography>
                                              )}
                                            </Box>
                                            <Tooltip
                                              arrow
                                              placement="top"
                                              title="Copy"
                                            >
                                              <ContentCopy
                                                sx={{
                                                  color:
                                                    msg?.role === 'user'
                                                      ? '#fff'
                                                      : theme.palette.text
                                                          .secondary,
                                                  fontSize: 18,
                                                  cursor: 'pointer',
                                                }}
                                                onClick={async (e) => {
                                                  e.stopPropagation();
                                                  try {
                                                    await navigator.clipboard.writeText(
                                                      msg?.content,
                                                    );
                                                  } catch (err) {
                                                    console.error(
                                                      'Failed to copy: ',
                                                      err,
                                                    );
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          </Box>
                                          {expandedPromptSections?.includes(
                                            index,
                                          ) ? (
                                            <Typography
                                              sx={{
                                                whiteSpace: 'pre-wrap',
                                                color:
                                                  msg?.role === 'user'
                                                    ? '#fff'
                                                    : theme.palette.text
                                                        .primary,
                                                padding: '0px 16px 16px 16px',
                                              }}
                                            >
                                              {msg?.content}
                                            </Typography>
                                          ) : null}
                                        </Box>
                                      ) : null}
                                    </>
                                  ),
                                )}
                              </Box>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: 300,
                                gap: 2,
                              }}
                            >
                              <Typography>No meta data found</Typography>
                            </Box>
                          )}
                        </Box>
                      ) : currentTab === 'framework' ? (
                        <Box
                          display={'flex'}
                          flexDirection={'column'}
                          gap={2}
                          position={'relative'}
                        >
                          {!(
                            organizations?.find(
                              (org) => org?.id === selectedOrganization,
                            )?.customFields?.discoveryTree?.status ===
                            'completed'
                          ) ? (
                            <Box
                              sx={{
                                display: 'flex',
                                // flexDirection: 'column',
                                // alignItems: 'center',
                                // justifyContent: 'center',
                                // minHeight: 300,
                                gap: 2,
                              }}
                            >
                              <CircularProgress size={20} />
                              <Typography>
                                Tree generation is in progress
                              </Typography>
                            </Box>
                          ) : null}
                          {selectedTree && selectedTree.length > 0 ? (
                            <QuestionFrameworkTree data={selectedTree} />
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: 300,
                                gap: 2,
                              }}
                            >
                              <Typography>No question tree found</Typography>
                            </Box>
                          )}
                        </Box>
                      ) : currentTab === 'onboardingData' ? (
                        <Box>
                          <Tabs
                            value={currentOnboadingDataTab}
                            onChange={(e, newValue) =>
                              setCurrentOnboardingDataTab(newValue)
                            }
                            aria-label="Current onboarding data Tabs"
                            orientation={'horizontal'}
                            // indicatorColor={theme.palette.background.default}
                            variant="scrollable"
                            // scrollButtons={!isMd}
                            allowScrollButtonsMobile
                            sx={{
                              border: '1px solid #d3d3d3',
                            }}
                          >
                            <Tab
                              value={'valueprop'}
                              label={
                                <Typography variant="body1">
                                  Value Prop
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'sellingstyle'}
                              label={
                                <Typography variant="body1">
                                  Selling Style
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'stackHolderSearchLimit'}
                              label={
                                <Typography variant="body1">
                                  Stakeholder Search Limit
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'otherSettings'}
                              label={
                                <Typography variant="body1">
                                  Other Settings
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'riskBands'}
                              label={
                                <Typography variant="body1">
                                  Deal Risk Bands
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'schedule'}
                              label={
                                <Typography variant="body1">
                                  Timezone &amp; Report Schedule
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            <Tab
                              value={'enableDisableAccount'}
                              label={
                                <Typography variant="body1">
                                  Enable/Disable Account
                                </Typography>
                              }
                              id={`simple-tab-${0}`}
                              aria-controls={`simple-tabpanel-${0}`}
                              sx={{}}
                            />
                            {/* <Tab
                            value={'details'}
                            label={
                              <Typography variant="body1">
                                
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'tree'}
                            label={
                              <Typography variant="body1">Tree</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          /> */}
                            {/* <Tab
                          value={'prompts'}
                          label={
                            <Typography variant="body1">Prompts</Typography>
                          }
                          id={`simple-tab-${0}`}
                          aria-controls={`simple-tabpanel-${0}`}
                          sx={{}}
                        /> */}
                          </Tabs>
                          <Box
                            sx={{
                              border: '1px solid #d3d3d3',
                              padding: 2,
                            }}
                          >
                            {currentOnboadingDataTab === 'valueprop' ? (
                              <TextField
                                value={
                                  organizations?.find(
                                    (org) => org?.id === selectedOrganization,
                                  )?.valueProp || ''
                                }
                                multiline
                                rows={18}
                                fullWidth
                                // onChange={(e) =>
                                //   setValueProposition(e.target.value)
                                // }
                              />
                            ) : currentOnboadingDataTab === 'sellingstyle' ? (
                              <Typography>
                                {capitalizeText(
                                  organizations
                                    ?.find(
                                      (org) => org?.id === selectedOrganization,
                                    )
                                    ?.sellingStyle?.split('_')
                                    ?.join(' '),
                                )}
                              </Typography>
                            ) : currentOnboadingDataTab ===
                              'stackHolderSearchLimit' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                }}
                              >
                                <TextField
                                  autoFocus
                                  placeholder="Enter Stackholder Search Limit"
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  name="stackHolderSearchLimit"
                                  value={stackHolderSearchLimit}
                                  onChange={(e) =>
                                    setStackHolderSearchLimit(e.target.value)
                                  }
                                />
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    dispatch(
                                      updateOrganization(
                                        selectedOrganization,
                                        {
                                          stackHolderSearchLimit: stackHolderSearchLimit,
                                        },
                                        () => {
                                          dispatch(
                                            getAllOrganizations(
                                              [],
                                              true,
                                              'n_org',
                                              9,
                                              null,
                                              version === 'v1' ? 'all' : 'v2',
                                              () => {
                                                setSelectedOrganization(null);
                                              },
                                            ),
                                          );
                                          alert('Information Updated!');
                                        },
                                      ),
                                    );
                                  }}
                                >
                                  Update
                                </Button>
                              </Box>
                            ) : currentOnboadingDataTab === 'otherSettings' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'start',
                                  gap: 1,
                                }}
                              >
                                <FormControl fullWidth>
                                  <InputLabel id="excludedCrmStageNamesForSync">
                                    Exclude CRM Deal Stages
                                  </InputLabel>
                                  {/* {JSON.stringify(
                                    organizations?.find(
                                      (org) => org?.id === selectedOrganization,
                                    )?.qaiDealStages,
                                    null,
                                    2,
                                  )} */}
                                  <Select
                                    variant="outlined"
                                    size="small"
                                    labelId={'excludedCrmStageNamesForSync'}
                                    label={'Artifact Prompt'}
                                    id={'excludedCrmStageNamesForSync'}
                                    name={'excludedCrmStageNamesForSync'}
                                    MenuProps={{ disableScrollLock: true }}
                                    fullWidth
                                    multiple
                                    onChange={(e) => {
                                      console.llg;
                                      setExcludedCrmStageNamesForSync(
                                        e.target.value,
                                      );
                                    }}
                                    value={excludedCrmStageNamesForSync}
                                  >
                                    {organizations
                                      ?.find(
                                        (org) =>
                                          org?.id === selectedOrganization,
                                      )
                                      ?.qaiDealStages?.map((stage) => (
                                        <MenuItem
                                          key={stage?.id}
                                          value={stage?.name}
                                        >
                                          {/* <Typography variant="subtitle2"> */}
                                          {stage?.name} ({stage?.crm})
                                          {/* </Typography> */}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                                <FormControl
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormGroup row>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          size="small"
                                          checked={gmailOAuthFlowEnabled}
                                          name="emailVerified"
                                        />
                                      }
                                      label={
                                        <Typography variant="subtitle2">
                                          Enable Gmail OAuth Flow{' '}
                                          <span
                                            style={{
                                              color:
                                                theme.palette.text.secondary,
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            (Make sure no users of this
                                            organization have gmail integration
                                            turned on)
                                          </span>
                                        </Typography>
                                      }
                                      onChange={(e) =>
                                        setGmailOAuthFlowEnabled(
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </FormControl>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={gmailAutoSync}
                                      name="gmailAutoSync"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Enable email auto-sync
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setGmailAutoSync(e.target.checked);
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={syncCrmEmailEnabled}
                                      name="syncCrmEmailEnabled"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Enable Sync CRM Email
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setSyncCrmEmailEnabled(e.target.checked);
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={autoTrackNewCrmDeals}
                                      name="autoTrackNewCrmDeals"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Auto track new CRM Deals
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setAutoTrackNewCrmDeals(e.target.checked);
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={adminCanSeeAllDeals}
                                      name="adminCanSeeAllDeals"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Admin can see all deals
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setAdminCanSeeAllDeals(e.target.checked);
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={generateWeeklyDealSummary}
                                      name="generateWeeklyDealSummary"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Enable weekly deal summary generation
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setGenerateWeeklyDealSummary(
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={enableOauthMcpIntegration}
                                      name="enableOauthMcpIntegration"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Enable MCP OAuth Integration
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setEnableOauthMcpIntegration(
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={
                                        experimentalFeaturesSettingPreferenceEnabled
                                      }
                                      name="experimentalFeaturesSettingPreferenceEnabled"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Turn on Experimental features for this
                                      account
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setExperimentalFeaturesSettingPreferenceEnabled(
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={syncLinkedInPosts}
                                      onChange={(e) => {
                                        setSyncLinkedInPosts(e.target.checked);
                                      }}
                                      name="syncLinkedInPosts"
                                    />
                                  }
                                  label="Fetch LinkedIn posts made by companies and individuals"
                                  sx={{
                                    textAlign: 'left',
                                    marginLeft: 0,
                                    flex: 1,
                                    paddingRight: 2,
                                    background: '#fff',
                                    border: 'none',
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={scheduledAutoSyncLinkedInPosts}
                                      onChange={(e) => {
                                        setScheduledAutoSyncLinkedInPosts(
                                          e.target.checked,
                                        );
                                      }}
                                      name="scheduledAutoSyncLinkedInPosts"
                                    />
                                  }
                                  label="Enable scheduled auto-sync of LinkedIn posts"
                                  sx={{
                                    textAlign: 'left',
                                    marginLeft: 0,
                                    flex: 1,
                                    paddingRight: 2,
                                    background: '#fff',
                                    border: 'none',
                                  }}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={larry}
                                      name="larry"
                                    />
                                  }
                                  label={
                                    <Typography variant="subtitle2">
                                      Enable Larry AI (route AI/LLM operations
                                      through self-hosted Ollama)
                                    </Typography>
                                  }
                                  onChange={(e) => {
                                    setLarry(e.target.checked);
                                  }}
                                />
                                {larry ? (
                                  <FormControl
                                    size="small"
                                    sx={{ minWidth: 260 }}
                                  >
                                    <InputLabel id="larry-ai-model-label">
                                      Larry AI Model
                                    </InputLabel>
                                    <Select
                                      labelId="larry-ai-model-label"
                                      label="Larry AI Model"
                                      value={larryAiModel}
                                      onChange={(e) => {
                                        setLarryAiModel(e.target.value);
                                      }}
                                    >
                                      {aiModels?.slice(12).map((model) => (
                                        <MenuItem key={model} value={model}>
                                          {modelMapping[model]}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                ) : null}
                                <FormControl
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormLabel component="legend">
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      Email or Calendar Integration Service
                                      Provider
                                    </Typography>
                                  </FormLabel>
                                  <RadioGroup
                                    row
                                    value={emailIntegrationType}
                                    onChange={(e) =>
                                      setEmailIntegrationType(e.target.value)
                                    }
                                  >
                                    <FormControlLabel
                                      value="default"
                                      control={<Radio size="small" />}
                                      label={
                                        <Typography variant="caption">
                                          Default
                                        </Typography>
                                      }
                                    />
                                    <FormControlLabel
                                      value="attrove"
                                      control={<Radio size="small" />}
                                      label={
                                        <Typography variant="caption">
                                          Attrove
                                        </Typography>
                                      }
                                    />
                                    <FormControlLabel
                                      value="unipile"
                                      control={<Radio size="small" />}
                                      label={
                                        <Typography variant="caption">
                                          Unipile
                                        </Typography>
                                      }
                                    />
                                  </RadioGroup>
                                </FormControl>
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    if (larry && !larryAiModel) {
                                      alert(
                                        'Select a Larry AI Model before enabling Larry AI.',
                                      );
                                      return;
                                    }
                                    dispatch(
                                      updateOrgAutoSync(
                                        selectedOrganization,
                                        {
                                          gmailAutoSync: gmailAutoSync,
                                        },
                                        () => {
                                          dispatch(
                                            getAllOrganizations(
                                              [],
                                              true,
                                              'n_org',
                                              9,
                                              null,
                                              version === 'v1' ? 'all' : 'v2',
                                              () => {
                                                setSelectedOrganization(null);
                                              },
                                            ),
                                          );
                                        },
                                      ),
                                    );
                                    dispatch(
                                      updateOrganization(
                                        selectedOrganization,
                                        {
                                          excludedCrmStageNamesForSync: excludedCrmStageNamesForSync,
                                          autoTrackNewCrmDeals: autoTrackNewCrmDeals,
                                          adminCanSeeAllDeals: adminCanSeeAllDeals,
                                          generateWeeklyDealSummary: generateWeeklyDealSummary,
                                          syncCrmEmailEnabled: syncCrmEmailEnabled,
                                          experimentalFeaturesSettingPreferenceEnabled: experimentalFeaturesSettingPreferenceEnabled,
                                          gmailOAuthFlowEnabled: gmailOAuthFlowEnabled,
                                          enableOauthMcpIntegration: enableOauthMcpIntegration,
                                          syncLinkedInPosts: syncLinkedInPosts,
                                          scheduledAutoSyncLinkedInPosts: scheduledAutoSyncLinkedInPosts,
                                          emailOrCalendarServiceProvider: emailIntegrationType,
                                          larry: larry,
                                          ...(larryAiModel
                                            ? { larryAiModel: larryAiModel }
                                            : {}),
                                        },
                                        () => {
                                          dispatch(
                                            getAllOrganizations(
                                              [],
                                              true,
                                              'n_org',
                                              9,
                                              null,
                                              version === 'v1' ? 'all' : 'v2',
                                              () => {
                                                setSelectedOrganization(null);
                                              },
                                            ),
                                          );
                                          alert('Information Updated!');
                                        },
                                      ),
                                    );
                                  }}
                                >
                                  Update
                                </Button>
                              </Box>
                            ) : currentOnboadingDataTab === 'riskBands' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                  alignItems: 'stretch',
                                  maxWidth: 640,
                                }}
                              >
                                <Box>
                                  <Typography variant="subtitle2">
                                    Deal Risk Classification
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Score ranges this organization&apos;s weekly
                                    deal risk scores are classified into.
                                    {orgHasOwnRiskBands
                                      ? ' This organization has its own bands, overriding the platform default set under Global Configs.'
                                      : ' This organization has no bands of its own, so it is classified by the platform default set under Global Configs — shown below. Saving here turns that into an override for this organization only.'}
                                  </Typography>
                                </Box>
                                <RiskBandsEditor
                                  rows={riskBandRows}
                                  onChange={setRiskBandRows}
                                  disabled={updatingRiskBands}
                                  defaultBands={platformRiskBands}
                                  defaultLabel="Reset to Platform Default"
                                />
                                <Box>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disabled={
                                      updatingRiskBands ||
                                      !!validateRiskBands(riskBandRows)
                                    }
                                    onClick={() => {
                                      setUpdatingRiskBands(true);
                                      dispatch(
                                        updateOrganization(
                                          selectedOrganization,
                                          {
                                            riskBands: toRiskBandPayload(
                                              riskBandRows,
                                            ),
                                          },
                                          () => {
                                            setUpdatingRiskBands(false);
                                            dispatch(
                                              getAllOrganizations(
                                                [],
                                                true,
                                                'n_org',
                                                9,
                                                null,
                                                version === 'v1' ? 'all' : 'v2',
                                                () => {
                                                  setSelectedOrganization(null);
                                                },
                                              ),
                                            );
                                            alert('Information Updated!');
                                          },
                                          (message) => {
                                            setUpdatingRiskBands(false);
                                            // Overlapping bands come back as a
                                            // 400 from the API too, so the
                                            // message is worth showing rather
                                            // than a generic failure.
                                            alert(
                                              message ||
                                                'Failed to update risk bands',
                                            );
                                          },
                                        ),
                                      );
                                    }}
                                  >
                                    {updatingRiskBands
                                      ? 'Updating...'
                                      : 'Update'}
                                  </Button>
                                </Box>
                              </Box>
                            ) : currentOnboadingDataTab === 'schedule' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                  alignItems: 'stretch',
                                  maxWidth: 640,
                                }}
                              >
                                <Box>
                                  <Typography variant="subtitle2">
                                    Timezone &amp; Weekly Report Schedule
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    The weekly deal summary cron selects orgs by
                                    timezone and day/time together, so every
                                    member of this organization gets the report
                                    at the same moment -- not on their own
                                    personal timezone. Currently{' '}
                                    {formatWeeklyReportSchedule(
                                      organizations?.find(
                                        (org) =>
                                          org?.id === selectedOrganization,
                                      )?.weeklyReportGenerationTime,
                                    )}{' '}
                                    {getTimeZoneLabel(
                                      organizations?.find(
                                        (org) =>
                                          org?.id === selectedOrganization,
                                      )?.timeZone || DEFAULT_TIME_ZONE,
                                    )}
                                    .
                                  </Typography>
                                </Box>
                                <OrgScheduleEditor
                                  value={scheduleDraft}
                                  onChange={setScheduleDraft}
                                  disabled={updatingSchedule}
                                />
                                <Box>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disabled={
                                      updatingSchedule ||
                                      !scheduleDraft?.timeZone ||
                                      !!validateWeeklyReportSchedule(
                                        scheduleDraft,
                                      )
                                    }
                                    onClick={() => {
                                      setUpdatingSchedule(true);
                                      dispatch(
                                        updateOrganization(
                                          selectedOrganization,
                                          {
                                            timeZone: scheduleDraft?.timeZone,
                                            weeklyReportGenerationTime: toWeeklyReportSchedulePayload(
                                              scheduleDraft,
                                            ),
                                          },
                                          () => {
                                            setUpdatingSchedule(false);
                                            dispatch(
                                              getAllOrganizations(
                                                [],
                                                true,
                                                'n_org',
                                                9,
                                                null,
                                                version === 'v1' ? 'all' : 'v2',
                                                () => {
                                                  setSelectedOrganization(null);
                                                },
                                              ),
                                            );
                                            alert('Information Updated!');
                                          },
                                          (message) => {
                                            setUpdatingSchedule(false);
                                            // An unknown zone id or an off-grid
                                            // time comes back as a 400, so the
                                            // message is worth showing rather
                                            // than a generic failure.
                                            alert(
                                              message ||
                                                'Failed to update timezone and report schedule',
                                            );
                                          },
                                        ),
                                      );
                                    }}
                                  >
                                    {updatingSchedule
                                      ? 'Updating...'
                                      : 'Update'}
                                  </Button>
                                </Box>
                              </Box>
                            ) : currentOnboadingDataTab ===
                              'enableDisableAccount' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                  alignItems: 'start',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    if (
                                      organizations?.find(
                                        (org) =>
                                          org?.id === selectedOrganization,
                                      )?.scheduledDeleteRequest
                                    ) {
                                      setShowConfirmDisableDialog('enable');
                                    } else {
                                      setShowConfirmDisableDialog('disable');
                                    }
                                  }}
                                >
                                  {organizations?.find(
                                    (org) => org?.id === selectedOrganization,
                                  )?.scheduledDeleteRequest
                                    ? 'Enable'
                                    : 'Disable'}{' '}
                                  Account
                                </Button>
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={() => {
                                    setShowConfirmDisableDialog('delete');
                                  }}
                                >
                                  Permanently Delete Account and Associated Data
                                </Button>
                                {organizations?.find(
                                  (org) => org?.id === selectedOrganization,
                                )?.scheduledDeleteRequest ? (
                                  <>
                                    <Typography>
                                      This account is scheduled to be deleted on{' '}
                                      {moment(
                                        organizations?.find(
                                          (org) =>
                                            org?.id === selectedOrganization,
                                        )?.scheduledDeleteRequest
                                          ?.scheduledForTime,
                                      ).format('DD-MMMM-YYYY HH:mm:ss A')}
                                    </Typography>
                                    <Typography>
                                      Reason for deletion:{' '}
                                      {
                                        organizations?.find(
                                          (org) =>
                                            org?.id === selectedOrganization,
                                        )?.scheduledDeleteRequest?.reason
                                      }
                                    </Typography>
                                  </>
                                ) : null}
                              </Box>
                            ) : null}
                          </Box>
                        </Box>
                      ) : null
                    ) : null}
                  </>
                  {/* )} */}
                </>
              ) : currentOrgMenu === 'users' ? (
                <Box p={2}>
                  <Box
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mb={2}
                  >
                    <Typography variant="h6" gutterBottom>
                      Users
                    </Typography>
                  </Box>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Role</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {organizations
                          ?.find((org) => org?.id === selectedOrganization)
                          ?.customFields?.users?.map((user) => (
                            <TableRow key={user.id}>
                              <TableCell>
                                {user.firstName} {user.lastName}
                              </TableCell>
                              <TableCell>{user.email}</TableCell>
                              <TableCell>{user.role || 'user'}</TableCell>
                              <TableCell align="center">
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleViewAs(user.id)}
                                  >
                                    View As
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() =>
                                      terminateViewAsSessions(user.id)
                                    }
                                  >
                                    Terminate Sessions
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : currentOrgMenu === 'deals' ? (
                <>
                  <Box
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={
                      viewType === 'dealdetails' ||
                      viewType === 'artifactDetails' ||
                      viewType === 'ragTesting'
                        ? 'flex-start'
                        : 'flex-end'
                    }
                  >
                    {viewType === 'dealdetails' ||
                    viewType === 'artifactDetails' ||
                    viewType === 'ragTesting' ? (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
                        >
                          <Button
                            startIcon={<ArrowBack />}
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                              if (viewType === 'artifactDetails') {
                                setViewType('dealdetails');
                              } else {
                                setViewType('deals');
                              }
                            }}
                            sx={{ padding: '4px 8px' }}
                          >
                            Go Back
                          </Button>
                          <Typography>{selectedDeal?.name}</Typography>
                          {viewType === 'artifactDetails' ? (
                            <Typography>
                              {'>'} {selectedArtifact?.title || '--'}
                            </Typography>
                          ) : null}
                        </Box>
                        {viewType === 'artifactDetails' ? (
                          <Button
                            // startIcon={< />}
                            disabled={processingArtifact}
                            startIcon={
                              processingArtifact ? (
                                <CircularProgress size={16} />
                              ) : null
                            }
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              setProcessingArtifact(true);
                              dispatch(
                                processDealArtifact(
                                  selectedOrganization,
                                  selectedDeal?.id,
                                  selectedArtifact?.id,
                                  {
                                    speakerConfigMap:
                                      selectedArtifact?.customField
                                        ?.salesReviewFile?.speakerConfigMap,
                                  },
                                  () => {
                                    setProcessingArtifact(false);
                                    setSelectedArtifact((prev) => {
                                      return {
                                        ...prev,
                                        postProcessingStatus:
                                          'file_analysis_in_process',
                                      };
                                    });
                                    alert('Analysis triggered!');
                                    setArtifacts((prev) => {
                                      return prev.map((artifact) => {
                                        if (
                                          artifact?.id === selectedArtifact?.id
                                        ) {
                                          return {
                                            ...artifact,
                                            postProcessingStatus:
                                              'file_analysis_in_process',
                                          };
                                        }
                                        return artifact;
                                      });
                                    });
                                  },
                                  () => {
                                    setProcessingArtifact(false);
                                  },
                                ),
                              );
                            }}
                            sx={{ padding: '4px 8px' }}
                          >
                            Re-trigger Analysis
                          </Button>
                        ) : viewType === 'dealdetails' ? (
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 2,
                              alignItems: 'center',
                            }}
                          >
                            <Button
                              // startIcon={< />}
                              disabled={resettingDealHighlights}
                              startIcon={
                                resettingDealHighlights ? (
                                  <CircularProgress size={16} />
                                ) : null
                              }
                              color="primary"
                              variant="contained"
                              onClick={() => {
                                setResettingDealDealHighlights(true);
                                dispatch(
                                  resetDealHighlights(
                                    selectedOrganization,
                                    selectedDeal?.id,
                                    () => {
                                      setResettingDealDealHighlights(false);
                                    },
                                    () => {
                                      setResettingDealDealHighlights(false);
                                    },
                                  ),
                                );
                              }}
                              sx={{ padding: '4px 8px' }}
                            >
                              Reset Deal Highligts
                            </Button>
                            <Button
                              // startIcon={< />}
                              disabled={reTriggeringDealHighlights}
                              startIcon={
                                reTriggeringDealHighlights ? (
                                  <CircularProgress size={16} />
                                ) : null
                              }
                              color="primary"
                              variant="contained"
                              onClick={() => {
                                setReTriggeringDealHighlights(true);
                                dispatch(
                                  reTriggerDealHighlights(
                                    selectedOrganization,
                                    selectedDeal?.id,
                                    organizations?.find(
                                      (org) => org?.id == selectedOrganization,
                                    )?.adminId,
                                    () => {
                                      setReTriggeringDealHighlights(false);
                                    },
                                    () => {
                                      setReTriggeringDealHighlights(false);
                                    },
                                  ),
                                );
                              }}
                              sx={{ padding: '4px 8px' }}
                            >
                              Retrigger Deal Highligts
                            </Button>
                          </Box>
                        ) : null}
                      </Box>
                    ) : null}
                    <Box display={'flex'} alignItems={'center'} gap={1}>
                      {viewType === 'deals' && selectedOrganization ? (
                        <Button
                          color="primary"
                          variant="outlined"
                          startIcon={<Summarize />}
                          onClick={() => {
                            setTriggerRecentResult(null);
                            setTriggerRecentError(null);
                            setTriggerRecentOpen(true);
                          }}
                          sx={{ padding: '4px 8px' }}
                        >
                          Generate Reports (Recent Deals)
                        </Button>
                      ) : null}
                      {viewType !== 'ragTesting' && (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => {
                            setViewType('ragTesting');
                            setSelectedDeal(null);
                          }}
                          sx={{ padding: '4px 8px' }}
                        >
                          Rag Testing Interface(Global)
                        </Button>
                      )}
                    </Box>
                  </Box>
                  {viewType === 'deals' ? (
                    fetchingDeals ? (
                      <Box
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          padding: 10,
                          textAlign: 'center',
                        }}
                      >
                        <CircularProgress size={16} />
                        <Typography>Loading deals ...</Typography>
                      </Box>
                    ) : (
                      <TableContainer
                        component={Paper}
                        sx={{
                          minHeight: 'calc(100vh - 120px)',
                          maxHeight: 'calc(100vh - 120px)',
                          overflowY: 'scroll',
                          '&::-webkit-scrollbar': {
                            width: '5px',
                          },
                          '&::-webkit-scrollbar-track': {
                            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 2,
                          },
                        }}
                        // onScroll={handleListScroll}
                      >
                        <Table
                          sx={{ minWidth: 750 }}
                          stickyHeader
                          aria-label="simple table"
                        >
                          <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                            <TableRow>
                              <TableCell>
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Deal Title
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Deal Stage
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Deal Size
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Close Date
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Activities
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography
                                  variant={'caption'}
                                  fontWeight={700}
                                  sx={{ textTransform: 'uppercase' }}
                                >
                                  Actions
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {deals.map((deal, i) => (
                              <TableRow
                                key={i}
                                // sx={{
                                //   '&:last-child td, &:last-child th': {
                                //     border: 0,
                                //   },
                                // }}
                              >
                                <TableCell component="th" scope="row">
                                  <Typography
                                    variant={'subtitle2'}
                                    // fontWeight={700}
                                  >
                                    {deal?.name}
                                  </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Typography
                                    variant={'subtitle2'}
                                    // fontWeight={700}
                                  >
                                    {deal?.qaiDealStage?.name}
                                  </Typography>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Typography
                                    variant={'subtitle2'}
                                    // fontWeight={700}
                                  >
                                    {deal?.amount?.amount ? (
                                      <>
                                        {deal?.amount?.currency === 'usd'
                                          ? '$'
                                          : deal?.amount?.currency === 'inr'
                                          ? '₹'
                                          : '$'}
                                        {deal?.amount?.amount || '--'}
                                      </>
                                    ) : (
                                      '--'
                                    )}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant={'caption'}
                                    // fontWeight={700}
                                    // sx={{
                                    //   color: theme.palette.success.main,
                                    // }}
                                  >
                                    {deal?.closeOn > 0
                                      ? moment(deal?.closeOn).format(
                                          'DD MMMM YYYY',
                                        )
                                      : '--'}
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {deal?.counts?.interactions &&
                                  deal?.counts?.interactions > 0 ? (
                                    <Button
                                      size="small"
                                      variant="text"
                                      color="primary"
                                      onClick={() => {
                                        setViewType('dealdetails');
                                        setCurrentDealTab('artifacts');
                                        setSelectedDeal(deal);
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        fontWeight={'bold'}
                                        sx={{
                                          textDecoration: 'underline',
                                        }}
                                      >
                                        {deal?.counts?.interactions || 0}
                                      </Typography>
                                    </Button>
                                  ) : (
                                    <Typography variant={'caption'}>
                                      {deal?.counts?.interactions
                                        ? deal?.counts?.interactions
                                        : 0}
                                    </Typography>
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  <Box
                                    display={'flex'}
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    gap={1}
                                  >
                                    <Tooltip
                                      arrow
                                      placement="top"
                                      title="RAG Testing Interface"
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          setViewType('ragTesting');
                                          setSelectedDeal(deal);
                                        }}
                                      >
                                        <Article sx={{ fontSize: 20 }} />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip
                                      arrow
                                      placement="top"
                                      title="Weekly Deal Summary"
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          setWeeklySummaryDeal(deal);
                                          setWeeklySummaryWindow('LAST_WEEK');
                                          setWeeklySummaries([]);
                                          setLoadingWeeklySummaries(true);
                                          dispatch(
                                            getWeeklyDealSummaries(
                                              selectedOrganization,
                                              deal?.id,
                                              (data) => {
                                                setWeeklySummaries(data || []);
                                                setLoadingWeeklySummaries(
                                                  false,
                                                );
                                              },
                                              () => {
                                                setLoadingWeeklySummaries(
                                                  false,
                                                );
                                              },
                                            ),
                                          );
                                        }}
                                      >
                                        <Summarize sx={{ fontSize: 20 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          {/* <TableFooter>
                            <TableRow>
                              <TableCell
                                variant="footer"
                                colSpan={6}
                                sx={{
                                  padding: 0,
                                }}
                              >
                                {fetchingPagination ? (
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      padding: 1,
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      variant="contained"
                                      // type="submit"
                                      color="primary"
                                      onClick={handleListScroll}
                                      // className="searchSettings"
                                      disabled
                                      // fullWidth
                                    >
                                      <Typography color="textPrimary">
                                        Loading more deals ...{' '}
                                      </Typography>
                                      <CircularProgress size={20} />
                                    </Button>
                                  </Box>
                                ) : emptyList === false &&
                                  deals.length >= 10 ? (
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      padding: 1,
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      variant="contained"
                                      // type="submit"
                                      // fullWidth
                                      color="primary"
                                      // onClick={(e) => handleListScroll(e, true)}
                                      // className="searchSettings"
                                    >
                                      Load More
                                    </Button>
                                  </Box>
                                ) : null}
                              </TableCell>
                            </TableRow>
                          </TableFooter> */}
                        </Table>
                      </TableContainer>
                    )
                  ) : viewType === 'dealdetails' ||
                    viewType === 'artifactDetails' ||
                    viewType === 'ragTesting' ? (
                    <Box>
                      {viewType === 'dealdetails' ? (
                        <Tabs
                          value={currentDealTab}
                          onChange={(e, newValue) =>
                            setCurrentDealTab(newValue)
                          }
                          aria-label="Current Deal Tabs"
                          orientation={'horizontal'}
                          // indicatorColor={theme.palette.background.default}
                          variant="scrollable"
                          // scrollButtons={!isMd}
                          allowScrollButtonsMobile
                          sx={{
                            border: '1px solid #d3d3d3',
                          }}
                        >
                          <Tab
                            value={'artifacts'}
                            label={
                              <Typography variant="body1">
                                Activities
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />

                          {/* <Tab
                            value={'uploadArtifact'}
                            label={
                              <Typography variant="body1">
                                Upload Artifact
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          /> */}
                          <Tab
                            value={'details'}
                            label={
                              <Typography variant="body1">
                                Deal Details
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'tree'}
                            label={
                              <Typography variant="body1">Tree</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          {/* <Tab
                          value={'prompts'}
                          label={
                            <Typography variant="body1">Prompts</Typography>
                          }
                          id={`simple-tab-${0}`}
                          aria-controls={`simple-tabpanel-${0}`}
                          sx={{}}
                        /> */}
                        </Tabs>
                      ) : viewType === 'artifactDetails' ? (
                        <Tabs
                          value={currentArtifactTab}
                          onChange={(e, newValue) =>
                            setCurrentArtifactTab(newValue)
                          }
                          aria-label="Current Artifact Tabs"
                          orientation={'horizontal'}
                          // indicatorColor={theme.palette.background.default}
                          variant="scrollable"
                          // scrollButtons={!isMd}
                          allowScrollButtonsMobile
                          sx={{
                            border: '1px solid #d3d3d3',
                          }}
                        >
                          <Tab
                            value={'artifactSummary'}
                            label={
                              <Typography variant="body1">Summary</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactContent'}
                            label={
                              <Typography variant="body1">
                                {artifactTypesWithoutMedia.includes(
                                  selectedArtifact?.interactionType,
                                )
                                  ? 'Content'
                                  : 'Transcript'}
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactBuyersPOV'}
                            label={
                              <Typography variant="body1">
                                Buyers POV
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactRisks'}
                            label={
                              <Typography variant="body1">Risks</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactNBAs'}
                            label={
                              <Typography variant="body1">
                                Recommended Actions
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactOverview'}
                            label={
                              <Typography variant="body1">Overview</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactTree'}
                            label={
                              <Typography variant="body1">
                                Tree(Cummulative deltas)
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'prompt'}
                            label={
                              <Typography variant="body1">Prompt</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          {/* <Tab
                        value={'prompts'}
                        label={
                          <Typography variant="body1">Prompts</Typography>
                        }
                        id={`simple-tab-${0}`}
                        aria-controls={`simple-tabpanel-${0}`}
                        sx={{}}
                      /> */}
                        </Tabs>
                      ) : null}
                      <Box
                        sx={{
                          minHeight:
                            viewType === 'ragTesting'
                              ? 'calc(100vh - 160px)'
                              : 'calc(100vh - 200px)',
                          maxHeight:
                            viewType === 'ragTesting'
                              ? 'calc(100vh - 160px)'
                              : 'calc(100vh - 200px)',
                          overflowY: 'scroll',
                          '&::-webkit-scrollbar': {
                            width: '5px',
                          },
                          '&::-webkit-scrollbar-track': {
                            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 2,
                          },
                          border:
                            viewType === 'ragTesting'
                              ? 'none'
                              : '1px solid #d3d3d3',
                          padding: viewType === 'ragTesting' ? 0 : 2,
                        }}
                      >
                        {viewType === 'dealdetails' ? (
                          currentDealTab === 'artifacts' ? (
                            fetchingArtifacts ? (
                              <Box
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  padding: 10,
                                  textAlign: 'center',
                                }}
                              >
                                <CircularProgress size={16} />
                                <Typography>Loading activities ...</Typography>
                              </Box>
                            ) : (
                              <TableContainer
                                component={Paper}
                                sx={{
                                  minHeight: 'calc(100vh - 260px)',
                                  maxHeight: 'calc(100vh - 260px)',
                                  overflowY: 'scroll',
                                  '&::-webkit-scrollbar': {
                                    width: '5px',
                                  },
                                  '&::-webkit-scrollbar-track': {
                                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                    webkitBoxShadow:
                                      'inset 0 0 6px rgba(0,0,0,0.00)',
                                  },
                                  '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: theme.palette.primary.main,
                                    borderRadius: 2,
                                  },
                                }}
                                // onScroll={handleListScroll}
                              >
                                <Table
                                  sx={{ minWidth: 750 }}
                                  stickyHeader
                                  aria-label="simple table"
                                >
                                  <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                                    <TableRow>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Title
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Type
                                        </Typography>
                                      </TableCell>
                                      {/* <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Buyers
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Sellers
                                        </Typography>
                                      </TableCell> */}
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Date
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Actions
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {artifacts.map((artifact, i) => (
                                      <TableRow
                                        key={i}
                                        // sx={{
                                        //   '&:last-child td, &:last-child th': {
                                        //     border: 0,
                                        //   },
                                        // }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {/* {artifactEditable?.id ===
                                          artifact?.id ? (
                                            <form
                                              onSubmit={(e) => {
                                                e.preventDefault();
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <TextField
                                                  autoFocus
                                                  placeholder="Artifact Title"
                                                  variant="outlined"
                                                  color="primary"
                                                  size="small"
                                                  name="artifactTitle"
                                                  value={artifactTitle}
                                                  onChange={(e) =>
                                                    setArtifactTitle(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                                <Box
                                                  display={'flex'}
                                                  flexDirection={'column'}
                                                  gap={0.5}
                                                >
                                                  <Tooltip
                                                    title="Close"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    <IconButton
                                                      sx={{
                                                        borderRadius: 1,
                                                        color: '#fff',
                                                        width: 16,
                                                        height: 16,
                                                        background:
                                                          theme.palette.text
                                                            .secondary,
                                                        ':hover': {
                                                          backgroundColor:
                                                            theme.palette.text
                                                              .secondary,
                                                        },
                                                      }}
                                                      onClick={() => {
                                                        setArtifactEditable(
                                                          null,
                                                        );
                                                      }}
                                                    >
                                                      <Close
                                                        sx={{ fontSize: 9 }}
                                                      />
                                                    </IconButton>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title="Done"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    {updatingArtifactTitle ? (
                                                      <CircularProgress
                                                        size={14}
                                                        sx={{
                                                          color:
                                                            theme.palette
                                                              .primary.main,
                                                        }}
                                                      />
                                                    ) : (
                                                      <IconButton
                                                        disabled={
                                                          !artifactTitle?.trim() ||
                                                          updatingArtifactTitle
                                                        }
                                                        sx={{
                                                          borderRadius: 1,
                                                          color: '#fff',
                                                          width: 16,
                                                          height: 16,
                                                          background:
                                                            theme.palette
                                                              .primary.main,
                                                          ':hover': {
                                                            backgroundColor:
                                                              theme.palette
                                                                .primary.main,
                                                          },
                                                        }}
                                                        onClick={() => {
                                                          setUpdatingArtifactTitle(
                                                            true,
                                                          );
                                                          dispatch(
                                                            udpateArtifactForDeal(
                                                              selectedOrganization,
                                                              selectedDeal?.id,
                                                              artifactEditable?.id,
                                                              {
                                                                title: artifactTitle,
                                                              },
                                                              (data) => {
                                                                setUpdatingArtifactTitle(
                                                                  false,
                                                                );
                                                                setArtifactEditable(
                                                                  null,
                                                                );
                                                                setArtifacts(
                                                                  (prev) => {
                                                                    return prev.map(
                                                                      (
                                                                        artifact,
                                                                      ) => {
                                                                        if (
                                                                          artifact?.id ===
                                                                          data?.id
                                                                        ) {
                                                                          return data;
                                                                        }
                                                                        return artifact;
                                                                      },
                                                                    );
                                                                  },
                                                                );
                                                              },
                                                            ),
                                                          );
                                                        }}
                                                      >
                                                        <Check
                                                          sx={{ fontSize: 9 }}
                                                        />
                                                      </IconButton>
                                                    )}
                                                  </Tooltip>
                                                </Box>
                                              </Box>
                                            </form>
                                          ) : ( */}
                                          <Tooltip
                                            arrow
                                            placement="top"
                                            title={
                                              'Click to update artifact title'
                                            }
                                          >
                                            <Typography
                                              variant={'subtitle2'}
                                              // fontWeight={700}
                                              sx={{
                                                cursor: 'pointer',
                                                maxWidth: 200,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: '1',
                                                WebkitBoxOrient: 'vertical',
                                              }}
                                              // onClick={() => {
                                              //   setArtifactEditable(artifact);
                                              // }}
                                            >
                                              {artifact?.title || '--'}
                                            </Typography>
                                          </Tooltip>
                                          {/* )} */}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {capitalizeText(
                                              artifact?.interactionType
                                                ?.split('-')
                                                ?.join(' '),
                                            )}
                                          </Typography>
                                        </TableCell>
                                        {/* <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.buyers?.join(', ')}
                                          </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.sellers?.join(', ')}
                                          </Typography>
                                        </TableCell> */}
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'caption'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.interactionTime
                                              ? moment(
                                                  artifact?.interactionTime,
                                                ).format(
                                                  'DD MMMM YYYY hh:mm:ss A',
                                                )
                                              : '--'}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          <Box
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Tooltip
                                              arrow
                                              placement="top"
                                              title="Artifact Details"
                                            >
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setViewType(
                                                    'artifactDetails',
                                                  );
                                                  setCurrentArtifactTab(
                                                    'artifactContent',
                                                  );
                                                  setSelectedArtifact(artifact);
                                                }}
                                              >
                                                <Article
                                                  sx={{ fontSize: 20 }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                            {/* <Tooltip
                                              arrow
                                              placement="top"
                                              title="Remove"
                                            >
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setShowConfirmDeleteArtifact(
                                                    artifact?.id,
                                                  );
                                                }}
                                              >
                                                <Delete sx={{ fontSize: 20 }} />
                                              </IconButton>
                                            </Tooltip> */}
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                  <TableFooter>
                                    <TableRow>
                                      <TableCell
                                        variant="footer"
                                        colSpan={6}
                                        sx={{
                                          padding: 0,
                                        }}
                                      >
                                        {fetchingPagination ? (
                                          <Box
                                            sx={{
                                              width: '100%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              padding: 1,
                                              textAlign: 'center',
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="contained"
                                              // type="submit"
                                              color="primary"
                                              onClick={handleListScroll}
                                              // className="searchSettings"
                                              disabled
                                              // fullWidth
                                            >
                                              <Typography color="textPrimary">
                                                Loading more bots ...{' '}
                                              </Typography>
                                              <CircularProgress size={20} />
                                            </Button>
                                          </Box>
                                        ) : emptyList === false &&
                                          deals.length >= 10 ? (
                                          <Box
                                            sx={{
                                              width: '100%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              padding: 1,
                                              textAlign: 'center',
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="contained"
                                              // type="submit"
                                              // fullWidth
                                              color="primary"
                                              // onClick={(e) => handleListScroll(e, true)}
                                              // className="searchSettings"
                                            >
                                              Load More
                                            </Button>
                                          </Box>
                                        ) : null}
                                      </TableCell>
                                    </TableRow>
                                  </TableFooter>
                                </Table>
                              </TableContainer>
                            )
                          ) : currentDealTab === 'uploadArtifact' ? (
                            <Box>
                              {/* <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Box
                                  display={'flex'}
                                  flexDirection={'column'}
                                  // gap={2}
                                >
                                  <TextField
                                    label="Artifact Title"
                                    variant="outlined"
                                    name={'artifactTitle'}
                                    size="small"
                                    fullWidth
                                    value={artifactTitle}
                                    onChange={(e) =>
                                      setArtifactTitle(e.target.value)
                                    }
                                  />
                                  <FormControl size="small">
                                    <FormLabel id="demo-row-radio-buttons-group-label">
                                      <Typography variant="caption">
                                        Artifact Type
                                      </Typography>
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                      value={artifactType || ''}
                                      onChange={(e) =>
                                        setArtifactType(e.target.value)
                                      }
                                    >
                                      <FormControlLabel
                                        value={'transcript'}
                                        control={<Radio size="small" />}
                                        label={'Transcript'}
                                      />
                                      <FormControlLabel
                                        value={'email'}
                                        control={<Radio size="small" />}
                                        label={'Email'}
                                      />
                                      <FormControlLabel
                                        value={'note'}
                                        control={<Radio size="small" />}
                                        label={'Note'}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  <Box>
                                    <Typography
                                      variant="caption"
                                      color={'text.secondary'}
                                    >
                                      Artifact Time
                                    </Typography>
                                    <br />
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DateTimePicker
                                        // label="Meeting Time"
                                        size="small"
                                        value={dayjs(artifactTime)}
                                        onChange={(newValue) => {
                                          console.log(
                                            new Date(newValue).getTime(),
                                          );
                                          setArtifactTime(
                                            new Date(newValue).getTime(),
                                          );
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </Box>
                                </Box>
                                <TextField
                                  label="Buyer's Participants(Comma Seperated)"
                                  variant="outlined"
                                  name={'buyerParticipants'}
                                  size="small"
                                  fullWidth
                                  value={buyerParticipants}
                                  onChange={(e) =>
                                    setBuyerParticipants(e.target.value)
                                  }
                                />
                                <TextField
                                  label="Seller's Participants(Comma Seperated)"
                                  variant="outlined"
                                  name={'sellerParticipants'}
                                  size="small"
                                  fullWidth
                                  value={sellerParticipants}
                                  onChange={(e) =>
                                    setSellerParticipants(e.target.value)
                                  }
                                />
                                <TextField
                                  label="Content"
                                  variant="outlined"
                                  name={'artifactContent'}
                                  size="small"
                                  fullWidth
                                  multiline
                                  rows={8}
                                  value={artifactContent}
                                  onChange={(e) =>
                                    setArtifactContent(e.target.value)
                                  }
                                />
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    disabled={
                                      generatingValueProp ||
                                      creatingDiscoverytree
                                    }
                                    startIcon={
                                      creatingDiscoverytree ? (
                                        <CircularProgress size={20} />
                                      ) : null
                                    }
                                    onClick={(e) => {
                                      setAddingArtifactForDeal(true);
                                      dispatch(
                                        addArtifactForDeal(
                                          selectedOrganization,
                                          selectedDeal?.id,
                                          {
                                            buyers:
                                              buyerParticipants?.split(',') ||
                                              [],
                                            sellers:
                                              sellerParticipants?.split(',') ||
                                              [],
                                            content: artifactContent,
                                            interactionType: artifactType,
                                            interactionTime: artifactTime,
                                            title: artifactTitle,
                                          },
                                          (data) => {
                                            setArtifactType('transcript');
                                            setArtifactContent('');
                                            setBuyerParticipants('');
                                            setSellerParticipants('');
                                            setAddingArtifactForDeal(false);
                                            setShowUploadArtifact(false);
                                            setCurrentDealTab('artifacts');
                                          },
                                        ),
                                      );
                                    }}
                                    color="primary"
                                    autoFocus
                                  >
                                    Upload
                                  </Button>
                                </Box>
                              </Box> */}
                            </Box>
                          ) : currentDealTab === 'tree' ? (
                            <Box
                              display={'flex'}
                              flexDirection={'column'}
                              gap={2}
                              position={'relative'}
                            >
                              {selectedDeal?.topics &&
                              selectedDeal?.topics.length > 0 ? (
                                <QuestionFrameworkTree
                                  data={selectedDeal.topics}
                                  dealTree={true}
                                  showExportButton={true}
                                  treeId={selectedOrganization}
                                  dealId={selectedDeal?.id}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: 300,
                                    gap: 2,
                                  }}
                                >
                                  <Typography>
                                    No question tree found
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          ) : currentDealTab === 'details' ? (
                            <Box>
                              <Box
                                sx={{
                                  paddingX: 1,
                                  display: 'flex',
                                  gap: 2,
                                  paddingY: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                    flex: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <Typography
                                      color={'text.secondary'}
                                      fontWeight={'bold'}
                                      sx={{ fontSize: 18 }}
                                    >
                                      Summary
                                    </Typography>
                                  </Box>
                                  <Typography
                                    sx={{
                                      minHeight: 200,
                                      maxHeight: 200,
                                      overflowY: 'auto',
                                      '&::-webkit-scrollbar': {
                                        width: '5px',
                                      },
                                      '&::-webkit-scrollbar-track': {
                                        boxShadow:
                                          'inset 0 0 6px rgba(0,0,0,0.00)',
                                        webkitBoxShadow:
                                          'inset 0 0 6px rgba(0,0,0,0.00)',
                                      },
                                      '&::-webkit-scrollbar-thumb': {
                                        backgroundColor:
                                          theme.palette.primary.main,
                                        borderRadius: 2,
                                      },
                                      borderRight: '1px solid #d3d3d3',
                                      color: !selectedDeal?.overallDealSummary
                                        ? 'text.secondary'
                                        : 'text.primary',
                                    }}
                                  >
                                    {selectedDeal?.overallDealSummary ||
                                      'No summary generated yet.'}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    gap: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flex: 1,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Deal Size
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.amount?.amount
                                          ? `${
                                              selectedDeal?.amount?.currency ===
                                              'usd'
                                                ? '$'
                                                : selectedDeal?.amount
                                                    ?.currency === 'inr'
                                                ? '₹'
                                                : '$'
                                            }
              ${selectedDeal?.amount?.amount || '--'}`
                                          : '--'}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Expected Close Date
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.closeOn
                                          ? moment(
                                              selectedDeal?.closeOn,
                                            ).format('MM/DD/YYYY')
                                          : '--'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      flex: 1,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Top Risks
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{
                                          textAlign: 'center',
                                          fontSize: 22,
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: '-webkit-box',
                                          WebkitLineClamp: '1',
                                          WebkitBoxOrient: 'vertical',
                                          cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => {
                                          setAnchorElRisks(e.currentTarget);
                                        }}
                                        onMouseLeave={() => {
                                          setAnchorElRisks(null);
                                        }}
                                      >
                                        {selectedDeal?.customFields?.topRisks &&
                                        selectedDeal?.customFields?.topRisks
                                          ?.length > 0
                                          ? selectedDeal?.customFields?.topRisks?.map(
                                              (risk) => (
                                                <Chip
                                                  key={risk?.id}
                                                  label={risk?.riskTitle}
                                                  size="small"
                                                />
                                              ),
                                            )
                                          : '--'}
                                      </Typography>
                                      <Popper
                                        id="mouse-over-popover"
                                        sx={{
                                          pointerEvents: 'none',
                                          zIndex: 1111111,
                                        }}
                                        open={Boolean(anchorElRisks)}
                                        anchorEl={anchorElRisks}
                                        placement="bottom"
                                        onClose={() => {
                                          setAnchorElRisks(null);
                                        }}
                                        // disableRestoreFocus
                                      >
                                        <Box
                                          sx={{
                                            border: '1px solid #d3d3d3',
                                            borderRadius: 1,
                                            padding: 1,
                                            background: '#fff',
                                            // maxWidth: 400,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1,
                                            // boxShadow: theme.shadows[1],
                                          }}
                                        >
                                          {selectedDeal?.customFields?.topRisks?.map(
                                            (risk) => (
                                              <Chip
                                                key={risk?.id}
                                                label={risk?.riskTitle}
                                                size="small"
                                              />
                                            ),
                                          )}
                                        </Box>
                                      </Popper>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Deal Stage
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.qaiDealStage?.name ||
                                          '--'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Divider orientation="horizontal" flexItem />
                              <Box
                                sx={{
                                  paddingX: 1,
                                  marginTop: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 1,
                                }}
                              >
                                <Typography
                                  color={'text.secondary'}
                                  fontWeight={'bold'}
                                  sx={{ fontSize: 18 }}
                                >
                                  Execution Guidance
                                </Typography>
                                <NextBestActions
                                  type={'recent'}
                                  dealId={selectedDeal?.id}
                                  dealArtifactsLoading={false}
                                  noArtifacts={artifacts?.length === 0}
                                  readOnly={true}
                                  activeArtifact={recentArtifactWithNBA}
                                  // setCurrentArtifactDetailTab={
                                  //   setCurrentArtifactDetailTab
                                  // }
                                  // setActiveArtifactTab={setActiveArtifactTab}
                                />
                              </Box>
                            </Box>
                          ) : null
                        ) : viewType === 'ragTesting' ? (
                          <RagTestingView
                            selectedOrganization={organizations?.find(
                              (org) => org?.id === selectedOrganization,
                            )}
                            selectedDeal={selectedDeal}
                          />
                        ) : currentArtifactTab === 'artifactContent' ? (
                          <Typography
                            sx={{
                              whiteSpace: 'pre-wrap',
                              padding: 2,
                            }}
                          >
                            {selectedArtifact?.mediaFileBasedInteraction
                              ? parse(
                                  selectedArtifact?.customField?.salesReviewFile?.transcript?.replace(
                                    new RegExp(
                                      '(([0-5])?[0-9]):([0-5][0-9])',
                                      'gmi',
                                    ),
                                    (highlight) => {
                                      return `<button class="highlight">${highlight}</button>`;
                                    },
                                  ) || '',
                                )
                              : selectedArtifact?.content}
                          </Typography>
                        ) : currentArtifactTab === 'artifactSummary' ? (
                          <Typography
                            sx={{
                              whiteSpace: 'pre-wrap',
                              padding: 2,
                              flex: 1,
                            }}
                          >
                            {selectedArtifact?.mediaFileBasedInteraction
                              ? selectedArtifact?.customField?.salesReviewFile
                                  ?.analysis?.methodAnalysis?.['callSummary']
                                  ?.analysisHtml
                                ? parse(
                                    selectedArtifact?.customField
                                      ?.salesReviewFile?.analysis
                                      ?.methodAnalysis?.['callSummary']
                                      ?.analysisHtml ||
                                      'Not able to generate summary',
                                  )
                                : selectedArtifact?.customField?.salesReviewFile
                                    ?.analysis?.methodAnalysis?.['callSummary']
                                    ?.analysis || 'Not able to generate summary'
                              : artifactTypesWithoutMedia?.includes(
                                  selectedArtifact?.interactionType,
                                )
                              ? selectedArtifact?.interactionSummaryShort ||
                                'Not able to generate summary'
                              : parse(
                                  selectedArtifact?.interactionSummaryHtml ||
                                    'Not able to generate summary',
                                )}
                          </Typography>
                        ) : currentArtifactTab === 'artifactOverview' ? (
                          selectedArtifact?.discoveryTreeStatus === null ||
                          selectedArtifact?.discoveryTreeStatus ===
                            'in_process' ? (
                            <Box
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 10,
                                textAlign: 'center',
                              }}
                            >
                              <CircularProgress size={16} />
                              <Typography>
                                Overview generation is in progress ...
                              </Typography>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                              }}
                            >
                              <Typography color={'textSecondary'}>
                                Artifact Summary
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                {selectedArtifact?.interactionSummary?.map(
                                  (summary) => {
                                    return (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: 1,
                                        }}
                                      >
                                        <Typography color={'textSecondary'}>
                                          {summary?.title}
                                        </Typography>
                                        <Typography>
                                          {summary?.summary}
                                        </Typography>
                                      </Box>
                                    );
                                  },
                                )}
                              </Box>
                              <Typography color={'textSecondary'}>
                                Answers from Artifact
                              </Typography>
                              <TableContainer
                                component={Paper}
                                sx={
                                  {
                                    // minHeight: 'calc(100vh - 120px)',
                                    // maxHeight: 'calc(100vh - 120px)',
                                    // overflowY: 'scroll',
                                    // '&::-webkit-scrollbar': {
                                    //   width: '5px',
                                    // },
                                    // '&::-webkit-scrollbar-track': {
                                    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                    //   webkitBoxShadow:
                                    //     'inset 0 0 6px rgba(0,0,0,0.00)',
                                    // },
                                    // '&::-webkit-scrollbar-thumb': {
                                    //   backgroundColor: theme.palette.primary.main,
                                    //   borderRadius: 2,
                                    // },
                                  }
                                }
                                // onScroll={handleListScroll}
                              >
                                <Table
                                  sx={{ minWidth: 750 }}
                                  stickyHeader
                                  aria-label="simple table"
                                >
                                  <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                                    <TableRow>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Topic
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Subtopic
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Question
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Answer
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Reasoning
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Weighted Score
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Confidence Score
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {Object.values(
                                      selectedArtifact?.interactionAnswers ||
                                        {},
                                    ) &&
                                    Object.values(
                                      selectedArtifact?.interactionAnswers ||
                                        {},
                                    )?.length > 0
                                      ? Object.values(
                                          selectedArtifact?.interactionAnswers ||
                                            {},
                                        )?.map((ia, i) => (
                                          <TableRow
                                            key={i}
                                            // sx={{
                                            //   '&:last-child td, &:last-child th': {
                                            //     border: 0,
                                            //   },
                                            // }}
                                          >
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.topic?.topic}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {
                                                  ia?.treeDetails?.subTopic
                                                    ?.topic
                                                }
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.q}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.sa === 'y'
                                                  ? 'Yes'
                                                  : ia?.sa === 'n'
                                                  ? 'No'
                                                  : '--'}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.rsa}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              align="center"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.wus?.toFixed(
                                                  2,
                                                )}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              align="center"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.cus
                                                  ? ia?.treeDetails?.question?.cus?.toFixed(
                                                      2,
                                                    )
                                                  : '--'}
                                              </Typography>
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      : null}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Typography color={'textSecondary'}>
                                Buyers Reference
                              </Typography>
                              <Box sx={{ padding: 1 }}>
                                {selectedArtifact?.buyersReference?.length > 0
                                  ? selectedArtifact?.buyersReference?.map(
                                      (br) => (
                                        <Grid container spacing={1}>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              Buyer Name
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              Mention
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              {br?.buyer}
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              {br?.mentions}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      ),
                                    )
                                  : null}
                              </Box>
                            </Box>
                          )
                        ) : currentArtifactTab === 'artifactTree' ? (
                          selectedArtifact?.discoveryTreeStatus === null ||
                          selectedArtifact?.discoveryTreeStatus ===
                            'in_process' ? (
                            <Box
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 10,
                                textAlign: 'center',
                              }}
                            >
                              <CircularProgress size={16} />
                              <Typography>
                                Discovery tree delta generation is in progress
                                ...
                              </Typography>
                            </Box>
                          ) : (
                            <Box position={'relative'}>
                              {selectedDeal?.topics &&
                              selectedDeal?.topics.length > 0 ? (
                                <QuestionFrameworkTree
                                  data={selectedDeal.topics}
                                  dealTree={true}
                                  interactionAnswers={
                                    selectedArtifact?.interactionAnswers
                                  }
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: 300,
                                    gap: 2,
                                  }}
                                >
                                  <Typography>
                                    No question tree found
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          )
                        ) : currentArtifactTab === 'prompt' ? (
                          <>
                            {artifactPrompts && artifactPrompts?.length > 0 ? (
                              <Box
                                display={'flex'}
                                flexDirection={'column'}
                                gap={2}
                              >
                                <FormControl
                                  size="small"
                                  sx={{ minWidth: 150 }}
                                >
                                  <InputLabel id="promptType">
                                    Prompt Type
                                  </InputLabel>
                                  <Select
                                    variant="outlined"
                                    size="small"
                                    labelId={'promptType'}
                                    label={'Artifact Prompt'}
                                    id={'promptType'}
                                    name={'promptType'}
                                    MenuProps={{ disableScrollLock: true }}
                                    onChange={(e) => {
                                      setSelectedArtifactPrompt(e.target.value);
                                    }}
                                    value={selectedArtifactPrompt}
                                  >
                                    {artifactPrompts.map((key) => (
                                      <MenuItem key={key} value={key}>
                                        <Typography variant="subtitle2">
                                          {capitalizeText(
                                            key?.split('_').join(' '),
                                          )}
                                        </Typography>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: 2,
                                    gap: 2,
                                    border: '1px solid #d3d3d3',

                                    minHeight: 'calc(100vh - 310px)',
                                    maxHeight: 'calc(100vh - 310px)',
                                    overflowY: 'scroll',
                                    '&::-webkit-scrollbar': {
                                      width: '5px',
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                      boxShadow:
                                        'inset 0 0 6px rgba(0,0,0,0.00)',
                                      webkitBoxShadow:
                                        'inset 0 0 6px rgba(0,0,0,0.00)',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      borderRadius: 2,
                                      // outline: '1px solid slategrey',
                                    },
                                  }}
                                >
                                  {selectedArtifact?.customField?.metadata?.[
                                    selectedArtifactPrompt
                                  ]?.messages?.map((msg, index) => (
                                    <>
                                      {msg ? (
                                        <Box
                                          key={msg?.content}
                                          sx={{
                                            borderTopLeftRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 16
                                                : 0,
                                            borderTopRightRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 0
                                                : 16,
                                            borderBottomLeftRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 8
                                                : 16,
                                            borderBottomRightRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 16
                                                : 8,
                                            minWidth: '80%',
                                            maxWidth: '80%',
                                            alignSelf:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 'end'
                                                : 'start',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // gap: 1,
                                            boxShadow: theme.shadows[8],
                                            background:
                                              msg?.role === 'user'
                                                ? theme.palette.primary.main
                                                : msg?.role === 'system'
                                                ? '#aaa'
                                                : '#fff',
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            alignItems={'center'}
                                            justifyContent={'space-between'}
                                            sx={{
                                              padding: '8px 16px',
                                              gap: 4,
                                              width: 1,
                                              cursor: 'pointer',
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                expandedPromptSections?.includes(
                                                  index,
                                                )
                                              ) {
                                                setExpandedPromptSections(
                                                  (prev) =>
                                                    prev?.filter(
                                                      (id) => id !== index,
                                                    ),
                                                );
                                              } else {
                                                setExpandedPromptSections(
                                                  (prev) => [...prev, index],
                                                );
                                              }
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                              }}
                                            >
                                              {expandedPromptSections?.includes(
                                                index,
                                              ) ? (
                                                <ExpandMore
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : msg?.role === 'system'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              ) : (
                                                <ChevronRight
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : msg?.role === 'system'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              )}
                                              {msg?.role === 'user' ? (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#f1f1f1',
                                                  }}
                                                >
                                                  User
                                                </Typography>
                                              ) : msg?.role === 'system' ? (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#f1f1f1',
                                                  }}
                                                >
                                                  Prompt
                                                </Typography>
                                              ) : (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color:
                                                      theme.palette.text
                                                        .secondary,
                                                  }}
                                                >
                                                  {'GPT'}
                                                </Typography>
                                              )}
                                            </Box>
                                            <Tooltip
                                              arrow
                                              placement="top"
                                              title="Copy"
                                            >
                                              <ContentCopy
                                                sx={{
                                                  color:
                                                    msg?.role === 'user'
                                                      ? '#fff'
                                                      : theme.palette.text
                                                          .secondary,
                                                  fontSize: 18,
                                                  cursor: 'pointer',
                                                }}
                                                onClick={async (e) => {
                                                  e.stopPropagation();
                                                  try {
                                                    await navigator.clipboard.writeText(
                                                      msg?.content,
                                                    );
                                                  } catch (err) {
                                                    console.error(
                                                      'Failed to copy: ',
                                                      err,
                                                    );
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          </Box>
                                          {expandedPromptSections?.includes(
                                            index,
                                          ) ? (
                                            <Typography
                                              sx={{
                                                whiteSpace: 'pre-wrap',
                                                color:
                                                  msg?.role === 'user'
                                                    ? '#fff'
                                                    : theme.palette.text
                                                        .primary,
                                                padding: '0px 16px 16px 16px',
                                              }}
                                            >
                                              {msg?.content}
                                            </Typography>
                                          ) : null}
                                        </Box>
                                      ) : null}
                                    </>
                                  ))}
                                </Box>
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  minHeight: 300,
                                  gap: 2,
                                }}
                              >
                                <Typography>No meta data found</Typography>
                              </Box>
                            )}
                          </>
                        ) : currentArtifactTab === 'artifactRisks' &&
                          Object.keys(artifactStatusMap || {})?.indexOf(
                            selectedArtifact?.postProcessingStatus,
                          ) > 9 &&
                          !artifactFailedStatuses?.includes(
                            selectedArtifact?.postProcessingStatus,
                          ) ? (
                          <ArtifactRisksSelectionList
                            viewType={'dealDetails'}
                            readOnly={true}
                            activeArtifact={selectedArtifact}
                            selectedOrganization={selectedOrganization}
                            // successCallback={(
                            //   risks,
                            //   actions,
                            //   artfct,
                            // ) => {
                            //   setSelectedArtifact(
                            //     (prev) => {
                            //       return {
                            //         ...prev,
                            //         selectedRisks: risks,
                            //         nextBestActionsMap: actions,
                            //       };
                            //     },
                            //   );
                            //   if (
                            //     dealArtifacts?.find(
                            //       (artifact) =>
                            //         artifact?.interactionTime >
                            //           artfct?.interactionTime &&
                            //         artifact?.id !==
                            //           artfct?.id &&
                            //         recentArtifactWithNBA?.id ===
                            //           artifact?.id,
                            //     )
                            //   ) {
                            //     // setRecentArtifactWithNBA(
                            //     //   (prev) => {
                            //     //     return {
                            //     //       ...prev,
                            //     //       selectedRisks: risks,
                            //     //       nextBestActionsMap: actions,
                            //     //     };
                            //     //   },
                            //     // );
                            //     setCurrentArtifactDetailTab(
                            //       'actions',
                            //     );
                            //   } else {
                            //     setRecentArtifactWithNBA(
                            //       (prev) => {
                            //         return {
                            //           ...prev,
                            //           selectedRisks: risks,
                            //           nextBestActionsMap: actions,
                            //         };
                            //       },
                            //     );
                            //     setCurrentArtifactDetailTab(
                            //       'summary',
                            //     );
                            //   }
                            //   setDealArtifacts(
                            //     (prev) => {
                            //       return prev.map(
                            //         (artifact) => {
                            //           if (
                            //             artifact?.id ===
                            //             artfct?.id
                            //           ) {
                            //             return {
                            //               ...artifact,
                            //               selectedRisks: risks,
                            //               nextBestActionsMap: actions,
                            //               postProcessingStatus:
                            //                 'interaction_nba_completed',
                            //             };
                            //           }
                            //           return artifact;
                            //         },
                            //       );
                            //     },
                            //   );
                            // }}
                          />
                        ) : currentArtifactTab === 'artifactNBAs' &&
                          Object.keys(artifactStatusMap || {})?.indexOf(
                            selectedArtifact?.postProcessingStatus,
                          ) > 9 &&
                          !artifactFailedStatuses?.includes(
                            selectedArtifact?.postProcessingStatus,
                          ) ? (
                          <NextBestActions
                            type={'current'}
                            // dealId={dealId}
                            dealArtifactsLoading={false}
                            noArtifacts={artifacts?.length === 0}
                            readOnly={
                              selectedArtifact?.nextBestActionsMap &&
                              Object.keys(
                                selectedArtifact?.nextBestActionsMap || {},
                              ) &&
                              Object.keys(
                                selectedArtifact?.nextBestActionsMap || {},
                              )?.length > 0
                            }
                            activeArtifact={selectedArtifact}
                            sx={{
                              margin: 2,
                            }}
                            // setCurrentArtifactDetailTab={
                            //   setCurrentArtifactDetailTab
                            // }
                            // setActiveArtifactTab={
                            //   setActiveArtifactTab
                            // }
                          />
                        ) : currentArtifactTab === 'artifactBuyersPOV' ? (
                          <Box
                            sx={{
                              padding: 2,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Reason to Buy
                                </Typography>
                                {selectedArtifact?.buyersPov?.buyersReasonToBuy?.map(
                                  (reasonToBuy, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {reasonToBuy?.reason}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {reasonToBuy?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Reason to Not Buy
                                </Typography>
                                {selectedArtifact?.buyersPov?.buyersReasonToNotBuy?.map(
                                  (reasonToNotBuy, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {reasonToNotBuy?.reason}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {reasonToNotBuy?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Metrics
                                </Typography>
                                {selectedArtifact?.buyersPov?.metrics?.map(
                                  (metric, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {metric?.metrics}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {metric?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Priorities
                                </Typography>
                                {selectedArtifact?.buyersPov?.priorities?.map(
                                  (priority, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography sx={{}}>
                                              {priority?.priority}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {priority?.explanation}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : null}
                      </Box>
                    </Box>
                  ) : null}
                </>
              ) : currentOrgMenu === 'activities' ? (
                <>
                  <Box
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={
                      viewType === 'dealdetails' ||
                      viewType === 'artifactDetails'
                        ? 'flex-start'
                        : 'flex-end'
                    }
                  >
                    {viewType === 'artifactDetails' ? (
                      <Box
                        sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
                      >
                        <Button
                          startIcon={<ArrowBack />}
                          color="primary"
                          variant="outlined"
                          onClick={() => {
                            if (viewType === 'artifactDetails') {
                              setViewType('artifacts');
                            } else {
                              setViewType('activities');
                            }
                          }}
                          sx={{ padding: '4px 8px' }}
                        >
                          Go Back
                        </Button>
                        {viewType === 'artifactDetails' ? (
                          <Typography>
                            {selectedArtifact?.title || '--'}
                          </Typography>
                        ) : null}
                      </Box>
                    ) : null
                    // <Button
                    //   startIcon={<Add />}
                    //   color="primary"
                    //   variant="contained"
                    //   onClick={() => setShowAddDeal(selectedOrganization)}
                    // >
                    //   Add Deal
                    // </Button>
                    }
                  </Box>
                  {viewType === 'artifacts' ? (
                    fetchingArtifacts ? (
                      <Box
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          padding: 10,
                          textAlign: 'center',
                        }}
                      >
                        <CircularProgress size={16} />
                        <Typography>Loading activities ...</Typography>
                      </Box>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          disabled={resettingUnlinkedItems}
                          startIcon={
                            resettingUnlinkedItems ? (
                              <CircularProgress size={16} />
                            ) : null
                          }
                          onClick={() => {
                            setResettingUnlinkedItems(true);
                            dispatch(
                              resetUnlinkedItems(selectedOrganization, () => {
                                setResettingUnlinkedItems(false);
                              }),
                            );
                          }}
                        >
                          Reset Unlinked Items
                        </Button>
                        <TableContainer
                          component={Paper}
                          sx={{
                            minHeight: 'calc(100vh - 260px)',
                            maxHeight: 'calc(100vh - 260px)',
                            overflowY: 'scroll',
                            '&::-webkit-scrollbar': {
                              width: '5px',
                            },
                            '&::-webkit-scrollbar-track': {
                              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: theme.palette.primary.main,
                              borderRadius: 2,
                            },
                          }}
                          // onScroll={handleListScroll}
                        >
                          <Table
                            sx={{ minWidth: 750 }}
                            stickyHeader
                            aria-label="simple table"
                          >
                            <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                              <TableRow>
                                <TableCell>
                                  <Typography
                                    variant={'caption'}
                                    fontWeight={700}
                                    sx={{ textTransform: 'uppercase' }}
                                  >
                                    Title
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant={'caption'}
                                    fontWeight={700}
                                    sx={{ textTransform: 'uppercase' }}
                                  >
                                    Type
                                  </Typography>
                                </TableCell>
                                {/* <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Buyers
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Sellers
                                        </Typography>
                                      </TableCell> */}
                                <TableCell>
                                  <Typography
                                    variant={'caption'}
                                    fontWeight={700}
                                    sx={{ textTransform: 'uppercase' }}
                                  >
                                    Potential
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant={'caption'}
                                    fontWeight={700}
                                    sx={{ textTransform: 'uppercase' }}
                                  >
                                    Date
                                  </Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography
                                    variant={'caption'}
                                    fontWeight={700}
                                    sx={{ textTransform: 'uppercase' }}
                                  >
                                    Actions
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {artifacts.map((artifact, i) => (
                                <TableRow
                                  key={i}
                                  // sx={{
                                  //   '&:last-child td, &:last-child th': {
                                  //     border: 0,
                                  //   },
                                  // }}
                                >
                                  <TableCell component="th" scope="row">
                                    {/* {artifactEditable?.id ===
                                          artifact?.id ? (
                                            <form
                                              onSubmit={(e) => {
                                                e.preventDefault();
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <TextField
                                                  autoFocus
                                                  placeholder="Artifact Title"
                                                  variant="outlined"
                                                  color="primary"
                                                  size="small"
                                                  name="artifactTitle"
                                                  value={artifactTitle}
                                                  onChange={(e) =>
                                                    setArtifactTitle(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                                <Box
                                                  display={'flex'}
                                                  flexDirection={'column'}
                                                  gap={0.5}
                                                >
                                                  <Tooltip
                                                    title="Close"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    <IconButton
                                                      sx={{
                                                        borderRadius: 1,
                                                        color: '#fff',
                                                        width: 16,
                                                        height: 16,
                                                        background:
                                                          theme.palette.text
                                                            .secondary,
                                                        ':hover': {
                                                          backgroundColor:
                                                            theme.palette.text
                                                              .secondary,
                                                        },
                                                      }}
                                                      onClick={() => {
                                                        setArtifactEditable(
                                                          null,
                                                        );
                                                      }}
                                                    >
                                                      <Close
                                                        sx={{ fontSize: 9 }}
                                                      />
                                                    </IconButton>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title="Done"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    {updatingArtifactTitle ? (
                                                      <CircularProgress
                                                        size={14}
                                                        sx={{
                                                          color:
                                                            theme.palette
                                                              .primary.main,
                                                        }}
                                                      />
                                                    ) : (
                                                      <IconButton
                                                        disabled={
                                                          !artifactTitle?.trim() ||
                                                          updatingArtifactTitle
                                                        }
                                                        sx={{
                                                          borderRadius: 1,
                                                          color: '#fff',
                                                          width: 16,
                                                          height: 16,
                                                          background:
                                                            theme.palette
                                                              .primary.main,
                                                          ':hover': {
                                                            backgroundColor:
                                                              theme.palette
                                                                .primary.main,
                                                          },
                                                        }}
                                                        onClick={() => {
                                                          setUpdatingArtifactTitle(
                                                            true,
                                                          );
                                                          dispatch(
                                                            udpateArtifactForDeal(
                                                              selectedOrganization,
                                                              selectedDeal?.id,
                                                              artifactEditable?.id,
                                                              {
                                                                title: artifactTitle,
                                                              },
                                                              (data) => {
                                                                setUpdatingArtifactTitle(
                                                                  false,
                                                                );
                                                                setArtifactEditable(
                                                                  null,
                                                                );
                                                                setArtifacts(
                                                                  (prev) => {
                                                                    return prev.map(
                                                                      (
                                                                        artifact,
                                                                      ) => {
                                                                        if (
                                                                          artifact?.id ===
                                                                          data?.id
                                                                        ) {
                                                                          return data;
                                                                        }
                                                                        return artifact;
                                                                      },
                                                                    );
                                                                  },
                                                                );
                                                              },
                                                            ),
                                                          );
                                                        }}
                                                      >
                                                        <Check
                                                          sx={{ fontSize: 9 }}
                                                        />
                                                      </IconButton>
                                                    )}
                                                  </Tooltip>
                                                </Box>
                                              </Box>
                                            </form>
                                          ) : ( */}
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                      }}
                                    >
                                      {/* <Tooltip
                                    arrow
                                    placement="top"
                                    title={'Click to update artifact title'}
                                  > */}
                                      <Typography
                                        variant={'subtitle2'}
                                        // fontWeight={700}
                                        sx={{
                                          cursor: 'pointer',
                                          maxWidth: 200,
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: '-webkit-box',
                                          WebkitLineClamp: '1',
                                          WebkitBoxOrient: 'vertical',
                                        }}
                                        // onClick={() => {
                                        //   setArtifactEditable(artifact);
                                        // }}
                                      >
                                        {artifact?.title || '--'}
                                      </Typography>
                                      {/* </Tooltip> */}
                                      {artifact?.customField?.emails?.length >
                                      0 ? (
                                        <Tooltip
                                          arrow
                                          placement="top"
                                          title={`${
                                            artifact?.customField?.emails
                                              ?.length
                                          } more email${
                                            artifact?.customField?.emails
                                              ?.length > 1
                                              ? 's'
                                              : ''
                                          }`}
                                        >
                                          <Chip
                                            size="small"
                                            label={`+${artifact?.customField?.emails?.length}`}
                                            // clickable
                                            // onClick={(e) => {
                                            //   e.stopPropagation();
                                            //   setShowArtifactDetails(
                                            //     ar,
                                            //   );
                                            // }}
                                          />
                                        </Tooltip>
                                      ) : (
                                        ''
                                      )}
                                    </Box>
                                    {/* )} */}
                                  </TableCell>
                                  <TableCell component="th" scope="row">
                                    <Typography
                                      variant={'subtitle2'}
                                      // fontWeight={700}
                                    >
                                      {capitalizeText(
                                        artifact?.interactionType
                                          ?.split('-')
                                          ?.join(' '),
                                      )}
                                    </Typography>
                                  </TableCell>
                                  <TableCell component="th" scope="row">
                                    <Typography
                                      variant={'subtitle2'}
                                      // fontWeight={700}
                                    >
                                      {capitalizeText(artifact?.dealPotential)}
                                    </Typography>
                                  </TableCell>
                                  {/* <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.buyers?.join(', ')}
                                          </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.sellers?.join(', ')}
                                          </Typography>
                                        </TableCell> */}
                                  <TableCell component="th" scope="row">
                                    <Typography
                                      variant={'caption'}
                                      // fontWeight={700}
                                    >
                                      {artifact?.interactionTime
                                        ? moment(
                                            artifact?.interactionTime,
                                          ).format('DD MMMM YYYY hh:mm:ss A')
                                        : '--'}
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="center"
                                  >
                                    <Box
                                      display={'flex'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      gap={1}
                                    >
                                      <Tooltip
                                        arrow
                                        placement="top"
                                        title="Artifact Details"
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setViewType('artifactDetails');
                                            setCurrentArtifactTab(
                                              'artifactContent',
                                            );
                                            setSelectedArtifact(artifact);
                                          }}
                                        >
                                          <Article sx={{ fontSize: 20 }} />
                                        </IconButton>
                                      </Tooltip>
                                      {/* <Tooltip
                                              arrow
                                              placement="top"
                                              title="Remove"
                                            >
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setShowConfirmDeleteArtifact(
                                                    artifact?.id,
                                                  );
                                                }}
                                              >
                                                <Delete sx={{ fontSize: 20 }} />
                                              </IconButton>
                                            </Tooltip> */}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                            <TableFooter>
                              <TableRow>
                                <TableCell
                                  variant="footer"
                                  colSpan={6}
                                  sx={{
                                    padding: 0,
                                  }}
                                >
                                  {fetchingPagination ? (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        padding: 1,
                                        textAlign: 'center',
                                      }}
                                    >
                                      <Button
                                        size="small"
                                        variant="contained"
                                        // type="submit"
                                        color="primary"
                                        onClick={handleListScroll}
                                        // className="searchSettings"
                                        disabled
                                        // fullWidth
                                      >
                                        <Typography color="textPrimary">
                                          Loading more bots ...{' '}
                                        </Typography>
                                        <CircularProgress size={20} />
                                      </Button>
                                    </Box>
                                  ) : emptyList === false &&
                                    deals.length >= 10 ? (
                                    <Box
                                      sx={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        padding: 1,
                                        textAlign: 'center',
                                      }}
                                    >
                                      <Button
                                        size="small"
                                        variant="contained"
                                        // type="submit"
                                        // fullWidth
                                        color="primary"
                                        // onClick={(e) => handleListScroll(e, true)}
                                        // className="searchSettings"
                                      >
                                        Load More
                                      </Button>
                                    </Box>
                                  ) : null}
                                </TableCell>
                              </TableRow>
                            </TableFooter>
                          </Table>
                        </TableContainer>
                      </>
                    )
                  ) : viewType === 'artifactDetails' ? (
                    <Box>
                      {viewType === 'dealdetails' ? (
                        <Tabs
                          value={currentDealTab}
                          onChange={(e, newValue) =>
                            setCurrentDealTab(newValue)
                          }
                          aria-label="Current Deal Tabs"
                          orientation={'horizontal'}
                          // indicatorColor={theme.palette.background.default}
                          variant="scrollable"
                          // scrollButtons={!isMd}
                          allowScrollButtonsMobile
                          sx={{
                            border: '1px solid #d3d3d3',
                          }}
                        >
                          <Tab
                            value={'artifacts'}
                            label={
                              <Typography variant="body1">
                                Activities
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />

                          {/* <Tab
                            value={'uploadArtifact'}
                            label={
                              <Typography variant="body1">
                                Upload Artifact
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          /> */}
                          <Tab
                            value={'details'}
                            label={
                              <Typography variant="body1">
                                Deal Details
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'tree'}
                            label={
                              <Typography variant="body1">Tree</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          {/* <Tab
                          value={'prompts'}
                          label={
                            <Typography variant="body1">Prompts</Typography>
                          }
                          id={`simple-tab-${0}`}
                          aria-controls={`simple-tabpanel-${0}`}
                          sx={{}}
                        /> */}
                        </Tabs>
                      ) : (
                        <Tabs
                          value={currentArtifactTab}
                          onChange={(e, newValue) =>
                            setCurrentArtifactTab(newValue)
                          }
                          aria-label="Current Artifact Tabs"
                          orientation={'horizontal'}
                          // indicatorColor={theme.palette.background.default}
                          variant="scrollable"
                          // scrollButtons={!isMd}
                          allowScrollButtonsMobile
                          sx={{
                            border: '1px solid #d3d3d3',
                          }}
                        >
                          <Tab
                            value={'artifactSummary'}
                            label={
                              <Typography variant="body1">Summary</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactContent'}
                            label={
                              <Typography variant="body1">
                                {artifactTypesWithoutMedia.includes(
                                  selectedArtifact?.interactionType,
                                )
                                  ? 'Content'
                                  : 'Transcript'}
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactBuyersPOV'}
                            label={
                              <Typography variant="body1">
                                Buyers POV
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactRisks'}
                            label={
                              <Typography variant="body1">Risks</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactNBAs'}
                            label={
                              <Typography variant="body1">
                                Recommended Actions
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactOverview'}
                            label={
                              <Typography variant="body1">Overview</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'artifactTree'}
                            label={
                              <Typography variant="body1">
                                Tree(Cummulative deltas)
                              </Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          <Tab
                            value={'prompt'}
                            label={
                              <Typography variant="body1">Prompt</Typography>
                            }
                            id={`simple-tab-${0}`}
                            aria-controls={`simple-tabpanel-${0}`}
                            sx={{}}
                          />
                          {/* <Tab
                        value={'prompts'}
                        label={
                          <Typography variant="body1">Prompts</Typography>
                        }
                        id={`simple-tab-${0}`}
                        aria-controls={`simple-tabpanel-${0}`}
                        sx={{}}
                      /> */}
                        </Tabs>
                      )}
                      <Box
                        sx={{
                          minHeight: 'calc(100vh - 220px)',
                          maxHeight: 'calc(100vh - 220px)',
                          overflowY: 'scroll',
                          '&::-webkit-scrollbar': {
                            width: '5px',
                          },
                          '&::-webkit-scrollbar-track': {
                            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 2,
                          },
                          border: '1px solid #d3d3d3',
                          padding: 2,
                        }}
                      >
                        {viewType === 'dealdetails' ? (
                          currentDealTab === 'artifacts' ? (
                            fetchingArtifacts ? (
                              <Box
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  padding: 10,
                                  textAlign: 'center',
                                }}
                              >
                                <CircularProgress size={16} />
                                <Typography>Loading activities ...</Typography>
                              </Box>
                            ) : (
                              <TableContainer
                                component={Paper}
                                sx={{
                                  minHeight: 'calc(100vh - 260px)',
                                  maxHeight: 'calc(100vh - 260px)',
                                  overflowY: 'scroll',
                                  '&::-webkit-scrollbar': {
                                    width: '5px',
                                  },
                                  '&::-webkit-scrollbar-track': {
                                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                    webkitBoxShadow:
                                      'inset 0 0 6px rgba(0,0,0,0.00)',
                                  },
                                  '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: theme.palette.primary.main,
                                    borderRadius: 2,
                                  },
                                }}
                                // onScroll={handleListScroll}
                              >
                                <Table
                                  sx={{ minWidth: 750 }}
                                  stickyHeader
                                  aria-label="simple table"
                                >
                                  <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                                    <TableRow>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Title
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Type
                                        </Typography>
                                      </TableCell>
                                      {/* <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Buyers
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Sellers
                                        </Typography>
                                      </TableCell> */}
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Date
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Actions
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {artifacts.map((artifact, i) => (
                                      <TableRow
                                        key={i}
                                        // sx={{
                                        //   '&:last-child td, &:last-child th': {
                                        //     border: 0,
                                        //   },
                                        // }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {/* {artifactEditable?.id ===
                                          artifact?.id ? (
                                            <form
                                              onSubmit={(e) => {
                                                e.preventDefault();
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <TextField
                                                  autoFocus
                                                  placeholder="Artifact Title"
                                                  variant="outlined"
                                                  color="primary"
                                                  size="small"
                                                  name="artifactTitle"
                                                  value={artifactTitle}
                                                  onChange={(e) =>
                                                    setArtifactTitle(
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                                <Box
                                                  display={'flex'}
                                                  flexDirection={'column'}
                                                  gap={0.5}
                                                >
                                                  <Tooltip
                                                    title="Close"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    <IconButton
                                                      sx={{
                                                        borderRadius: 1,
                                                        color: '#fff',
                                                        width: 16,
                                                        height: 16,
                                                        background:
                                                          theme.palette.text
                                                            .secondary,
                                                        ':hover': {
                                                          backgroundColor:
                                                            theme.palette.text
                                                              .secondary,
                                                        },
                                                      }}
                                                      onClick={() => {
                                                        setArtifactEditable(
                                                          null,
                                                        );
                                                      }}
                                                    >
                                                      <Close
                                                        sx={{ fontSize: 9 }}
                                                      />
                                                    </IconButton>
                                                  </Tooltip>
                                                  <Tooltip
                                                    title="Done"
                                                    arrow
                                                    placement="right"
                                                  >
                                                    {updatingArtifactTitle ? (
                                                      <CircularProgress
                                                        size={14}
                                                        sx={{
                                                          color:
                                                            theme.palette
                                                              .primary.main,
                                                        }}
                                                      />
                                                    ) : (
                                                      <IconButton
                                                        disabled={
                                                          !artifactTitle?.trim() ||
                                                          updatingArtifactTitle
                                                        }
                                                        sx={{
                                                          borderRadius: 1,
                                                          color: '#fff',
                                                          width: 16,
                                                          height: 16,
                                                          background:
                                                            theme.palette
                                                              .primary.main,
                                                          ':hover': {
                                                            backgroundColor:
                                                              theme.palette
                                                                .primary.main,
                                                          },
                                                        }}
                                                        onClick={() => {
                                                          setUpdatingArtifactTitle(
                                                            true,
                                                          );
                                                          dispatch(
                                                            udpateArtifactForDeal(
                                                              selectedOrganization,
                                                              selectedDeal?.id,
                                                              artifactEditable?.id,
                                                              {
                                                                title: artifactTitle,
                                                              },
                                                              (data) => {
                                                                setUpdatingArtifactTitle(
                                                                  false,
                                                                );
                                                                setArtifactEditable(
                                                                  null,
                                                                );
                                                                setArtifacts(
                                                                  (prev) => {
                                                                    return prev.map(
                                                                      (
                                                                        artifact,
                                                                      ) => {
                                                                        if (
                                                                          artifact?.id ===
                                                                          data?.id
                                                                        ) {
                                                                          return data;
                                                                        }
                                                                        return artifact;
                                                                      },
                                                                    );
                                                                  },
                                                                );
                                                              },
                                                            ),
                                                          );
                                                        }}
                                                      >
                                                        <Check
                                                          sx={{ fontSize: 9 }}
                                                        />
                                                      </IconButton>
                                                    )}
                                                  </Tooltip>
                                                </Box>
                                              </Box>
                                            </form>
                                          ) : ( */}
                                          <Tooltip
                                            arrow
                                            placement="top"
                                            title={
                                              'Click to update artifact title'
                                            }
                                          >
                                            <Typography
                                              variant={'subtitle2'}
                                              // fontWeight={700}
                                              sx={{
                                                cursor: 'pointer',
                                                maxWidth: 200,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: '1',
                                                WebkitBoxOrient: 'vertical',
                                              }}
                                              // onClick={() => {
                                              //   setArtifactEditable(artifact);
                                              // }}
                                            >
                                              {artifact?.title || '--'}
                                            </Typography>
                                          </Tooltip>
                                          {/* )} */}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {capitalizeText(
                                              artifact?.interactionType
                                                ?.split('-')
                                                ?.join(' '),
                                            )}
                                          </Typography>
                                        </TableCell>
                                        {/* <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.buyers?.join(', ')}
                                          </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'subtitle2'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.sellers?.join(', ')}
                                          </Typography>
                                        </TableCell> */}
                                        <TableCell component="th" scope="row">
                                          <Typography
                                            variant={'caption'}
                                            // fontWeight={700}
                                          >
                                            {artifact?.interactionTime
                                              ? moment(
                                                  artifact?.interactionTime,
                                                ).format(
                                                  'DD MMMM YYYY hh:mm:ss A',
                                                )
                                              : '--'}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                        >
                                          <Box
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Tooltip
                                              arrow
                                              placement="top"
                                              title="Artifact Details"
                                            >
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setViewType(
                                                    'artifactDetails',
                                                  );
                                                  setCurrentArtifactTab(
                                                    'artifactContent',
                                                  );
                                                  setSelectedArtifact(artifact);
                                                }}
                                              >
                                                <Article
                                                  sx={{ fontSize: 20 }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                            {/* <Tooltip
                                              arrow
                                              placement="top"
                                              title="Remove"
                                            >
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  setShowConfirmDeleteArtifact(
                                                    artifact?.id,
                                                  );
                                                }}
                                              >
                                                <Delete sx={{ fontSize: 20 }} />
                                              </IconButton>
                                            </Tooltip> */}
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                  <TableFooter>
                                    <TableRow>
                                      <TableCell
                                        variant="footer"
                                        colSpan={6}
                                        sx={{
                                          padding: 0,
                                        }}
                                      >
                                        {fetchingPagination ? (
                                          <Box
                                            sx={{
                                              width: '100%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              padding: 1,
                                              textAlign: 'center',
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="contained"
                                              // type="submit"
                                              color="primary"
                                              onClick={handleListScroll}
                                              // className="searchSettings"
                                              disabled
                                              // fullWidth
                                            >
                                              <Typography color="textPrimary">
                                                Loading more bots ...{' '}
                                              </Typography>
                                              <CircularProgress size={20} />
                                            </Button>
                                          </Box>
                                        ) : emptyList === false &&
                                          deals.length >= 10 ? (
                                          <Box
                                            sx={{
                                              width: '100%',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              padding: 1,
                                              textAlign: 'center',
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="contained"
                                              // type="submit"
                                              // fullWidth
                                              color="primary"
                                              // onClick={(e) => handleListScroll(e, true)}
                                              // className="searchSettings"
                                            >
                                              Load More
                                            </Button>
                                          </Box>
                                        ) : null}
                                      </TableCell>
                                    </TableRow>
                                  </TableFooter>
                                </Table>
                              </TableContainer>
                            )
                          ) : currentDealTab === 'uploadArtifact' ? (
                            <Box>
                              {/* <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Box
                                  display={'flex'}
                                  flexDirection={'column'}
                                  // gap={2}
                                >
                                  <TextField
                                    label="Artifact Title"
                                    variant="outlined"
                                    name={'artifactTitle'}
                                    size="small"
                                    fullWidth
                                    value={artifactTitle}
                                    onChange={(e) =>
                                      setArtifactTitle(e.target.value)
                                    }
                                  />
                                  <FormControl size="small">
                                    <FormLabel id="demo-row-radio-buttons-group-label">
                                      <Typography variant="caption">
                                        Artifact Type
                                      </Typography>
                                    </FormLabel>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                      value={artifactType || ''}
                                      onChange={(e) =>
                                        setArtifactType(e.target.value)
                                      }
                                    >
                                      <FormControlLabel
                                        value={'transcript'}
                                        control={<Radio size="small" />}
                                        label={'Transcript'}
                                      />
                                      <FormControlLabel
                                        value={'email'}
                                        control={<Radio size="small" />}
                                        label={'Email'}
                                      />
                                      <FormControlLabel
                                        value={'note'}
                                        control={<Radio size="small" />}
                                        label={'Note'}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  <Box>
                                    <Typography
                                      variant="caption"
                                      color={'text.secondary'}
                                    >
                                      Artifact Time
                                    </Typography>
                                    <br />
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DateTimePicker
                                        // label="Meeting Time"
                                        size="small"
                                        value={dayjs(artifactTime)}
                                        onChange={(newValue) => {
                                          console.log(
                                            new Date(newValue).getTime(),
                                          );
                                          setArtifactTime(
                                            new Date(newValue).getTime(),
                                          );
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </Box>
                                </Box>
                                <TextField
                                  label="Buyer's Participants(Comma Seperated)"
                                  variant="outlined"
                                  name={'buyerParticipants'}
                                  size="small"
                                  fullWidth
                                  value={buyerParticipants}
                                  onChange={(e) =>
                                    setBuyerParticipants(e.target.value)
                                  }
                                />
                                <TextField
                                  label="Seller's Participants(Comma Seperated)"
                                  variant="outlined"
                                  name={'sellerParticipants'}
                                  size="small"
                                  fullWidth
                                  value={sellerParticipants}
                                  onChange={(e) =>
                                    setSellerParticipants(e.target.value)
                                  }
                                />
                                <TextField
                                  label="Content"
                                  variant="outlined"
                                  name={'artifactContent'}
                                  size="small"
                                  fullWidth
                                  multiline
                                  rows={8}
                                  value={artifactContent}
                                  onChange={(e) =>
                                    setArtifactContent(e.target.value)
                                  }
                                />
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    disabled={
                                      generatingValueProp ||
                                      creatingDiscoverytree
                                    }
                                    startIcon={
                                      creatingDiscoverytree ? (
                                        <CircularProgress size={20} />
                                      ) : null
                                    }
                                    onClick={(e) => {
                                      setAddingArtifactForDeal(true);
                                      dispatch(
                                        addArtifactForDeal(
                                          selectedOrganization,
                                          selectedDeal?.id,
                                          {
                                            buyers:
                                              buyerParticipants?.split(',') ||
                                              [],
                                            sellers:
                                              sellerParticipants?.split(',') ||
                                              [],
                                            content: artifactContent,
                                            interactionType: artifactType,
                                            interactionTime: artifactTime,
                                            title: artifactTitle,
                                          },
                                          (data) => {
                                            setArtifactType('transcript');
                                            setArtifactContent('');
                                            setBuyerParticipants('');
                                            setSellerParticipants('');
                                            setAddingArtifactForDeal(false);
                                            setShowUploadArtifact(false);
                                            setCurrentDealTab('artifacts');
                                          },
                                        ),
                                      );
                                    }}
                                    color="primary"
                                    autoFocus
                                  >
                                    Upload
                                  </Button>
                                </Box>
                              </Box> */}
                            </Box>
                          ) : currentDealTab === 'tree' ? (
                            <Box
                              display={'flex'}
                              flexDirection={'column'}
                              gap={2}
                              position={'relative'}
                            >
                              {selectedDeal?.topics &&
                              selectedDeal?.topics.length > 0 ? (
                                <QuestionFrameworkTree
                                  data={selectedDeal.topics}
                                  dealTree={true}
                                  showExportButton={true}
                                  treeId={selectedOrganization}
                                  dealId={selectedDeal?.id}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: 300,
                                    gap: 2,
                                  }}
                                >
                                  <Typography>
                                    No question tree found
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          ) : currentDealTab === 'details' ? (
                            <Box>
                              <Box
                                sx={{
                                  paddingX: 1,
                                  display: 'flex',
                                  gap: 2,
                                  paddingY: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                    flex: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <Typography
                                      color={'text.secondary'}
                                      fontWeight={'bold'}
                                      sx={{ fontSize: 18 }}
                                    >
                                      Summary
                                    </Typography>
                                  </Box>
                                  <Typography
                                    sx={{
                                      minHeight: 200,
                                      maxHeight: 200,
                                      overflowY: 'auto',
                                      '&::-webkit-scrollbar': {
                                        width: '5px',
                                      },
                                      '&::-webkit-scrollbar-track': {
                                        boxShadow:
                                          'inset 0 0 6px rgba(0,0,0,0.00)',
                                        webkitBoxShadow:
                                          'inset 0 0 6px rgba(0,0,0,0.00)',
                                      },
                                      '&::-webkit-scrollbar-thumb': {
                                        backgroundColor:
                                          theme.palette.primary.main,
                                        borderRadius: 2,
                                      },
                                      borderRight: '1px solid #d3d3d3',
                                      color: !selectedDeal?.overallDealSummary
                                        ? 'text.secondary'
                                        : 'text.primary',
                                    }}
                                  >
                                    {selectedDeal?.overallDealSummary ||
                                      'No summary generated yet.'}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    gap: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      flex: 1,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Deal Size
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.amount?.amount
                                          ? `${
                                              selectedDeal?.amount?.currency ===
                                              'usd'
                                                ? '$'
                                                : selectedDeal?.amount
                                                    ?.currency === 'inr'
                                                ? '₹'
                                                : '$'
                                            }
              ${selectedDeal?.amount?.amount || '--'}`
                                          : '--'}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Expected Close Date
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.closeOn
                                          ? moment(
                                              selectedDeal?.closeOn,
                                            ).format('MM/DD/YYYY')
                                          : '--'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      flex: 1,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 2,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Top Risks
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{
                                          textAlign: 'center',
                                          fontSize: 22,
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: '-webkit-box',
                                          WebkitLineClamp: '1',
                                          WebkitBoxOrient: 'vertical',
                                          cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => {
                                          setAnchorElRisks(e.currentTarget);
                                        }}
                                        onMouseLeave={() => {
                                          setAnchorElRisks(null);
                                        }}
                                      >
                                        {selectedDeal?.customFields?.topRisks &&
                                        selectedDeal?.customFields?.topRisks
                                          ?.length > 0
                                          ? selectedDeal?.customFields?.topRisks?.map(
                                              (risk) => (
                                                <Chip
                                                  key={risk?.id}
                                                  label={risk?.riskTitle}
                                                  size="small"
                                                />
                                              ),
                                            )
                                          : '--'}
                                      </Typography>
                                      <Popper
                                        id="mouse-over-popover"
                                        sx={{
                                          pointerEvents: 'none',
                                          zIndex: 1111111,
                                        }}
                                        open={Boolean(anchorElRisks)}
                                        anchorEl={anchorElRisks}
                                        placement="bottom"
                                        onClose={() => {
                                          setAnchorElRisks(null);
                                        }}
                                        // disableRestoreFocus
                                      >
                                        <Box
                                          sx={{
                                            border: '1px solid #d3d3d3',
                                            borderRadius: 1,
                                            padding: 1,
                                            background: '#fff',
                                            // maxWidth: 400,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1,
                                            // boxShadow: theme.shadows[1],
                                          }}
                                        >
                                          {selectedDeal?.customFields?.topRisks?.map(
                                            (risk) => (
                                              <Chip
                                                key={risk?.id}
                                                label={risk?.riskTitle}
                                                size="small"
                                              />
                                            ),
                                          )}
                                        </Box>
                                      </Popper>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 1,
                                        background: '#f1f1f1',
                                        borderRadius: 2,
                                        padding: 1,
                                      }}
                                    >
                                      <Typography
                                        color={'text.secondary'}
                                        sx={{ fontSize: 14 }}
                                      >
                                        Deal Stage
                                      </Typography>
                                      <Typography
                                        // color={'text.secondary'}
                                        sx={{ fontSize: 22 }}
                                      >
                                        {selectedDeal?.qaiDealStage?.name ||
                                          '--'}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Divider orientation="horizontal" flexItem />
                              <Box
                                sx={{
                                  paddingX: 1,
                                  marginTop: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 1,
                                }}
                              >
                                <Typography
                                  color={'text.secondary'}
                                  fontWeight={'bold'}
                                  sx={{ fontSize: 18 }}
                                >
                                  Execution Guidance
                                </Typography>
                                <NextBestActions
                                  type={'recent'}
                                  dealId={selectedDeal?.id}
                                  dealArtifactsLoading={false}
                                  noArtifacts={artifacts?.length === 0}
                                  readOnly={true}
                                  activeArtifact={recentArtifactWithNBA}
                                  // setCurrentArtifactDetailTab={
                                  //   setCurrentArtifactDetailTab
                                  // }
                                  // setActiveArtifactTab={setActiveArtifactTab}
                                />
                              </Box>
                            </Box>
                          ) : null
                        ) : currentArtifactTab === 'artifactContent' ? (
                          <Typography
                            sx={{
                              whiteSpace: 'pre-wrap',
                              padding: 2,
                            }}
                          >
                            {selectedArtifact?.mediaFileBasedInteraction
                              ? parse(
                                  selectedArtifact?.customField?.salesReviewFile?.transcript?.replace(
                                    new RegExp(
                                      '(([0-5])?[0-9]):([0-5][0-9])',
                                      'gmi',
                                    ),
                                    (highlight) => {
                                      return `<button class="highlight">${highlight}</button>`;
                                    },
                                  ) || '',
                                )
                              : selectedArtifact?.content}
                          </Typography>
                        ) : currentArtifactTab === 'artifactSummary' ? (
                          <Typography
                            sx={{
                              whiteSpace: 'pre-wrap',
                              padding: 2,
                              flex: 1,
                            }}
                          >
                            {selectedArtifact?.mediaFileBasedInteraction
                              ? selectedArtifact?.customField?.salesReviewFile
                                  ?.analysis?.methodAnalysis?.['callSummary']
                                  ?.analysisHtml
                                ? parse(
                                    selectedArtifact?.customField
                                      ?.salesReviewFile?.analysis
                                      ?.methodAnalysis?.['callSummary']
                                      ?.analysisHtml ||
                                      'Not able to generate summary',
                                  )
                                : selectedArtifact?.customField?.salesReviewFile
                                    ?.analysis?.methodAnalysis?.['callSummary']
                                    ?.analysis || 'Not able to generate summary'
                              : artifactTypesWithoutMedia?.includes(
                                  selectedArtifact?.interactionType,
                                )
                              ? selectedArtifact?.interactionSummaryShort ||
                                'Not able to generate summary'
                              : parse(
                                  selectedArtifact?.interactionSummaryHtml ||
                                    'Not able to generate summary',
                                )}
                          </Typography>
                        ) : currentArtifactTab === 'artifactOverview' ? (
                          selectedArtifact?.discoveryTreeStatus === null ||
                          selectedArtifact?.discoveryTreeStatus ===
                            'in_process' ? (
                            <Box
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 10,
                                textAlign: 'center',
                              }}
                            >
                              <CircularProgress size={16} />
                              <Typography>
                                Overview generation is in progress ...
                              </Typography>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                              }}
                            >
                              <Typography color={'textSecondary'}>
                                Artifact Summary
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                {selectedArtifact?.interactionSummary?.map(
                                  (summary) => {
                                    return (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: 1,
                                        }}
                                      >
                                        <Typography color={'textSecondary'}>
                                          {summary?.title}
                                        </Typography>
                                        <Typography>
                                          {summary?.summary}
                                        </Typography>
                                      </Box>
                                    );
                                  },
                                )}
                              </Box>
                              <Typography color={'textSecondary'}>
                                Answers from Artifact
                              </Typography>
                              <TableContainer
                                component={Paper}
                                sx={
                                  {
                                    // minHeight: 'calc(100vh - 120px)',
                                    // maxHeight: 'calc(100vh - 120px)',
                                    // overflowY: 'scroll',
                                    // '&::-webkit-scrollbar': {
                                    //   width: '5px',
                                    // },
                                    // '&::-webkit-scrollbar-track': {
                                    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                                    //   webkitBoxShadow:
                                    //     'inset 0 0 6px rgba(0,0,0,0.00)',
                                    // },
                                    // '&::-webkit-scrollbar-thumb': {
                                    //   backgroundColor: theme.palette.primary.main,
                                    //   borderRadius: 2,
                                    // },
                                  }
                                }
                                // onScroll={handleListScroll}
                              >
                                <Table
                                  sx={{ minWidth: 750 }}
                                  stickyHeader
                                  aria-label="simple table"
                                >
                                  <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                                    <TableRow>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Topic
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Subtopic
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Question
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Answer
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Reasoning
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Weighted Score
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography
                                          variant={'caption'}
                                          fontWeight={700}
                                          sx={{ textTransform: 'uppercase' }}
                                        >
                                          Confidence Score
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {Object.values(
                                      selectedArtifact?.interactionAnswers ||
                                        {},
                                    ) &&
                                    Object.values(
                                      selectedArtifact?.interactionAnswers ||
                                        {},
                                    )?.length > 0
                                      ? Object.values(
                                          selectedArtifact?.interactionAnswers ||
                                            {},
                                        )?.map((ia, i) => (
                                          <TableRow
                                            key={i}
                                            // sx={{
                                            //   '&:last-child td, &:last-child th': {
                                            //     border: 0,
                                            //   },
                                            // }}
                                          >
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.topic?.topic}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {
                                                  ia?.treeDetails?.subTopic
                                                    ?.topic
                                                }
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'subtitle2'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.q}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.sa === 'y'
                                                  ? 'Yes'
                                                  : ia?.sa === 'n'
                                                  ? 'No'
                                                  : '--'}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.rsa}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              align="center"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.wus?.toFixed(
                                                  2,
                                                )}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              component="th"
                                              scope="row"
                                              align="center"
                                            >
                                              <Typography
                                                variant={'caption'}
                                                // fontWeight={700}
                                              >
                                                {ia?.treeDetails?.question?.cus
                                                  ? ia?.treeDetails?.question?.cus?.toFixed(
                                                      2,
                                                    )
                                                  : '--'}
                                              </Typography>
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      : null}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Typography color={'textSecondary'}>
                                Buyers Reference
                              </Typography>
                              <Box sx={{ padding: 1 }}>
                                {selectedArtifact?.buyersReference?.length > 0
                                  ? selectedArtifact?.buyersReference?.map(
                                      (br) => (
                                        <Grid container spacing={1}>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              Buyer Name
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              Mention
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              {br?.buyer}
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            sx={{
                                              border: '1px solid #d3d3d3',
                                              padding: 1,
                                            }}
                                          >
                                            <Typography variant="subtitle2">
                                              {br?.mentions}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      ),
                                    )
                                  : null}
                              </Box>
                            </Box>
                          )
                        ) : currentArtifactTab === 'artifactTree' ? (
                          selectedArtifact?.discoveryTreeStatus === null ||
                          selectedArtifact?.discoveryTreeStatus ===
                            'in_process' ? (
                            <Box
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 10,
                                textAlign: 'center',
                              }}
                            >
                              <CircularProgress size={16} />
                              <Typography>
                                Discovery tree delta generation is in progress
                                ...
                              </Typography>
                            </Box>
                          ) : (
                            <Box position={'relative'}>
                              {selectedDeal?.topics &&
                              selectedDeal?.topics.length > 0 ? (
                                <QuestionFrameworkTree
                                  data={selectedDeal.topics}
                                  dealTree={true}
                                  interactionAnswers={
                                    selectedArtifact?.interactionAnswers
                                  }
                                />
                              ) : (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: 300,
                                    gap: 2,
                                  }}
                                >
                                  <Typography>
                                    No question tree found
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          )
                        ) : currentArtifactTab === 'prompt' ? (
                          <>
                            {artifactPrompts && artifactPrompts?.length > 0 ? (
                              <Box
                                display={'flex'}
                                flexDirection={'column'}
                                gap={2}
                              >
                                <FormControl
                                  size="small"
                                  sx={{ minWidth: 150 }}
                                >
                                  <InputLabel id="promptType">
                                    Prompt Type
                                  </InputLabel>
                                  <Select
                                    variant="outlined"
                                    size="small"
                                    labelId={'promptType'}
                                    label={'Artifact Prompt'}
                                    id={'promptType'}
                                    name={'promptType'}
                                    MenuProps={{ disableScrollLock: true }}
                                    onChange={(e) => {
                                      setSelectedArtifactPrompt(e.target.value);
                                    }}
                                    value={selectedArtifactPrompt}
                                  >
                                    {artifactPrompts.map((key) => (
                                      <MenuItem key={key} value={key}>
                                        <Typography variant="subtitle2">
                                          {capitalizeText(
                                            key?.split('_').join(' '),
                                          )}
                                        </Typography>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: 2,
                                    gap: 2,
                                    border: '1px solid #d3d3d3',

                                    minHeight: 'calc(100vh - 310px)',
                                    maxHeight: 'calc(100vh - 310px)',
                                    overflowY: 'scroll',
                                    '&::-webkit-scrollbar': {
                                      width: '5px',
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                      boxShadow:
                                        'inset 0 0 6px rgba(0,0,0,0.00)',
                                      webkitBoxShadow:
                                        'inset 0 0 6px rgba(0,0,0,0.00)',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                      backgroundColor:
                                        theme.palette.primary.main,
                                      borderRadius: 2,
                                      // outline: '1px solid slategrey',
                                    },
                                  }}
                                >
                                  {selectedArtifact?.customField?.metadata?.[
                                    selectedArtifactPrompt
                                  ]?.messages?.map((msg, index) => (
                                    <>
                                      {msg ? (
                                        <Box
                                          key={msg?.content}
                                          sx={{
                                            borderTopLeftRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 16
                                                : 0,
                                            borderTopRightRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 0
                                                : 16,
                                            borderBottomLeftRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 8
                                                : 16,
                                            borderBottomRightRadius:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 16
                                                : 8,
                                            minWidth: '80%',
                                            maxWidth: '80%',
                                            alignSelf:
                                              msg?.role === 'user' ||
                                              msg?.role === 'system'
                                                ? 'end'
                                                : 'start',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // gap: 1,
                                            boxShadow: theme.shadows[8],
                                            background:
                                              msg?.role === 'user'
                                                ? theme.palette.primary.main
                                                : msg?.role === 'system'
                                                ? '#aaa'
                                                : '#fff',
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            alignItems={'center'}
                                            justifyContent={'space-between'}
                                            sx={{
                                              padding: '8px 16px',
                                              gap: 4,
                                              width: 1,
                                              cursor: 'pointer',
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              if (
                                                expandedPromptSections?.includes(
                                                  index,
                                                )
                                              ) {
                                                setExpandedPromptSections(
                                                  (prev) =>
                                                    prev?.filter(
                                                      (id) => id !== index,
                                                    ),
                                                );
                                              } else {
                                                setExpandedPromptSections(
                                                  (prev) => [...prev, index],
                                                );
                                              }
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                              }}
                                            >
                                              {expandedPromptSections?.includes(
                                                index,
                                              ) ? (
                                                <ExpandMore
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : msg?.role === 'system'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              ) : (
                                                <ChevronRight
                                                  sx={{
                                                    fontSize: 22,
                                                    color:
                                                      msg?.role === 'user'
                                                        ? '#fff'
                                                        : msg?.role === 'system'
                                                        ? '#fff'
                                                        : theme.palette.text
                                                            .secondary,
                                                  }}
                                                />
                                              )}
                                              {msg?.role === 'user' ? (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#f1f1f1',
                                                  }}
                                                >
                                                  User
                                                </Typography>
                                              ) : msg?.role === 'system' ? (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#f1f1f1',
                                                  }}
                                                >
                                                  Prompt
                                                </Typography>
                                              ) : (
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color:
                                                      theme.palette.text
                                                        .secondary,
                                                  }}
                                                >
                                                  {'GPT'}
                                                </Typography>
                                              )}
                                            </Box>
                                            <Tooltip
                                              arrow
                                              placement="top"
                                              title="Copy"
                                            >
                                              <ContentCopy
                                                sx={{
                                                  color:
                                                    msg?.role === 'user'
                                                      ? '#fff'
                                                      : theme.palette.text
                                                          .secondary,
                                                  fontSize: 18,
                                                  cursor: 'pointer',
                                                }}
                                                onClick={async (e) => {
                                                  e.stopPropagation();
                                                  try {
                                                    await navigator.clipboard.writeText(
                                                      msg?.content,
                                                    );
                                                  } catch (err) {
                                                    console.error(
                                                      'Failed to copy: ',
                                                      err,
                                                    );
                                                  }
                                                }}
                                              />
                                            </Tooltip>
                                          </Box>
                                          {expandedPromptSections?.includes(
                                            index,
                                          ) ? (
                                            <Typography
                                              sx={{
                                                whiteSpace: 'pre-wrap',
                                                color:
                                                  msg?.role === 'user'
                                                    ? '#fff'
                                                    : theme.palette.text
                                                        .primary,
                                                padding: '0px 16px 16px 16px',
                                              }}
                                            >
                                              {msg?.content}
                                            </Typography>
                                          ) : null}
                                        </Box>
                                      ) : null}
                                    </>
                                  ))}
                                </Box>
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  minHeight: 300,
                                  gap: 2,
                                }}
                              >
                                <Typography>No meta data found</Typography>
                              </Box>
                            )}
                          </>
                        ) : currentArtifactTab === 'artifactRisks' &&
                          Object.keys(artifactStatusMap || {})?.indexOf(
                            selectedArtifact?.postProcessingStatus,
                          ) > 9 &&
                          !artifactFailedStatuses?.includes(
                            selectedArtifact?.postProcessingStatus,
                          ) ? (
                          <ArtifactRisksSelectionList
                            viewType={'dealDetails'}
                            readOnly={true}
                            activeArtifact={selectedArtifact}
                            selectedOrganization={selectedOrganization}
                            // successCallback={(
                            //   risks,
                            //   actions,
                            //   artfct,
                            // ) => {
                            //   setSelectedArtifact(
                            //     (prev) => {
                            //       return {
                            //         ...prev,
                            //         selectedRisks: risks,
                            //         nextBestActionsMap: actions,
                            //       };
                            //     },
                            //   );
                            //   if (
                            //     dealArtifacts?.find(
                            //       (artifact) =>
                            //         artifact?.interactionTime >
                            //           artfct?.interactionTime &&
                            //         artifact?.id !==
                            //           artfct?.id &&
                            //         recentArtifactWithNBA?.id ===
                            //           artifact?.id,
                            //     )
                            //   ) {
                            //     // setRecentArtifactWithNBA(
                            //     //   (prev) => {
                            //     //     return {
                            //     //       ...prev,
                            //     //       selectedRisks: risks,
                            //     //       nextBestActionsMap: actions,
                            //     //     };
                            //     //   },
                            //     // );
                            //     setCurrentArtifactDetailTab(
                            //       'actions',
                            //     );
                            //   } else {
                            //     setRecentArtifactWithNBA(
                            //       (prev) => {
                            //         return {
                            //           ...prev,
                            //           selectedRisks: risks,
                            //           nextBestActionsMap: actions,
                            //         };
                            //       },
                            //     );
                            //     setCurrentArtifactDetailTab(
                            //       'summary',
                            //     );
                            //   }
                            //   setDealArtifacts(
                            //     (prev) => {
                            //       return prev.map(
                            //         (artifact) => {
                            //           if (
                            //             artifact?.id ===
                            //             artfct?.id
                            //           ) {
                            //             return {
                            //               ...artifact,
                            //               selectedRisks: risks,
                            //               nextBestActionsMap: actions,
                            //               postProcessingStatus:
                            //                 'interaction_nba_completed',
                            //             };
                            //           }
                            //           return artifact;
                            //         },
                            //       );
                            //     },
                            //   );
                            // }}
                          />
                        ) : currentArtifactTab === 'artifactNBAs' &&
                          Object.keys(artifactStatusMap || {})?.indexOf(
                            selectedArtifact?.postProcessingStatus,
                          ) > 9 &&
                          !artifactFailedStatuses?.includes(
                            selectedArtifact?.postProcessingStatus,
                          ) ? (
                          <NextBestActions
                            type={'current'}
                            // dealId={dealId}
                            dealArtifactsLoading={false}
                            noArtifacts={artifacts?.length === 0}
                            readOnly={
                              selectedArtifact?.nextBestActionsMap &&
                              Object.keys(
                                selectedArtifact?.nextBestActionsMap || {},
                              ) &&
                              Object.keys(
                                selectedArtifact?.nextBestActionsMap || {},
                              )?.length > 0
                            }
                            activeArtifact={selectedArtifact}
                            sx={{
                              margin: 2,
                            }}
                            // setCurrentArtifactDetailTab={
                            //   setCurrentArtifactDetailTab
                            // }
                            // setActiveArtifactTab={
                            //   setActiveArtifactTab
                            // }
                          />
                        ) : currentArtifactTab === 'artifactBuyersPOV' ? (
                          <Box
                            sx={{
                              padding: 2,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Reason to Buy
                                </Typography>
                                {selectedArtifact?.buyersPov?.buyersReasonToBuy?.map(
                                  (reasonToBuy, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {reasonToBuy?.reason}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {reasonToBuy?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Reason to Not Buy
                                </Typography>
                                {selectedArtifact?.buyersPov?.buyersReasonToNotBuy?.map(
                                  (reasonToNotBuy, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {reasonToNotBuy?.reason}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {reasonToNotBuy?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 2,
                              }}
                            >
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Metrics
                                </Typography>
                                {selectedArtifact?.buyersPov?.metrics?.map(
                                  (metric, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography
                                              sx={
                                                {
                                                  // color:
                                                  //   activeNBA?.id === action?.id
                                                  //     ? theme.palette.primary.main
                                                  //     : theme.palette.text.primary,
                                                  // textDecoration: action?.deleted
                                                  //   ? 'line-through'
                                                  //   : 'none',
                                                }
                                              }
                                              // onMouseEnter={(e) => {
                                              //   setAnchorElDetails(e.currentTarget);
                                              //   setPopperDetails(action?.risksAddressed);
                                              //   setPopperExplanation(action?.explanation);
                                              // }}
                                              // onMouseLeave={() => {
                                              //   setAnchorElDetails(null);
                                              //   setPopperDetails(null);
                                              //   setPopperExplanation(null);
                                              // }}
                                            >
                                              {metric?.metrics}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {metric?.explanation}
                                            </Typography>
                                          </Box>
                                          {/* <Popper
                                                                                id="mouse-over-popover"
                                                                                sx={{
                                                                                  pointerEvents: 'none',
                                                                                  zIndex: 1111111,
                                                                                }}
                                                                                open={Boolean(anchorElDetails)}
                                                                                anchorEl={anchorElDetails}
                                                                                placement="right"
                                                                                onClose={() => {
                                                                                  setAnchorElDetails(null);
                                                                                }}
                                                                                // disableRestoreFocus
                                                                              >
                                                                                <Box
                                                                                  sx={{
                                                                                    border: '1px solid #d3d3d3',
                                                                                    borderRadius: 1,
                                                                                    padding: 1,
                                                                                    background: '#fff',
                                                                                    maxWidth: 400,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: 1,
                                                                                    // boxShadow: theme.shadows[1],
                                                                                  }}
                                                                                >
                                                                                  <Typography>
                                                                                    Risks addressed by this action:
                                                                                  </Typography>
                                                                                  <Box
                                                                                    display={'flex'}
                                                                                    alignItems={'center'}
                                                                                    gap={1}
                                                                                    flexWrap={'wrap'}
                                                                                  >
                                                                                    {popperDetails?.map((risk) => (
                                                                                      <Chip
                                                                                        key={risk?.id}
                                                                                        label={risk?.riskTitle}
                                                                                        size="small"
                                                                                        color="default"
                                                                                      />
                                                                                    ))}
                                                                                  </Box>
                                                                                  <Typography
                                                                                    variant={'body1'}
                                                                                    color={'text.secondary'}
                                                                                    sx={{
                                                                                      padding: 1,
                                                                                    }}
                                                                                  >
                                                                                    {popperExplanation || ''}
                                                                                  </Typography>
                                                                                </Box>
                                                                              </Popper> */}
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: 'text.secondary',
                                  }}
                                >
                                  Priorities
                                </Typography>
                                {selectedArtifact?.buyersPov?.priorities?.map(
                                  (priority, index) => (
                                    <Box
                                      key={index + 1}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'default',
                                        borderRadius: 2,
                                        width: 1,
                                      }}
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setActiveNBA(action);
                                      // }}
                                    >
                                      <Box
                                        sx={{
                                          background: '#F2F6FC',
                                          // activeNBA?.id === action?.id ? '#C2DBFF' : '#F2F6FC',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 1,
                                          flex: 1,
                                          borderRadius: 2,
                                          position: 'relative',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            flex: 1,
                                            borderRadius: 2,
                                            paddingLeft: 2,
                                          }}
                                        >
                                          <Box
                                            display={'flex'}
                                            sx={{
                                              flexDirection: 'column',
                                              width: 1,
                                              padding: 1,
                                              justifyContent: 'space-between',
                                              gap: 1,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Typography sx={{}}>
                                              {priority?.priority}
                                            </Typography>
                                            <Typography
                                              color={`text.secondary`}
                                            >
                                              {priority?.explanation}
                                            </Typography>
                                          </Box>
                                        </Box>
                                      </Box>
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ) : null}
                      </Box>
                    </Box>
                  ) : null}
                </>
              ) : currentOrgMenu === 'mcpTools' ? (
                <Box>
                  <McpToolsConfig
                    org={organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )}
                  />
                </Box>
              ) : currentOrgMenu === 'rag' ? (
                <Box>
                  <RagQueries
                    org={organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )}
                  />
                </Box>
              ) : currentOrgMenu === 'promptTesting' ? (
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'start',
                      gap: 1,
                    }}
                  >
                    <FormControl
                      size="small"
                      sx={{ minWidth: 150, maxWidth: 300 }}
                    >
                      <InputLabel id="selectedNamespaces">
                        Namespaces
                      </InputLabel>
                      <Select
                        variant="outlined"
                        size="small"
                        labelId={'selectedNamespaces'}
                        label={'Namespaces'}
                        id={'selectedNamespaces'}
                        name={'selectedNamespaces'}
                        MenuProps={{ disableScrollLock: true }}
                        onChange={(e) => {
                          setSelectedNamespaces(e.target.value);
                        }}
                        value={selectedNamespaces}
                        multiple
                      >
                        {Object.keys(
                          organizations?.find(
                            (org) => org?.id === selectedOrganization,
                          )?.ragNamespaceMapForFE || {},
                        )?.map((namespace) => (
                          <MenuItem key={namespace} value={namespace}>
                            <Typography variant="subtitle2">
                              {namespace}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box
                      sx={{
                        width: 1,
                      }}
                    >
                      <Typography variant="body2" color={'textSecondary'}>
                        Query to generate Prompt
                      </Typography>
                      <TextField
                        placeholder="Query to generate Prompt"
                        variant="outlined"
                        name={'query'}
                        multiline
                        rows={3}
                        fullWidth
                        size="small"
                        type="text"
                        value={query}
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: 1,
                      }}
                    >
                      <Typography variant="body2" color={'textSecondary'}>
                        Response Size
                      </Typography>
                      <TextField
                        placeholder="Response Size"
                        variant="outlined"
                        name={'size'}
                        fullWidth
                        size="small"
                        type="number"
                        value={size}
                        onChange={(e) => {
                          setSize(e.target.value);
                        }}
                      />
                    </Box>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={
                        generatingPrompt ? <CircularProgress size={20} /> : null
                      }
                      disabled={generatingPrompt}
                      onClick={() => {
                        setGeneratingPrompt(true);
                        dispatch(
                          processRagQueryBulk(
                            selectedNamespaces?.map((namespace) => {
                              return {
                                namespace,
                                query,
                                size,
                              };
                            }),
                            indexProvider,
                            (response) => {
                              setGeneratingPrompt(false);
                              setPrompts(
                                response?.reduce(
                                  (acc, curr) => [...acc, ...curr.responses],
                                  [],
                                ),
                              );
                            },
                            (error) => {
                              setGeneratingPrompt(false);
                              console.log(error);
                            },
                          ),
                        );
                      }}
                    >
                      Generate
                    </Button>
                    <Box
                      sx={{
                        width: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                      }}
                    >
                      <Typography variant="body2" color={'textSecondary'}>
                        Generated Prompts
                      </Typography>
                      {prompts?.map((prompt) => (
                        <TextField
                          placeholder="Generated Prompt"
                          variant="outlined"
                          name={'prompt'}
                          multiline
                          rows={5}
                          fullWidth
                          size="small"
                          type="text"
                          value={prompt?.text}
                          // onChange={(e) => {
                          //   setPrompt(e.target.value);
                          // }}
                        />
                      ))}
                      {/* <TextField
                        placeholder="Generated Prompt"
                        variant="outlined"
                        name={'prompt'}
                        multiline
                        rows={3}
                        fullWidth
                        size="small"
                        type="text"
                        value={prompt}
                        // onChange={(e) => {
                        //   setPrompt(e.target.value);
                        // }}
                      /> */}
                    </Box>
                  </Box>
                  <Divider orientation="vertical" flexItem />
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size="small"
                      // sx={{ marginBottom: 2 }}
                    >
                      <FormLabel id="demo-row-radio-buttons-group-label">
                        Model
                      </FormLabel>
                      <Select
                        // ref={promptSelectRef}
                        labelId="prompt-select-label"
                        // label="Select Prompt"
                        value={model || ''}
                        onChange={(e) => {
                          setModel(e.target.value);
                        }}
                      >
                        {models?.map((model) => (
                          <MenuItem value={model}>
                            {modelMapping[model]}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      placeholder="Prompt"
                      variant="outlined"
                      name={'prompt'}
                      multiline
                      rows={8}
                      fullWidth
                      size="small"
                      type="text"
                      value={prompt}
                      onChange={(e) => {
                        setPrompt(e.target.value);
                      }}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ alignSelf: 'start' }}
                      startIcon={
                        generatingPromptResponse ? (
                          <CircularProgress size={20} />
                        ) : null
                      }
                      disabled={generatingPromptResponse}
                      onClick={() => {
                        setGeneratingPromptResponse(true);
                        dispatch(
                          testLllPrompt(
                            {
                              model,
                              prompt,
                            },
                            (response) => {
                              setGeneratingPromptResponse(false);
                              setPromptResponse(response || '');
                            },
                            (error) => {
                              setGeneratingPromptResponse(false);
                              console.log(error);
                            },
                          ),
                        );
                      }}
                    >
                      Generate Response
                    </Button>
                    <Typography variant="body2" color={'textSecondary'}>
                      Generated Response
                    </Typography>
                    <TextField
                      placeholder="Generated Response"
                      variant="outlined"
                      name={'promptResponse'}
                      multiline
                      rows={10}
                      fullWidth
                      size="small"
                      type="text"
                      value={promptResponse}
                      // onChange={(e) => {
                      //   set(e.target.value);
                      // }}
                    />
                  </Box>
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={Boolean(showConfirmTreeRegeneration)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 1300,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
            minWidth: '400px',
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">Confirm</DialogTitle> */}
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <Typography>
              Are you sure you want to regenerate the tree?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowConfirmTreeRegeneration(false);
              // if (testMode) setShowTestDeviceDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={triggeringTreeRegeneration}
            startIcon={
              triggeringTreeRegeneration ? <CircularProgress size={20} /> : null
            }
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              setTriggeringTreeRegeneration(true);
              dispatch(
                regenerateDiscoveryTree(
                  selectedOrganization,
                  organizations?.find((org) => org?.id === selectedOrganization)
                    ?.discoveryTreeId,
                  {
                    title: organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.organizationName,
                    url: organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.companyWebsite,
                    sellingStyle: organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.sellingStyle,
                    aboutCompany: organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.aboutCompany,
                    valueProp: organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.valuePropHtml,
                    metaData: '',
                    model: 'gpt-4o-mini-2024-07-18',
                  },
                  (data) => {
                    setTriggeringTreeRegeneration(false);
                    setShowConfirmTreeRegeneration(false);
                    dispatch({
                      type: 'UPDATE_ORGANIZATION_IN_ALL_ORGANIZATIONS',
                      payload: {
                        organization: {
                          ...organizations?.find(
                            (org) => org?.id === selectedOrganization,
                          ),
                          customFields: {
                            ...organizations?.find(
                              (org) => org?.id === selectedOrganization,
                            )?.customFields,
                            discoveryTree: {
                              ...organizations?.find(
                                (org) => org?.id === selectedOrganization,
                              )?.customFields?.discoveryTree,
                              status: 'pending',
                            },
                          },
                        },
                      },
                    });
                  },
                ),
              );
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(showConfirmDisableDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 1300,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
            minWidth: '400px',
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">Confirm</DialogTitle> */}
        <DialogContent>
          <Box
            display={'flex'}
            flexDirection={'column'}
            // alignItems={'center'}
            gap={2}
          >
            <Typography>
              Are you sure you want to {showConfirmDisableDialog} this
              organization?
            </Typography>
            <Typography>
              {showConfirmDisableDialog === 'delete'
                ? 'This will delete the organization and its associated data. You will not be able to recover it leter.'
                : showConfirmDisableDialog === 'disable'
                ? 'This will disable the organization and prevent every user from signing into their account.'
                : showConfirmDisableDialog === 'enable'
                ? 'This will enable the organization and allow every user to sign into their account.'
                : null}
            </Typography>
            {showConfirmDisableDialog === 'disable' ? (
              <Box>
                <Typography variant="body2" color={'textSecondary'}>
                  Reason for deletion
                </Typography>
                <TextField
                  placeholder="Reason"
                  variant="outlined"
                  name={'reason'}
                  multiline
                  rows={3}
                  fullWidth
                  size="small"
                  type="text"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowConfirmDisableDialog('');
              // if (testMode) setShowTestDeviceDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={disablingOrDeletingAccount}
            startIcon={
              disablingOrDeletingAccount ? <CircularProgress size={20} /> : null
            }
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              setDisablingOrDeletingAccount(true);
              if (
                showConfirmDisableDialog === 'disable' ||
                showConfirmDisableDialog === 'enable'
              ) {
                dispatch(
                  scheduleAccountForDeletion(
                    selectedOrganization,
                    organizations?.find(
                      (org) => org?.id === selectedOrganization,
                    )?.organizationName,
                    reason,
                    showConfirmDisableDialog === 'disable' ? true : false,
                    (data) => {
                      dispatch({
                        type: 'UPDATE_ORGANIZATION_IN_ALL_ORGANIZATIONS',
                        payload: {
                          organization: {
                            ...organizations?.find(
                              (org) => org?.id === selectedOrganization,
                            ),
                            scheduledDeleteRequest: data,
                          },
                        },
                      });
                      alert(
                        `Account successfully ${
                          showConfirmDisableDialog === 'disable'
                            ? 'disabled'
                            : 'enabled'
                        }`,
                      );
                      setShowConfirmDisableDialog('');
                      setDisablingOrDeletingAccount(false);
                    },
                  ),
                );
              } else {
                dispatch(
                  deleteAccountPermanently(selectedOrganization, () => {
                    alert(`Account successfully deleted`);
                    dispatch(
                      getAllOrganizations(
                        [],
                        true,
                        'n_org',
                        9,
                        null,
                        version === 'v1' ? 'all' : 'v2',
                        () => {},
                      ),
                    );
                    setShowConfirmDisableDialog('');
                    setDisablingOrDeletingAccount(false);
                  }),
                );
              }
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(weeklySummaryDeal)}
        onClose={() => {
          setWeeklySummaryDeal(null);
        }}
        aria-labelledby="weekly-deal-summary-dialog-title"
        style={{
          zIndex: 1300,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
            minWidth: '400px',
          },
        }}
      >
        <DialogTitle id="weekly-deal-summary-dialog-title">
          Weekly Deal Summary — {weeklySummaryDeal?.name}
        </DialogTitle>
        <DialogContent>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box display={'flex'} alignItems={'center'} gap={2}>
              <FormControl size="small" sx={{ minWidth: 220 }}>
                <InputLabel id="weekly-summary-window-label">
                  Summary Window
                </InputLabel>
                <Select
                  labelId="weekly-summary-window-label"
                  label="Summary Window"
                  value={weeklySummaryWindow}
                  onChange={(e) => {
                    setWeeklySummaryWindow(e.target.value);
                  }}
                >
                  <MenuItem value="LAST_WEEK">Last 7 days</MenuItem>
                  <MenuItem value="LAST_MONTH">Last 30 days</MenuItem>
                  <MenuItem value="LAST_3_MONTHS">Last 90 days</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="contained"
                size="small"
                disabled={triggeringWeeklySummary}
                startIcon={
                  triggeringWeeklySummary ? (
                    <CircularProgress size={16} />
                  ) : null
                }
                onClick={() => {
                  setTriggeringWeeklySummary(true);
                  dispatch(
                    triggerWeeklyDealSummary(
                      selectedOrganization,
                      weeklySummaryDeal?.id,
                      weeklySummaryWindow,
                      () => {
                        setTriggeringWeeklySummary(false);
                        alert(
                          'Summary generation triggered. It will appear in the history below once the workflow completes.',
                        );
                      },
                      () => {
                        setTriggeringWeeklySummary(false);
                        alert('Failed to trigger weekly deal summary.');
                      },
                    ),
                  );
                }}
              >
                Trigger Summary
              </Button>
            </Box>
            <Divider />
            <Typography variant="subtitle2">Summary History</Typography>
            {loadingWeeklySummaries ? (
              <Box display={'flex'} justifyContent={'center'} py={2}>
                <CircularProgress size={24} />
              </Box>
            ) : weeklySummaries?.length > 0 ? (
              <Box
                display={'flex'}
                flexDirection={'column'}
                gap={2}
                sx={{ maxHeight: '50vh', overflowY: 'auto' }}
              >
                {weeklySummaries.map((summary, idx) => (
                  <Box
                    key={summary?.id || idx}
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      p: 1.5,
                    }}
                  >
                    <Box
                      display={'flex'}
                      justifyContent={'space-between'}
                      alignItems={'center'}
                    >
                      <Chip
                        size="small"
                        label={summary?.summaryWindow || '--'}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {summary?.createdOn
                          ? moment(summary?.createdOn).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : '--'}
                      </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {summary?.summaryText}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No summaries generated yet for this deal.
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWeeklySummaryDeal(null);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={triggerRecentOpen}
        onClose={() => {
          if (triggeringRecent) return;
          setTriggerRecentOpen(false);
        }}
        aria-labelledby="trigger-recent-summaries-dialog-title"
        fullWidth
        maxWidth="sm"
        style={{ zIndex: 1300 }}
      >
        <DialogTitle id="trigger-recent-summaries-dialog-title">
          Generate Reports for Recent Deals
        </DialogTitle>
        <DialogContent>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Typography variant="body2">
              For <b>every user</b> in{' '}
              <b>
                {organizations?.find((org) => org?.id == selectedOrganization)
                  ?.organizationName || selectedOrganization}
              </b>
              , this takes their <b>10 most-recently-updated</b> non-archived
              deals, groups them into <b>one weekly batch per user</b> and
              triggers weekly summary generation for each deal.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Window is always <b>last 7 days</b>. The daily dedupe lock is
              skipped, so running this again for the same org on the same day
              re-triggers generation. This only <b>starts</b> generation —
              PERIOD_SUMMARY records land per deal as each workflow completes,
              and DEALS_CLOSING_THIS_WEEK / RISK_REPORT land once each user's
              batch fully resolves.
            </Typography>
            {triggerRecentResult ? (
              <Box
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  p: 1.5,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5,
                }}
              >
                <Typography variant="subtitle2">Triggered</Typography>
                <Typography variant="body2">
                  Users processed: <b>{triggerRecentResult?.usersProcessed}</b>
                </Typography>
                <Typography variant="body2">
                  Batches created: <b>{triggerRecentResult?.batchesCreated}</b>
                </Typography>
                <Typography variant="body2">
                  Deals triggered: <b>{triggerRecentResult?.dealsTriggered}</b>
                </Typography>
              </Box>
            ) : null}
            {triggerRecentError ? (
              <Typography variant="body2" color="error">
                {typeof triggerRecentError === 'string'
                  ? triggerRecentError
                  : JSON.stringify(triggerRecentError)}
              </Typography>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={triggeringRecent}
            onClick={() => {
              setTriggerRecentOpen(false);
            }}
          >
            {triggerRecentResult ? 'Close' : 'Cancel'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={triggeringRecent || !selectedOrganization}
            startIcon={triggeringRecent ? <CircularProgress size={16} /> : null}
            onClick={() => {
              setTriggeringRecent(true);
              setTriggerRecentResult(null);
              setTriggerRecentError(null);
              dispatch(
                triggerRecentWeeklyDealSummaries(
                  selectedOrganization,
                  (data) => {
                    setTriggeringRecent(false);
                    setTriggerRecentResult(data || {});
                  },
                  (error) => {
                    setTriggeringRecent(false);
                    setTriggerRecentError(
                      error || 'Failed to trigger report generation.',
                    );
                  },
                ),
              );
            }}
            autoFocus
          >
            {triggerRecentResult ? 'Trigger Again' : 'Trigger'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(showExportTreeDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 1300,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
            minWidth: '400px',
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">Confirm</DialogTitle> */}
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="stageType">Stage</InputLabel>
              <Select
                variant="outlined"
                size="small"
                labelId={'stageType'}
                label={'Deal Stage'}
                id={'stageType'}
                name={'stageType'}
                MenuProps={{ disableScrollLock: true }}
                onChange={(e) => {
                  setSelectedStage(e.target.value);
                }}
                value={selectedStage}
              >
                <MenuItem value={'-'}>
                  <Typography variant="subtitle2">All</Typography>
                </MenuItem>
                {stages.map((stage) => (
                  <MenuItem key={stage?.id} value={stage?.id}>
                    <Typography variant="subtitle2">{stage?.name}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowExportTreeDialog(null);
              // if (testMode) setShowTestDeviceDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={exportingTree}
            startIcon={exportingTree ? <CircularProgress size={20} /> : null}
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              setExportingTree(true);
              dispatch(
                exportDiscoveryTree(
                  selectedOrganization,
                  organizations?.find((org) => org?.id === selectedOrganization)
                    ?.discoveryTreeId,
                  selectedStage === '-' ? null : selectedStage,
                  (data) => {
                    setExportingTree(false);
                    console.log(data);
                    setShowExportTreeDialog(null);
                    window.open(data, '_blank');
                  },
                ),
              );
            }}
            color="primary"
            autoFocus
          >
            Export
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={showUpdateTrialDialog}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          // zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Update trial</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              minWidth: 300,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                Type
              </Grid>
              <Grid item xs={8}>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    labelId="type-select-label"
                    id="type-select"
                    name="type"
                    MenuProps={{ disableScrollLock: true }}
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                    value={type}
                  >
                    <MenuItem value={'date'}>Valid Till</MenuItem>
                    <MenuItem value={'days'}>Valid For</MenuItem>
                    <MenuItem value={'end'}>End Trial</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {type !== 'end' ? (
                <>
                  <Grid item xs={4}>
                    {type === 'date' ? 'Date' : 'Days'}
                  </Grid>
                  <Grid item xs={8}>
                    {type === 'date' ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={date ? dayjs(new Date(date)) : null}
                          label="Date"
                          format="MM-DD-YYYY"
                          onChange={(date) => {
                            let date_ = new Date(date); // some mock date
                            // console.log(date);
                            var milliseconds = date_.getTime();
                            setDate(milliseconds);
                          }}
                        />
                      </LocalizationProvider>
                    ) : null}
                    {type === 'days' ? (
                      <TextField
                        label="Days"
                        variant="outlined"
                        name={'days'}
                        size="small"
                        // fullWidth
                        value={days}
                        onChange={(e) => setDays(e.target.value)}
                      />
                    ) : null}
                  </Grid>
                </>
              ) : null}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={(e) => {
                setShowUpdateTrialDialog(false);
              }}
              color="primary"
              autoFocus
            >
              Dismiss
            </Button>
            <Button
              onClick={(e) => {
                setShowUpdateTrialDialog(false);
                dispatch(
                  updatePlanTrialEndsOn(
                    selectedOrganization,
                    {
                      trailEndsOn:
                        type === 'end'
                          ? new Date().getTime() - 172800000
                          : type === 'date'
                          ? date
                          : new Date().getTime() +
                            Number(days) * 24 * 60 * 60 * 1000,
                    },
                    (err) => {
                      if (err) {
                        alert('Failed to update trial! Please try again later');
                      } else {
                        dispatch(
                          getAllOrganizations(
                            [],
                            true,
                            'n_org',
                            9,
                            null,
                            version === 'v1' ? 'all' : 'v2',
                            () => {},
                          ),
                        );
                        alert('Information Updated!');
                      }
                    },
                  ),
                );
              }}
              color="primary"
              autoFocus
            >
              Update
            </Button>
          </Box>
        </DialogActions>
      </Dialog> */}
      {/* <Modal
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={showEditContentScoringConfig}
        onClose={(e, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // boxShadow: theme.shadows[5],
            outline: 'none',
            maxHeight: '95vh',
            maxWidth: '70vw',
            minWidth: '70vw',
            borderRadius: 1,
            // padding: 2,
            position: 'relative',
            // paddingTop: 3,
          }}
        >
          <Typography
            variant="body1"
            padding={2}
            borderBottom={'1px solid #d3d3d3'}
          >
            Call Scoring Configurations
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              padding: '16px',
              minHeight: 'calc(95vh - 140px)',
              maxHeight: 'calc(95vh - 140px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                // outline: '1px solid slategrey',
              },
            }}
          >
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                <Typography variant="caption" color={'text.secondary'}>
                  Configure with
                </Typography>
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={configType}
                onChange={(e) => {
                  if (e.target.value === 'form') {
                    try {
                      const outboundObj = JSON.parse(
                        contentScoreConfigText?.outbound || '{}',
                      );
                      const inboundObj = JSON.parse(
                        contentScoreConfigText?.inbound || '{}',
                      );
                      setContentScoringConfig((prev) => {
                        return {
                          ...prev,
                          outbound: outboundObj,
                          inbound: inboundObj,
                        };
                      });
                      setConfigType(e.target.value);
                    } catch (e) {
                      alert(
                        'Failed to parse json text. please validate the json.',
                      );
                    }
                  } else {
                    try {
                      setContentScoreConfigText((prev) => {
                        return {
                          ...prev,
                          outbound: JSON.stringify(
                            contentScoringConfig?.outbound || '{}',
                            null,
                            2,
                          ),
                          inbound: JSON.stringify(
                            contentScoringConfig?.inbound || '{}',
                            null,
                            2,
                          ),
                        };
                      });
                      setConfigType(e.target.value);
                    } catch (e) {
                      alert(
                        'Failed to convert json to text. please try again.',
                      );
                    }
                  }
                }}
              >
                <FormControlLabel
                  value={'form'}
                  control={<Radio size="small" />}
                  label={'Form'}
                />
                <FormControlLabel
                  value={'json'}
                  control={<Radio size="small" />}
                  label={'json'}
                />
              </RadioGroup>
            </FormControl>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                <Typography variant="caption" color={'text.secondary'}>
                  Call Type
                </Typography>
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={callType}
                onChange={(e) => setCallType(e.target.value)}
              >
                <FormControlLabel
                  value={'outbound'}
                  control={<Radio size="small" />}
                  label={'Outbound'}
                />
                <FormControlLabel
                  value={'inbound'}
                  control={<Radio size="small" />}
                  label={'Inbound'}
                />
              </RadioGroup>
            </FormControl>
            {callType === 'inbound' ? (
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={sameConfig}
                    name="sameConfig"
                  />
                }
                label={
                  <Typography variant="subtitle2">Same as outbound</Typography>
                }
                onChange={(e) => {
                  setSameConfig(e.target.checked);
                }}
              />
            ) : null}
            {callType === 'outbound' || (callType === 'inbound' && !sameConfig)
              ? Object.keys(contentScoringConfig?.[callType] || {})?.map(
                  (configKey) => {
                    return configKey === 'criteriaList' ? (
                      <Box
                        sx={{
                          border: '1px solid #d3d3d3',
                          borderRadius: 2,
                          position: 'relative',
                          // padding: 2,
                        }}
                        key={configKey}
                      >
                        {configType === 'form' ? (
                          <>
                            <Typography
                              variant="body1"
                              color={'text.secondary'}
                              sx={{
                                position: 'absolute',
                                top: -12,
                                left: 5,
                                background: '#fff',
                                padding: '0 5px',
                                zIndex: 9999,
                              }}
                            >
                              Categories
                            </Typography>
                            <Box
                              display={'flex'}
                              flexDirection={'column'}
                              gap={2}
                              // sx={{ background: '#f1f1f1' }}
                              // padding={2}
                            >
                              {contentScoringConfig[callType][configKey] ? (
                                contentScoringConfig[callType][configKey]
                                  ?.length > 0 ? (
                                  <Box sx={{}}>
                                    <Box sx={{ background: '#d3d3d3', p: 2 }}>
                                      {contentScoringConfig[callType][
                                        configKey
                                      ]?.map((criteriaKey, index) => (
                                        <Box
                                          key={
                                            Object.keys(criteriaKey || {})?.[0]
                                          }
                                          display={'flex'}
                                          flexDirection={'column'}
                                          // gap={2}
                                        >
                                          <Box
                                            display={'flex'}
                                            gap={1}
                                            alignItems={'center'}
                                            justifyContent={'space-between'}
                                            sx={
                                              {
                                                // background: '#f1f1f1',
                                                // padding: 1,
                                              }
                                            }
                                          >
                                            <Typography variant="body1">
                                              <span
                                                style={{ fontWeight: 'bold' }}
                                              >
                                                {index + 1}.
                                              </span>{' '}
                                              {
                                                Object.keys(
                                                  criteriaKey || {},
                                                )?.[0]
                                              }
                                            </Typography>
                                            <IconButton
                                              onClick={() => {
                                                setContentScoringConfig(
                                                  (prev) => {
                                                    return {
                                                      ...prev,
                                                      [callType]: {
                                                        ...prev[callType],
                                                        [configKey]: prev[
                                                          callType
                                                        ][configKey]?.filter(
                                                          (criteriaMap) =>
                                                            Object.keys(
                                                              criteriaMap || {},
                                                            )?.[0] !==
                                                            Object.keys(
                                                              criteriaKey || {},
                                                            )?.[0],
                                                        ),
                                                        categoryWeight: Object.keys(
                                                          prev[callType][
                                                            'categoryWeight'
                                                          ] || {},
                                                        )
                                                          ?.filter(
                                                            (key) =>
                                                              key !==
                                                              Object.keys(
                                                                criteriaKey ||
                                                                  {},
                                                              )?.[0],
                                                          )
                                                          ?.reduce(
                                                            (acc, curr) => {
                                                              acc[curr] =
                                                                prev[callType][
                                                                  'categoryWeight'
                                                                ][curr];
                                                              return acc;
                                                            },
                                                            {},
                                                          ),
                                                      },
                                                    };
                                                  },
                                                );
                                              }}
                                            >
                                              <Delete sx={{ fontSize: 18 }} />
                                            </IconButton>
                                          </Box>
                                          <Box
                                            display={'flex'}
                                            gap={1}
                                            alignItems={'center'}
                                            sx={{
                                              padding: 1,
                                            }}
                                          >
                                            <Typography flex={1}>
                                              Category Weight
                                            </Typography>
                                            <TextField
                                              placeholder={'Category Weight'}
                                              variant="outlined"
                                              name={'factorKey'}
                                              size="small"
                                              sx={{
                                                flex: 2,
                                              }}
                                              value={
                                                contentScoringConfig[callType][
                                                  'categoryWeight'
                                                ][
                                                  Object.keys(
                                                    criteriaKey || {},
                                                  )?.[0]
                                                ]
                                              }
                                              onChange={(e) => {
                                                setContentScoringConfig(
                                                  (prev) => {
                                                    return {
                                                      ...prev,
                                                      [callType]: {
                                                        ...prev[callType],
                                                        [configKey]:
                                                          prev[callType][
                                                            configKey
                                                          ],
                                                        categoryWeight: {
                                                          ...prev[callType][
                                                            'categoryWeight'
                                                          ],
                                                          [Object.keys(
                                                            criteriaKey || {},
                                                          )?.[0]]: e.target
                                                            .value,
                                                        },
                                                      },
                                                    };
                                                  },
                                                );
                                              }}
                                              type={'number'}
                                            />
                                          </Box>
                                          <Box
                                            display={'flex'}
                                            flexDirection={'column'}
                                            gap={2}
                                          >
                                            {contentScoringConfig[callType][
                                              configKey
                                            ][index][
                                              Object.keys(
                                                criteriaKey || {},
                                              )?.[0]
                                            ] ? (
                                              contentScoringConfig[callType][
                                                configKey
                                              ][index][
                                                Object.keys(
                                                  criteriaKey || {},
                                                )?.[0]
                                              ]?.length > 0 ? (
                                                <>
                                                  {contentScoringConfig[
                                                    callType
                                                  ][configKey][index][
                                                    Object.keys(
                                                      criteriaKey || {},
                                                    )?.[0]
                                                  ]?.map(
                                                    (
                                                      criteriaKeyFactor,
                                                      factorIndex,
                                                    ) => {
                                                      return (
                                                        <Box
                                                          key={`${
                                                            Object.keys(
                                                              criteriaKeyFactor ||
                                                                {},
                                                            )?.[0]
                                                          }${factorIndex}`}
                                                          display={'flex'}
                                                          flexDirection={
                                                            'column'
                                                          }
                                                          backgroundColor={
                                                            '#fff'
                                                          }
                                                        >
                                                          <Box
                                                            display={'flex'}
                                                            gap={1}
                                                            alignItems={
                                                              'center'
                                                            }
                                                            justifyContent={
                                                              'space-between'
                                                            }
                                                            sx={{
                                                              padding: 1,
                                                              border:
                                                                '1px solid #d3d3d3',
                                                            }}
                                                          >
                                                            <Typography variant="body1">
                                                              {
                                                                Object.keys(
                                                                  criteriaKeyFactor ||
                                                                    {},
                                                                )?.[0]
                                                              }
                                                            </Typography>
                                                            <IconButton
                                                              onClick={() => {
                                                                setContentScoringConfig(
                                                                  (prev) => {
                                                                    return {
                                                                      ...prev,
                                                                      [callType]: {
                                                                        ...prev[
                                                                          callType
                                                                        ],
                                                                        [configKey]: prev[
                                                                          callType
                                                                        ][
                                                                          configKey
                                                                        ]?.map(
                                                                          (
                                                                            ck,
                                                                            cki,
                                                                          ) =>
                                                                            cki ===
                                                                            index
                                                                              ? {
                                                                                  [Object.keys(
                                                                                    ck ||
                                                                                      {},
                                                                                  )?.[0]]: prev[
                                                                                    callType
                                                                                  ][
                                                                                    configKey
                                                                                  ][
                                                                                    index
                                                                                  ][
                                                                                    Object.keys(
                                                                                      criteriaKey ||
                                                                                        {},
                                                                                    )?.[0]
                                                                                  ]?.filter(
                                                                                    (
                                                                                      key,
                                                                                    ) =>
                                                                                      Object.keys(
                                                                                        key ||
                                                                                          {},
                                                                                      )?.[0] !==
                                                                                      Object.keys(
                                                                                        criteriaKeyFactor ||
                                                                                          {},
                                                                                      )?.[0],
                                                                                  ),
                                                                                }
                                                                              : ck,
                                                                        ),
                                                                      },
                                                                    };
                                                                  },
                                                                );
                                                              }}
                                                            >
                                                              <Delete
                                                                sx={{
                                                                  fontSize: 18,
                                                                }}
                                                              />
                                                            </IconButton>
                                                          </Box>
                                                          {contentScoringConfig[
                                                            callType
                                                          ][configKey][index][
                                                            Object.keys(
                                                              criteriaKey || {},
                                                            )?.[0]
                                                          ][factorIndex][
                                                            Object.keys(
                                                              criteriaKeyFactor ||
                                                                {},
                                                            )?.[0]
                                                          ]
                                                            ? Object.keys(
                                                                contentScoringConfig[
                                                                  callType
                                                                ][configKey][
                                                                  index
                                                                ][
                                                                  Object.keys(
                                                                    criteriaKey ||
                                                                      {},
                                                                  )?.[0]
                                                                ][factorIndex][
                                                                  Object.keys(
                                                                    criteriaKeyFactor ||
                                                                      {},
                                                                  )?.[0]
                                                                ] || {},
                                                              )?.map(
                                                                (factorKey) => {
                                                                  return factorKey ===
                                                                    'description' ||
                                                                    factorKey ===
                                                                      'weight' ||
                                                                    factorKey ===
                                                                      'question' ? (
                                                                    <Box
                                                                      display={
                                                                        'flex'
                                                                      }
                                                                      flexDirection={
                                                                        'column'
                                                                      }
                                                                    >
                                                                      <Box
                                                                        display={
                                                                          'flex'
                                                                        }
                                                                        gap={1}
                                                                        // alignItems={'center'}
                                                                        sx={{
                                                                          padding: 1,
                                                                        }}
                                                                      >
                                                                        <Typography
                                                                          flex={
                                                                            1
                                                                          }
                                                                        >
                                                                          {
                                                                            factorKey
                                                                          }
                                                                        </Typography>
                                                                        <TextField
                                                                          placeholder={
                                                                            factorKey
                                                                          }
                                                                          variant="outlined"
                                                                          name={
                                                                            'factorKey'
                                                                          }
                                                                          size="small"
                                                                          multiline={
                                                                            factorKey ===
                                                                              'description' ||
                                                                            factorKey ===
                                                                              'question'
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          rows={
                                                                            factorKey ===
                                                                              'description' ||
                                                                            factorKey ===
                                                                              'question'
                                                                              ? 3
                                                                              : 1
                                                                          }
                                                                          sx={{
                                                                            flex: 2,
                                                                          }}
                                                                          value={
                                                                            contentScoringConfig[
                                                                              callType
                                                                            ][
                                                                              configKey
                                                                            ][
                                                                              index
                                                                            ][
                                                                              Object.keys(
                                                                                criteriaKey ||
                                                                                  {},
                                                                              )?.[0]
                                                                            ][
                                                                              factorIndex
                                                                            ][
                                                                              Object.keys(
                                                                                criteriaKeyFactor ||
                                                                                  {},
                                                                              )?.[0]
                                                                            ][
                                                                              factorKey
                                                                            ]
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) => {
                                                                            setContentScoringConfig(
                                                                              (
                                                                                prev,
                                                                              ) => {
                                                                                return {
                                                                                  ...prev,
                                                                                  [callType]: {
                                                                                    ...prev[
                                                                                      callType
                                                                                    ],
                                                                                    [configKey]: prev[
                                                                                      callType
                                                                                    ][
                                                                                      configKey
                                                                                    ]?.map(
                                                                                      (
                                                                                        ck,
                                                                                        cki,
                                                                                      ) =>
                                                                                        cki ===
                                                                                        index
                                                                                          ? {
                                                                                              [Object.keys(
                                                                                                ck ||
                                                                                                  {},
                                                                                              )?.[0]]: prev[
                                                                                                callType
                                                                                              ][
                                                                                                configKey
                                                                                              ][
                                                                                                index
                                                                                              ][
                                                                                                Object.keys(
                                                                                                  criteriaKey ||
                                                                                                    {},
                                                                                                )?.[0]
                                                                                              ]?.map(
                                                                                                (
                                                                                                  key,
                                                                                                  keyIndex,
                                                                                                ) =>
                                                                                                  keyIndex ===
                                                                                                  factorIndex
                                                                                                    ? {
                                                                                                        ...prev[
                                                                                                          callType
                                                                                                        ][
                                                                                                          configKey
                                                                                                        ][
                                                                                                          index
                                                                                                        ][
                                                                                                          Object.keys(
                                                                                                            criteriaKey ||
                                                                                                              {},
                                                                                                          )?.[0]
                                                                                                        ][
                                                                                                          factorIndex
                                                                                                        ],
                                                                                                        [Object.keys(
                                                                                                          criteriaKeyFactor ||
                                                                                                            {},
                                                                                                        )?.[0]]: {
                                                                                                          ...prev[
                                                                                                            callType
                                                                                                          ][
                                                                                                            configKey
                                                                                                          ][
                                                                                                            index
                                                                                                          ][
                                                                                                            Object.keys(
                                                                                                              criteriaKey ||
                                                                                                                {},
                                                                                                            )?.[0]
                                                                                                          ][
                                                                                                            factorIndex
                                                                                                          ][
                                                                                                            Object.keys(
                                                                                                              criteriaKeyFactor ||
                                                                                                                {},
                                                                                                            )?.[0]
                                                                                                          ],
                                                                                                          [factorKey]:
                                                                                                            e
                                                                                                              .target
                                                                                                              .value,
                                                                                                        },
                                                                                                      }
                                                                                                    : key,
                                                                                              ),
                                                                                            }
                                                                                          : ck,
                                                                                    ),
                                                                                  },
                                                                                };
                                                                              },
                                                                            );
                                                                          }}
                                                                          type={
                                                                            factorKey ===
                                                                              'description' ||
                                                                            factorKey ===
                                                                              'question'
                                                                              ? 'text'
                                                                              : 'number'
                                                                          }
                                                                        />
                                                                      </Box>
                                                                    </Box>
                                                                  ) : null;
                                                                },
                                                              )
                                                            : null}
                                                        </Box>
                                                      );
                                                    },
                                                  )}
                                                  <Box
                                                    display={'flex'}
                                                    alignItems={'center'}
                                                    gap={1}
                                                  >
                                                    <TextField
                                                      placeholder="Metric Name"
                                                      variant="outlined"
                                                      name={
                                                        'criteriaFactorName'
                                                      }
                                                      size="small"
                                                      sx={{
                                                        width: '100%',
                                                      }}
                                                      value={criteriaFactorName}
                                                      onChange={(e) =>
                                                        setCriteriaFactorName(
                                                          e.target.value,
                                                        )
                                                      }
                                                      type="text"
                                                    />
                                                    <Button
                                                      variant="contained"
                                                      size="small"
                                                      startIcon={<Add />}
                                                      disabled={
                                                        !criteriaFactorName?.trim()
                                                      }
                                                      onClick={() => {
                                                        setContentScoringConfig(
                                                          (prev) => {
                                                            return {
                                                              ...prev,
                                                              [callType]: {
                                                                ...prev[
                                                                  callType
                                                                ],
                                                                [configKey]: prev[
                                                                  callType
                                                                ][
                                                                  configKey
                                                                ]?.map(
                                                                  (ck, cki) =>
                                                                    cki ===
                                                                    index
                                                                      ? {
                                                                          [Object.keys(
                                                                            criteriaKey,
                                                                          )[0]]: [
                                                                            ...prev[
                                                                              callType
                                                                            ][
                                                                              configKey
                                                                            ][
                                                                              index
                                                                            ][
                                                                              Object.keys(
                                                                                criteriaKey,
                                                                              )[0]
                                                                            ],
                                                                            {
                                                                              [criteriaFactorName]: {
                                                                                description:
                                                                                  '',
                                                                                weight: 1,
                                                                                question:
                                                                                  '',
                                                                              },
                                                                            },
                                                                          ],
                                                                        }
                                                                      : ck,
                                                                ),
                                                              },
                                                            };
                                                          },
                                                        );
                                                        setCriteriaFactorName(
                                                          '',
                                                        );
                                                      }}
                                                      fullWidth
                                                    >
                                                      Add new metric
                                                    </Button>
                                                  </Box>
                                                </>
                                              ) : (
                                                <Box
                                                  display={'flex'}
                                                  alignItems={'center'}
                                                  gap={1}
                                                >
                                                  <TextField
                                                    placeholder="Metric Name"
                                                    variant="outlined"
                                                    name={'criteriaFactorName'}
                                                    size="small"
                                                    sx={{
                                                      width: '100%',
                                                    }}
                                                    value={criteriaFactorName}
                                                    onChange={(e) =>
                                                      setCriteriaFactorName(
                                                        e.target.value,
                                                      )
                                                    }
                                                    type="text"
                                                  />
                                                  <Button
                                                    variant="contained"
                                                    size="small"
                                                    startIcon={<Add />}
                                                    disabled={
                                                      !criteriaFactorName?.trim()
                                                    }
                                                    onClick={() => {
                                                      setContentScoringConfig(
                                                        (prev) => {
                                                          return {
                                                            ...prev,
                                                            [callType]: {
                                                              ...prev[callType],
                                                              [configKey]: prev[
                                                                callType
                                                              ][configKey]?.map(
                                                                (ck, cki) =>
                                                                  cki === index
                                                                    ? {
                                                                        [Object.keys(
                                                                          criteriaKey,
                                                                        )[0]]: [
                                                                          {
                                                                            [criteriaFactorName]: {
                                                                              description:
                                                                                '',
                                                                              weight: 1,
                                                                              question:
                                                                                '',
                                                                            },
                                                                          },
                                                                        ],
                                                                      }
                                                                    : ck,
                                                              ),
                                                            },
                                                          };
                                                        },
                                                      );
                                                      setCriteriaFactorName('');
                                                    }}
                                                    fullWidth
                                                  >
                                                    Add new metric
                                                  </Button>
                                                </Box>
                                              )
                                            ) : null}
                                          </Box>
                                        </Box>
                                      ))}
                                    </Box>
                                    <Box
                                      display={'flex'}
                                      alignItems={'center'}
                                      gap={1}
                                      p={2}
                                    >
                                      <TextField
                                        placeholder="Category Name"
                                        variant="outlined"
                                        name={'criteriaName'}
                                        size="small"
                                        sx={{
                                          width: '100%',
                                        }}
                                        value={criteriaName}
                                        onChange={(e) =>
                                          setCriteriaName(e.target.value)
                                        }
                                        type="text"
                                      />
                                      <Button
                                        variant="contained"
                                        size="small"
                                        startIcon={<Add />}
                                        disabled={!criteriaName?.trim()}
                                        onClick={() => {
                                          setContentScoringConfig((prev) => {
                                            return {
                                              ...prev,
                                              [callType]: {
                                                ...prev[callType],
                                                [configKey]: [
                                                  ...prev[callType][configKey],
                                                  {
                                                    [criteriaName]: [],
                                                  },
                                                ],
                                                categoryWeight: {
                                                  ...prev[callType][
                                                    'categoryWeight'
                                                  ],
                                                  [criteriaName]: 1,
                                                },
                                              },
                                            };
                                          });
                                          setCriteriaName('');
                                        }}
                                        fullWidth
                                      >
                                        Add new category
                                      </Button>
                                    </Box>
                                  </Box>
                                ) : (
                                  <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={1}
                                    p={2}
                                  >
                                    <TextField
                                      placeholder="Category Name"
                                      variant="outlined"
                                      name={'criteriaName'}
                                      size="small"
                                      sx={{
                                        width: '100%',
                                      }}
                                      value={criteriaName}
                                      onChange={(e) =>
                                        setCriteriaName(e.target.value)
                                      }
                                      type="text"
                                    />
                                    <Button
                                      variant="contained"
                                      size="small"
                                      startIcon={<Add />}
                                      disabled={!criteriaName?.trim()}
                                      onClick={() => {
                                        setContentScoringConfig((prev) => {
                                          return {
                                            ...prev,
                                            [callType]: {
                                              ...prev[callType],
                                              [configKey]: [
                                                ...prev[callType][configKey],
                                                {
                                                  [criteriaName]: [],
                                                },
                                              ],
                                              categoryWeight: {
                                                ...prev[callType][
                                                  'categoryWeight'
                                                ],
                                                [criteriaName]: 1,
                                              },
                                            },
                                          };
                                        });
                                        setCriteriaName('');
                                      }}
                                      fullWidth
                                    >
                                      Add new category
                                    </Button>
                                  </Box>
                                )
                              ) : null}
                            </Box>
                          </>
                        ) : (
                          <TextField
                            placeholder="JSON CONFIG"
                            variant="outlined"
                            name={'contentScoreConfig'}
                            fullWidth
                            size="small"
                            multiline
                            rows={17}
                            value={contentScoreConfigText[callType]}
                            onChange={(e) =>
                              setContentScoreConfigText((prev) => {
                                return {
                                  ...prev,
                                  [callType]: e.target.value,
                                };
                              })
                            }
                            type={'text'}
                          />
                        )}
                      </Box>
                    ) : null;
                  },
                )
              : null}
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-between'}
            sx={{
              padding: 1,
              borderTop: '1px solid #d3d3d3',
            }}
          >
            <Button
              variant="outlined"
              onClick={(e) => {
                setShowEditContentScoringConfig(false);
              }}
              color="primary"
              autoFocus
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={(e) => {
                setShowEditContentScoringConfig(false);
                if (configType === 'form') {
                  try {
                    setContentScoreConfigText((prev) => {
                      return {
                        ...prev,
                        outbound: JSON.stringify(
                          contentScoringConfig?.outbound || '{}',
                          null,
                          2,
                        ),
                        inbound: JSON.stringify(
                          contentScoringConfig?.inbound || '{}',
                          null,
                          2,
                        ),
                      };
                    });
                    setConfigType('form');
                  } catch (e) {
                    alert('Failed to convert json to text. please try again.');
                  }
                } else {
                  try {
                    const outboundObj = JSON.parse(
                      contentScoreConfigText?.outbound || '{}',
                    );
                    const inboundObj = JSON.parse(
                      contentScoreConfigText?.inbound || '{}',
                    );
                    setContentScoringConfig((prev) => {
                      return {
                        ...prev,
                        outbound: outboundObj,
                        inbound: inboundObj,
                      };
                    });
                    setConfigType('form');
                  } catch (e) {
                    alert(
                      'Failed to parse json text. please validate the json.',
                    );
                  }
                }
              }}
              color="primary"
              autoFocus
            >
              Done
            </Button>
          </Box>
        </Box>
      </Modal>
      <Drawer
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={Boolean(showAssignedBots)}
        anchor="right"
        onClose={(e, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // boxShadow: theme.shadows[5],
            outline: 'none',
            maxHeight: '100vh',
            maxWidth: '40vw',
            minWidth: '40vw',
            overflowY: 'auto',
            borderRadius: 1,
            position: 'relative',
          }}
        >
          <Box
            p={1}
            sx={{
              borderBottom: '1px solid #d3d3d3',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() => {
                setShowAssignedBots('');
              }}
            >
              <ChevronRight sx={{}} />
            </IconButton>
            <Typography color={'text.secondary'}>Assigned Bots</Typography>
          </Box>
          <Box
            sx={{
              minHeight: 'calc(100vh - 120px)',
              maxHeight: 'calc(100vh - 120px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                padding: 2,
              }}
            >
              {assignedBots?.map((bot) => (
                <Box
                  // flex={1}
                  key={bot?.id}
                  sx={{
                    padding: '8px 16px',
                    border: '1px solid #d3d3d3',
                    whiteSpace: 'nowrap',
                    position: 'relative',
                  }}
                >
                  <Typography
                    variant="body1"
                    color={'text.primary'}
                    fontWeight={'bold'}
                  >
                    {bot?.title}{' '}
                    <Chip
                      size="small"
                      label={
                        bot?.visibility === 'published_for_all'
                          ? 'Public'
                          : 'Private'
                      }
                    />
                  </Typography>
                  <Typography
                    variant="body1"
                    color={'text.secondary'}
                    // fontWeight={'bold'}
                  >
                    {bot?.description}
                  </Typography>
                  <Typography
                    variant="body1"
                    color={'text.secondary'}
                    // fontWeight={'bold'}
                  >
                    {bot?.botAudio}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Drawer>
      <Drawer
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={Boolean(showAddCreditsDialog)}
        anchor="right"
        onClose={(e, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // boxShadow: theme.shadows[5],
            outline: 'none',
            maxHeight: '100vh',
            maxWidth: '40vw',
            minWidth: '40vw',
            overflowY: 'auto',
            borderRadius: 1,
            position: 'relative',
          }}
        >
          <Box
            p={1}
            sx={{
              borderBottom: '1px solid #d3d3d3',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() => {
                setShowAddCreditsDialog('');
              }}
            >
              <ChevronRight sx={{}} />
            </IconButton>
            <Typography color={'text.secondary'}>Add Credits</Typography>
          </Box>
          <Box
            sx={{
              minHeight: 'calc(100vh - 120px)',
              maxHeight: 'calc(100vh - 120px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                padding: 2,
              }}
            >
              <TextField
                placeholder="Credits"
                variant="outlined"
                name={'Credits'}
                fullWidth
                size="small"
                type="number"
                value={credits}
                onChange={(e) => {
                  setCredits(e.target.value);
                }}
              />
              <Box display={'flex'} alignItems={'center'} gap={2}>
                <TextField
                  placeholder="CreditExpiryTimeValue"
                  variant="outlined"
                  name={'CreditExpiryTimeValue'}
                  fullWidth
                  size="small"
                  type="number"
                  value={creditExpiryTimeValue}
                  onChange={(e) => {
                    setCreditExpiryTimeValue(e.target.value);
                  }}
                />
                <FormControl sx={{ minWidth: 100 }}>
                  <InputLabel id="unit-select-label">Unit</InputLabel>
                  <Select
                    size="small"
                    labelId="unit-select-label"
                    id="unit-select"
                    name="creditExpiryTimeUnit"
                    MenuProps={{ disableScrollLock: true }}
                    onChange={(e) => setCreditsExpiryTimeUnit(e.target.value)}
                    value={creditExpiryTimeUnit}
                    input={<OutlinedInput label="Select Country" />}
                  >
                    <MenuItem key={0} value="milli_sec">
                      Millisecond
                    </MenuItem>
                    <MenuItem key={0} value="sec">
                      Second
                    </MenuItem>
                    <MenuItem key={0} value="min">
                      Minute
                    </MenuItem>
                    <MenuItem key={1} value="hour">
                      Hour
                    </MenuItem>
                    <MenuItem key={0} value="month">
                      Month
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <FormControl sx={{ minWidth: 100 }}>
                <InputLabel id="admin-select-label">Select Admin</InputLabel>
                <Select
                  size="small"
                  labelId="admin-select-label"
                  id="admin-select"
                  name="creditAdmin"
                  MenuProps={{ disableScrollLock: true }}
                  onChange={(e) => setCreditAdmin(e.target.value)}
                  value={creditAdmin}
                  input={<OutlinedInput label="Select Admin" />}
                >
                  <MenuItem key={0} value="deepak">
                    Deepak
                  </MenuItem>
                  <MenuItem key={0} value="gaurav">
                    Gaurav
                  </MenuItem>
                  <MenuItem key={0} value="shubham">
                    Shubham
                  </MenuItem>
                  <MenuItem key={1} value="vijay">
                    Vijay
                  </MenuItem>
                </Select>
              </FormControl>
              <TextField
                placeholder="Credit Description"
                variant="outlined"
                name={'creditDescription'}
                fullWidth
                multiline
                rows={4}
                size="small"
                type="number"
                value={purpose}
                onChange={(e) => {
                  setPurpose(e.target.value);
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(
                    addCreditsForOrg(
                      {
                        orgId: showAddCreditsDialog,
                        credits,
                        creditExpiryTimeUnit,
                        creditExpiryTimeValue,
                        adminName: creditAdmin,
                        purpose,
                      },
                      () => {
                        setShowAddCreditsDialog('');
                      },
                    ),
                  );
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
      <Dialog
        open={Boolean(showConfirmResetSubscriptionDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <DialogContentText id="alert-dialog-description" flex={1}>
              Are you sure you want to reset the subscritpion?
              <br />
              This will reset the subscription to the sampe plan with
              subscription starting from now.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowConfirmResetSubscriptionDialog(null);
              // if (testMode) setShowTestDeviceDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              dispatch(
                updatePlanForOrganization(
                  selectedOrganization,
                  selectedPlan,
                  () => {
                    alert('Information updated');
                    setShowConfirmResetSubscriptionDialog(null);
                  },
                ),
              );
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* <Dialog
        open={Boolean(showConfirmDeleteDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <DialogContentText id="alert-dialog-description" flex={1}>
              Are you sure you want to delete this conversation?
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowConfirmDeleteDialog(null);
              // if (testMode) setShowTestDeviceDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              dispatch(
                deleteConversation(showConfirmDeleteDialog, () => {
                  setConversations((prev) =>
                    prev?.filter((cs) => cs.id !== showConfirmDeleteDialog),
                  );
                  setShowConfirmDeleteDialog(null);
                }),
              );
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showPermissionDeniedError}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Camera and microphone are blocked
        </DialogTitle>
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <Box flex={1}>
              <img src="/camerahelp.png" width={'100%'} height={'100%'} />
            </Box>
            <DialogContentText id="alert-dialog-description" flex={1}>
              To record your video we need permission to use your camera and
              microphone. Click the <Lock /> Lock Icon (usually in your
              browser&apos;s address bar) to allow permissions and start
              recording.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowPermissionDeniedError(false);
              // if (testMode) setShowTestDeviceDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog> */}
    </Fixed>
  );
};

export default OrganizationsV2;
